// AUTO-GENERATED
//
// This code was automatically generated.
// It should not be modified by hand. Make changes to template files located at
// `generated/frontend-events`, then re-generate this file with `tracking-gen`.

type ResultType = [string, object]

/**
 * API Error
 * Occurred
 */
export enum ApiErrorOccurredSource {
  'Graphql' = 'graphql',
  'Clientapi' = 'clientapi',
  'Acorns-document-upload' = 'acorns-document-upload',
  'Plaid-layer' = 'plaid-layer',
}

export type TrackApiErrorOccurredType = {
  source: ApiErrorOccurredSource
  operationName: string
  errorCode: string
  errorDetails?: string
}

export const trackApiErrorOccurredPayload = ({
  source,
  operationName,
  errorCode,
  errorDetails,
}: TrackApiErrorOccurredType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'API Error',
    event_description: 'Occurred',
    platforms: 'web',
    object: 'Error',
    action: 'Received',
    object_name: 'clientNetworkError',
    source: source,
    operation_name: operationName,
    error_code: errorCode,
    error_details: errorDetails,
  }

  if (!errorDetails) {
    delete payload.error_details
  }

  return ['Error Received', payload]
}

/**
 * Error Alert
 * Container Viewed
 */
export type TrackErrorAlertContainerViewedType = {
  screen: string
  error: string
  errorCode?: string
  funnel?: string
  funnelVersion?: string
}

export const trackErrorAlertContainerViewedPayload = ({
  screen,
  error,
  errorCode,
  funnel,
  funnelVersion,
}: TrackErrorAlertContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Error Alert',
    event_description: 'Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'errorAlert',
    screen: screen,
    error: error,
    error_code: errorCode,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!errorCode) {
    delete payload.error_code
  }

  if (!funnel) {
    delete payload.funnel
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Container Viewed', payload]
}

/**
 * Assign Subaccount Plaid Link Error
 * Screen Viewed
 */
export enum AssignSubaccountPlaidLinkErrorScreenViewedContext {
  'Registration' = 'registration',
  'Settings' = 'settings',
}

export type TrackAssignSubaccountPlaidLinkErrorScreenViewedType = {
  errorDetails: string
  context: AssignSubaccountPlaidLinkErrorScreenViewedContext
}

export const trackAssignSubaccountPlaidLinkErrorScreenViewedPayload = ({
  errorDetails,
  context,
}: TrackAssignSubaccountPlaidLinkErrorScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Assign Subaccount Plaid Link Error',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'plaidLinkError',
    screen: 'plaidLinkError',
    error_details: errorDetails,
    context: context,
  }

  return ['Screen Viewed', payload]
}

/**
 * Assign Subaccount Plaid Link Error
 * Try Again Button Tapped
 */
export enum AssignSubaccountPlaidLinkErrorTryAgainButtonTappedContext {
  'Registration' = 'registration',
  'Settings' = 'settings',
}

export type TrackAssignSubaccountPlaidLinkErrorTryAgainButtonTappedType = {
  context: AssignSubaccountPlaidLinkErrorTryAgainButtonTappedContext
}

export const trackAssignSubaccountPlaidLinkErrorTryAgainButtonTappedPayload = ({
  context,
}: TrackAssignSubaccountPlaidLinkErrorTryAgainButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Assign Subaccount Plaid Link Error',
    event_description: 'Try Again Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'plaidLinkErrorTryAgain',
    screen: 'plaidLinkError',
    context: context,
  }

  return ['Button Tapped', payload]
}

/**
 * Assign Subaccount Plaid Link Error
 * Link a different account Button Tapped
 */
export enum AssignSubaccountPlaidLinkErrorLinkADifferentAccountButtonTappedContext {
  'Registration' = 'registration',
  'Settings' = 'settings',
}

export type TrackAssignSubaccountPlaidLinkErrorLinkADifferentAccountButtonTappedType = {
  context: AssignSubaccountPlaidLinkErrorLinkADifferentAccountButtonTappedContext
}

export const trackAssignSubaccountPlaidLinkErrorLinkADifferentAccountButtonTappedPayload = ({
  context,
}: TrackAssignSubaccountPlaidLinkErrorLinkADifferentAccountButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Assign Subaccount Plaid Link Error',
    event_description: 'Link a different account Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'plaidLinkErrorDifferentAccount',
    screen: 'plaidLinkError',
    context: context,
  }

  return ['Button Tapped', payload]
}

/**
 * Assign Subaccount Plaid Link Error
 * Next Button Tapped
 */
export enum AssignSubaccountPlaidLinkErrorNextButtonTappedContext {
  'Registration' = 'registration',
  'Settings' = 'settings',
}

export type TrackAssignSubaccountPlaidLinkErrorNextButtonTappedType = {
  context: AssignSubaccountPlaidLinkErrorNextButtonTappedContext
}

export const trackAssignSubaccountPlaidLinkErrorNextButtonTappedPayload = ({
  context,
}: TrackAssignSubaccountPlaidLinkErrorNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Assign Subaccount Plaid Link Error',
    event_description: 'Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'plaidLinkErrorRoutingAccountNumberNext',
    screen: 'plaidLinkError',
    context: context,
  }

  return ['Button Tapped', payload]
}

/**
 * Assign Subaccount Plaid Link Error
 * Use manual account Tapped
 */
export enum AssignSubaccountPlaidLinkErrorUseManualAccountTappedContext {
  'Registration' = 'registration',
  'Settings' = 'settings',
}

export type TrackAssignSubaccountPlaidLinkErrorUseManualAccountTappedType = {
  context: AssignSubaccountPlaidLinkErrorUseManualAccountTappedContext
}

export const trackAssignSubaccountPlaidLinkErrorUseManualAccountTappedPayload = ({
  context,
}: TrackAssignSubaccountPlaidLinkErrorUseManualAccountTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Assign Subaccount Plaid Link Error',
    event_description: 'Use manual account Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'plaidLinkErrorUseManual',
    screen: 'plaidLinkError',
    context: context,
  }

  return ['Button Tapped', payload]
}

/**
 * Spend Registration: Address
 * Address screen viewed
 */
export type TrackSpendRegistrationAddressAddressScreenViewedType = {
  currentSubscription: string
  addressType: string
  cardType: string
  context: string
}

export const trackSpendRegistrationAddressAddressScreenViewedPayload = ({
  currentSubscription,
  addressType,
  cardType,
  context,
}: TrackSpendRegistrationAddressAddressScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Spend Registration: Address',
    event_description: 'Address screen viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationSpendAddress',
    style: 'main',
    screen: 'registrationSpendAddress',
    current_subscription: currentSubscription,
    address_type: addressType,
    card_type: cardType,
    context: context,
  }

  return ['Screen Viewed', payload]
}

/**
 * Spend Registration: Address
 * Address confirm button tapped
 */
export type TrackSpendRegistrationAddressAddressConfirmButtonTappedType = {
  currentSubscription: string
  addressType: string
  addressSelection?: string
  cardType: string
  context: string
  ctaTitle: string
}

export const trackSpendRegistrationAddressAddressConfirmButtonTappedPayload = ({
  currentSubscription,
  addressType,
  addressSelection,
  cardType,
  context,
  ctaTitle,
}: TrackSpendRegistrationAddressAddressConfirmButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Spend Registration: Address',
    event_description: 'Address confirm button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationSpendAddressConfirm',
    style: 'default',
    screen: 'registrationSpendAddress',
    current_subscription: currentSubscription,
    address_type: addressType,
    address_selection: addressSelection,
    card_type: cardType,
    context: context,
    cta_title: ctaTitle,
  }

  if (!addressSelection) {
    delete payload.address_selection
  }

  return ['Button Tapped', payload]
}

/**
 * Spend Registration: Address
 * Address edit button tapped
 */
export type TrackSpendRegistrationAddressAddressEditButtonTappedType = {
  currentSubscription: string
  addressType: string
  cardType: string
  context: string
  ctaTitle: string
}

export const trackSpendRegistrationAddressAddressEditButtonTappedPayload = ({
  currentSubscription,
  addressType,
  cardType,
  context,
  ctaTitle,
}: TrackSpendRegistrationAddressAddressEditButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Spend Registration: Address',
    event_description: 'Address edit button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationSpendAddressEdit',
    style: 'text',
    screen: 'registrationSpendAddress',
    current_subscription: currentSubscription,
    address_type: addressType,
    card_type: cardType,
    context: context,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Bank Card Order: Edit Address Input
 * Screen Viewed
 */
export type TrackBankCardOrderEditAddressInputScreenViewedType = {
  addressType: string
  cardType: string
  context: string
}

export const trackBankCardOrderEditAddressInputScreenViewedPayload = ({
  addressType,
  cardType,
  context,
}: TrackBankCardOrderEditAddressInputScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Bank Card Order: Edit Address Input',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'bankCardOrderEditAddressInput',
    screen: 'bankCardOrderEditAddressInput',
    address_type: addressType,
    card_type: cardType,
    context: context,
  }

  return ['Screen Viewed', payload]
}

/**
 * Bank Card Order: Edit Address Input
 * CTA Tapped
 */
export type TrackBankCardOrderEditAddressInputCtaTappedType = {
  addressType: string
  cardType: string
  context: string
  ctaTitle?: string
}

export const trackBankCardOrderEditAddressInputCtaTappedPayload = ({
  addressType,
  cardType,
  context,
  ctaTitle,
}: TrackBankCardOrderEditAddressInputCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Bank Card Order: Edit Address Input',
    event_description: 'CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'bankCardOrderEditAddressInputCTA',
    screen: 'bankCardOrderEditAddressInput',
    address_type: addressType,
    card_type: cardType,
    context: context,
    cta_title: ctaTitle,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  return ['Button Tapped', payload]
}

/**
 * Bank Card Order: Suggested Address
 * Screen Viewed
 */
export type TrackBankCardOrderSuggestedAddressScreenViewedType = {
  addressType: string
  cardType: string
  context: string
}

export const trackBankCardOrderSuggestedAddressScreenViewedPayload = ({
  addressType,
  cardType,
  context,
}: TrackBankCardOrderSuggestedAddressScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Bank Card Order: Suggested Address',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'bankCardOrderSuggestedAddress',
    screen: 'bankCardOrderSuggestedAddress',
    address_type: addressType,
    card_type: cardType,
    context: context,
  }

  return ['Screen Viewed', payload]
}

/**
 * Bank Card Order: Suggested Address
 * CTA Tapped
 */
export type TrackBankCardOrderSuggestedAddressCtaTappedType = {
  addressType: string
  cardType: string
  context: string
  ctaTitle?: string
}

export const trackBankCardOrderSuggestedAddressCtaTappedPayload = ({
  addressType,
  cardType,
  context,
  ctaTitle,
}: TrackBankCardOrderSuggestedAddressCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Bank Card Order: Suggested Address',
    event_description: 'CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'bankCardOrderSuggestedAddressCTA',
    screen: 'bankCardOrderSuggestedAddress',
    address_type: addressType,
    card_type: cardType,
    context: context,
    cta_title: ctaTitle,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  return ['Button Tapped', payload]
}

/**
 * Bank Card Order: Suggested Address Edit Address
 * CTA Tapped
 */
export type TrackBankCardOrderSuggestedAddressEditAddressCtaTappedType = {
  addressType: string
  cardType: string
  context: string
  ctaTitle?: string
}

export const trackBankCardOrderSuggestedAddressEditAddressCtaTappedPayload = ({
  addressType,
  cardType,
  context,
  ctaTitle,
}: TrackBankCardOrderSuggestedAddressEditAddressCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Bank Card Order: Suggested Address Edit Address',
    event_description: 'CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'bankCardOrderSuggestedAddressEditAddress',
    screen: 'bankCardOrderSuggestedAddress',
    address_type: addressType,
    card_type: cardType,
    context: context,
    cta_title: ctaTitle,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  return ['Button Tapped', payload]
}

/**
 * Bank Card Order: Address Not Found
 * Screen Viewed
 */
export type TrackBankCardOrderAddressNotFoundScreenViewedType = {
  addressType: string
  cardType: string
  context: string
}

export const trackBankCardOrderAddressNotFoundScreenViewedPayload = ({
  addressType,
  cardType,
  context,
}: TrackBankCardOrderAddressNotFoundScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Bank Card Order: Address Not Found',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'bankCardOrderAddressNotFound',
    screen: 'bankCardOrderAddressNotFound',
    address_type: addressType,
    card_type: cardType,
    context: context,
  }

  return ['Screen Viewed', payload]
}

/**
 * Bank Card Order: Address Not Found
 * Primary CTA Tapped
 */
export type TrackBankCardOrderAddressNotFoundPrimaryCtaTappedType = {
  addressType: string
  cardType: string
  context: string
  ctaTitle?: string
}

export const trackBankCardOrderAddressNotFoundPrimaryCtaTappedPayload = ({
  addressType,
  cardType,
  context,
  ctaTitle,
}: TrackBankCardOrderAddressNotFoundPrimaryCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Bank Card Order: Address Not Found',
    event_description: 'Primary CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'bankCardOrderAddressNotFoundPrimaryCTA',
    screen: 'bankCardOrderAddressNotFound',
    address_type: addressType,
    card_type: cardType,
    context: context,
    cta_title: ctaTitle,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  return ['Button Tapped', payload]
}

/**
 * Bank Card Order: Address Not Found
 * Secondary CTA Tapped
 */
export type TrackBankCardOrderAddressNotFoundSecondaryCtaTappedType = {
  ctaTitle?: string
}

export const trackBankCardOrderAddressNotFoundSecondaryCtaTappedPayload = ({
  ctaTitle,
}: TrackBankCardOrderAddressNotFoundSecondaryCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Bank Card Order: Address Not Found',
    event_description: 'Secondary CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'bankCardOrderAddressNotFoundSecondaryCTA',
    screen: 'bankCardOrderAddressNotFound',
    cta_title: ctaTitle,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Lander Screen Viewed
 */
export type TrackBenefitsHubLanderScreenViewedType = {
  origin: string
  tier: string
}

export const trackBenefitsHubLanderScreenViewedPayload = ({
  origin,
  tier,
}: TrackBenefitsHubLanderScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Lander Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'benefitsLander',
    screen: 'benefitsLander',
    screen_name: 'benefitsLander',
    origin: origin,
    tier: tier,
  }

  return ['Screen Viewed', payload]
}

/**
 * Benefits Hub
 * Card Viewed
 */
export type TrackBenefitsHubCardViewedType = {
  tier: string
  type: string
}

export const trackBenefitsHubCardViewedPayload = ({
  tier,
  type,
}: TrackBenefitsHubCardViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Card Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'benefitsLanderCard',
    screen: 'benefitsLander',
    screen_name: 'benefitsLander',
    tier: tier,
    type: type,
  }

  return ['Container Viewed', payload]
}

/**
 * Benefits Hub
 * Card CTA Tapped
 */
export type TrackBenefitsHubCardCtaTappedType = {
  ctaTitle: string
  tier: string
  type: string
}

export const trackBenefitsHubCardCtaTappedPayload = ({
  ctaTitle,
  tier,
  type,
}: TrackBenefitsHubCardCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Card CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'benefitsCardNext',
    screen: 'benefitsLander',
    screen_name: 'benefitsLander',
    cta_title: ctaTitle,
    tier: tier,
    type: type,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Lander Close Button Tapped
 */
export type TrackBenefitsHubLanderCloseButtonTappedType = {
  tier: string
}

export const trackBenefitsHubLanderCloseButtonTappedPayload = ({
  tier,
}: TrackBenefitsHubLanderCloseButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Lander Close Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'benefitsLanderExit',
    screen: 'benefitsLander',
    screen_name: 'benefitsLander',
    tier: tier,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Life Insurance Lander Screen Viewed
 */
export type TrackBenefitsHubLifeInsuranceLanderScreenViewedType = {
  offer: string
  tier: string
}

export const trackBenefitsHubLifeInsuranceLanderScreenViewedPayload = ({
  offer,
  tier,
}: TrackBenefitsHubLifeInsuranceLanderScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Life Insurance Lander Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'lifeInsuranceLander',
    screen: 'lifeInsuranceLander',
    screen_name: 'lifeInsuranceLander',
    offer: offer,
    tier: tier,
  }

  return ['Screen Viewed', payload]
}

/**
 * Benefits Hub
 * Life Insurance Next Button Tapped
 */
export type TrackBenefitsHubLifeInsuranceNextButtonTappedType = {
  offer: string
  ctaTitle: string
  tier: string
}

export const trackBenefitsHubLifeInsuranceNextButtonTappedPayload = ({
  offer,
  ctaTitle,
  tier,
}: TrackBenefitsHubLifeInsuranceNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Life Insurance Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'lifeInsuranceCTA',
    screen: 'lifeInsuranceLander',
    screen_name: 'lifeInsuranceLander',
    offer: offer,
    cta_title: ctaTitle,
    tier: tier,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Life Insurance Back Button Tapped
 */
export type TrackBenefitsHubLifeInsuranceBackButtonTappedType = {
  offer: string
  tier: string
}

export const trackBenefitsHubLifeInsuranceBackButtonTappedPayload = ({
  offer,
  tier,
}: TrackBenefitsHubLifeInsuranceBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Life Insurance Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'lifeInsuranceBackToBenefit',
    screen: 'lifeInsuranceLander',
    screen_name: 'lifeInsuranceLander',
    offer: offer,
    tier: tier,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Life Insurance Tab Viewed
 */
export type TrackBenefitsHubLifeInsuranceTabViewedType = {
  tier: string
  type: string
}

export const trackBenefitsHubLifeInsuranceTabViewedPayload = ({
  tier,
  type,
}: TrackBenefitsHubLifeInsuranceTabViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Life Insurance Tab Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'lifeInsuranceTab',
    screen: 'lifeInsuranceLander',
    screen_name: 'lifeInsuranceLander',
    tier: tier,
    type: type,
  }

  return ['Container Viewed', payload]
}

/**
 * Benefits Hub
 * Life Insurance Tab Button tapped
 */
export enum BenefitsHubLifeInsuranceTabButtonTappedType {
  'LifeInsuranceDetails' = 'lifeInsuranceDetails',
  'LifeInsuranceFAQ' = 'lifeInsuranceFAQ',
  'LifeInsuranceDisclaimer' = 'lifeInsuranceDisclaimer',
}

export type TrackBenefitsHubLifeInsuranceTabButtonTappedType = {
  offer: string
  tier: string
  type: BenefitsHubLifeInsuranceTabButtonTappedType
}

export const trackBenefitsHubLifeInsuranceTabButtonTappedPayload = ({
  offer,
  tier,
  type,
}: TrackBenefitsHubLifeInsuranceTabButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Life Insurance Tab Button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'lifeInsuranceTabButton',
    screen: 'lifeInsuranceLander',
    offer: offer,
    tier: tier,
    type: type,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Complimentary Will Lander Screen Viewed
 */
export type TrackBenefitsHubComplimentaryWillLanderScreenViewedType = {
  offer: string
  tier: string
}

export const trackBenefitsHubComplimentaryWillLanderScreenViewedPayload = ({
  offer,
  tier,
}: TrackBenefitsHubComplimentaryWillLanderScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Complimentary Will Lander Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'benefitsWillLander',
    screen: 'benefitsWillLander',
    screen_name: 'benefitsWillLander',
    offer: offer,
    tier: tier,
  }

  return ['Screen Viewed', payload]
}

/**
 * Benefits Hub
 * Complimentary Will Next Button Tapped
 */
export type TrackBenefitsHubComplimentaryWillNextButtonTappedType = {
  offer: string
  ctaTitle: string
  tier: string
}

export const trackBenefitsHubComplimentaryWillNextButtonTappedPayload = ({
  offer,
  ctaTitle,
  tier,
}: TrackBenefitsHubComplimentaryWillNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Complimentary Will Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'benefitsWillCTA',
    screen: 'benefitsWillLander',
    screen_name: 'benefitsWillLander',
    offer: offer,
    cta_title: ctaTitle,
    tier: tier,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Complimentary Will Back Button Tapped
 */
export type TrackBenefitsHubComplimentaryWillBackButtonTappedType = {
  offer: string
  tier: string
}

export const trackBenefitsHubComplimentaryWillBackButtonTappedPayload = ({
  offer,
  tier,
}: TrackBenefitsHubComplimentaryWillBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Complimentary Will Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'benefitsWillBackToBenefit',
    screen: 'benefitsWillLander',
    screen_name: 'benefitsWillLander',
    offer: offer,
    tier: tier,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Complimentary Will Tab Button tapped
 */
export type TrackBenefitsHubComplimentaryWillTabButtonTappedType = {
  offer: string
  tier: string
  type: string
}

export const trackBenefitsHubComplimentaryWillTabButtonTappedPayload = ({
  offer,
  tier,
  type,
}: TrackBenefitsHubComplimentaryWillTabButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Complimentary Will Tab Button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'benefitsWillTabButton',
    screen: 'benefitsWillLander',
    screen_name: 'benefitsWillLander',
    offer: offer,
    tier: tier,
    type: type,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * GoHenry Lander Screen Viewed
 */
export type TrackBenefitsHubGoHenryLanderScreenViewedType = {
  offer: string
  origin: string
  tier: string
}

export const trackBenefitsHubGoHenryLanderScreenViewedPayload = ({
  offer,
  origin,
  tier,
}: TrackBenefitsHubGoHenryLanderScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'GoHenry Lander Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'goHenryLander',
    screen: 'goHenryLander',
    offer: offer,
    origin: origin,
    tier: tier,
  }

  return ['Screen Viewed', payload]
}

/**
 * Benefits Hub
 * GoHenry Next Button Tapped
 */
export type TrackBenefitsHubGoHenryNextButtonTappedType = {
  offer: string
  ctaTitle: string
  tier: string
}

export const trackBenefitsHubGoHenryNextButtonTappedPayload = ({
  offer,
  ctaTitle,
  tier,
}: TrackBenefitsHubGoHenryNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'GoHenry Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'goHenryCTA',
    screen: 'goHenryLander',
    offer: offer,
    cta_title: ctaTitle,
    tier: tier,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * GoHenry Secondary Button Tapped
 */
export type TrackBenefitsHubGoHenrySecondaryButtonTappedType = {
  offer: string
  ctaTitle: string
  tier: string
}

export const trackBenefitsHubGoHenrySecondaryButtonTappedPayload = ({
  offer,
  ctaTitle,
  tier,
}: TrackBenefitsHubGoHenrySecondaryButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'GoHenry Secondary Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'goHenrySecondaryCTA',
    screen: 'goHenryLander',
    offer: offer,
    cta_title: ctaTitle,
    tier: tier,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * GoHenry Back Button Tapped
 */
export type TrackBenefitsHubGoHenryBackButtonTappedType = {
  offer: string
  tier: string
}

export const trackBenefitsHubGoHenryBackButtonTappedPayload = ({
  offer,
  tier,
}: TrackBenefitsHubGoHenryBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'GoHenry Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'goHenryBackToBenefit',
    screen: 'goHenryLander',
    offer: offer,
    tier: tier,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * GoHenry Tab Button tapped
 */
export type TrackBenefitsHubGoHenryTabButtonTappedType = {
  offer: string
  tier: string
  type: string
}

export const trackBenefitsHubGoHenryTabButtonTappedPayload = ({
  offer,
  tier,
  type,
}: TrackBenefitsHubGoHenryTabButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'GoHenry Tab Button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'goHenryTabButton',
    screen: 'goHenryLander',
    offer: offer,
    tier: tier,
    type: type,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Lander Screen Viewed
 */
export type TrackBenefitsHubTaxFilingLanderScreenViewedType = {
  offer: string
  origin: string
  tier: string
  status: string
}

export const trackBenefitsHubTaxFilingLanderScreenViewedPayload = ({
  offer,
  origin,
  tier,
  status,
}: TrackBenefitsHubTaxFilingLanderScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Lander Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'taxFilingLander',
    screen: 'taxFilingLander',
    offer: offer,
    origin: origin,
    tier: tier,
    status: status,
  }

  return ['Screen Viewed', payload]
}

/**
 * Benefits Hub
 * Tax Filing Next Button Tapped
 */
export type TrackBenefitsHubTaxFilingNextButtonTappedType = {
  offer: string
  ctaTitle: string
  tier: string
}

export const trackBenefitsHubTaxFilingNextButtonTappedPayload = ({
  offer,
  ctaTitle,
  tier,
}: TrackBenefitsHubTaxFilingNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingCTA',
    screen: 'taxFilingLander',
    offer: offer,
    cta_title: ctaTitle,
    tier: tier,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Back Button Tapped
 */
export type TrackBenefitsHubTaxFilingBackButtonTappedType = {
  offer: string
  tier: string
}

export const trackBenefitsHubTaxFilingBackButtonTappedPayload = ({
  offer,
  tier,
}: TrackBenefitsHubTaxFilingBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingBackToBenefit',
    screen: 'taxFilingLander',
    offer: offer,
    tier: tier,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Tab Button tapped
 */
export enum BenefitsHubTaxFilingTabButtonTappedType {
  'TaxFilingWhatsIncluded' = 'taxFilingWhatsIncluded',
  'TaxFilingFaq' = 'taxFilingFaq',
  'TaxFilingExclusions' = 'taxFilingExclusions',
}

export type TrackBenefitsHubTaxFilingTabButtonTappedType = {
  offer: string
  tier: string
  type: BenefitsHubTaxFilingTabButtonTappedType
}

export const trackBenefitsHubTaxFilingTabButtonTappedPayload = ({
  offer,
  tier,
  type,
}: TrackBenefitsHubTaxFilingTabButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Tab Button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingTabButton',
    screen: 'taxFilingLander',
    offer: offer,
    tier: tier,
    type: type,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Get Started Screen Viewed
 */
export type TrackBenefitsHubTaxFilingGetStartedScreenViewedType = {
  offer: string
  tier: string
}

export const trackBenefitsHubTaxFilingGetStartedScreenViewedPayload = ({
  offer,
  tier,
}: TrackBenefitsHubTaxFilingGetStartedScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Get Started Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'taxFilingGetStarted',
    screen: 'taxFilingGetStarted',
    offer: offer,
    tier: tier,
  }

  return ['Screen Viewed', payload]
}

/**
 * Benefits Hub
 * Tax Filing Get Started Exclusions Button Tapped
 */
export type TrackBenefitsHubTaxFilingGetStartedExclusionsButtonTappedType = {
  offer: string
  tier: string
}

export const trackBenefitsHubTaxFilingGetStartedExclusionsButtonTappedPayload = ({
  offer,
  tier,
}: TrackBenefitsHubTaxFilingGetStartedExclusionsButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Get Started Exclusions Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingGetStartedExclusionsButton',
    screen: 'taxFilingGetStarted',
    offer: offer,
    tier: tier,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Get Started Exclusions Container Viewed
 */
export type TrackBenefitsHubTaxFilingGetStartedExclusionsContainerViewedType = {
  tier: string
}

export const trackBenefitsHubTaxFilingGetStartedExclusionsContainerViewedPayload = ({
  tier,
}: TrackBenefitsHubTaxFilingGetStartedExclusionsContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Get Started Exclusions Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'taxFilingGetStartedExclusions',
    screen: 'taxFilingGetStarted',
    tier: tier,
  }

  return ['Container Viewed', payload]
}

/**
 * Benefits Hub
 * Tax Filing Get Started Exclusions Close Button Tapped
 */
export type TrackBenefitsHubTaxFilingGetStartedExclusionsCloseButtonTappedType = {
  tier: string
}

export const trackBenefitsHubTaxFilingGetStartedExclusionsCloseButtonTappedPayload = ({
  tier,
}: TrackBenefitsHubTaxFilingGetStartedExclusionsCloseButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Get Started Exclusions Close Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingGetStartedExclusionsClose',
    screen: 'taxFilingGetStarted',
    tier: tier,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Get Started Close Back Arrow
 */
export type TrackBenefitsHubTaxFilingGetStartedCloseBackArrowType = {
  tier: string
}

export const trackBenefitsHubTaxFilingGetStartedCloseBackArrowPayload = ({
  tier,
}: TrackBenefitsHubTaxFilingGetStartedCloseBackArrowType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Get Started Close Back Arrow',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingGetStartedClose',
    screen: 'taxFilingGetStarted',
    tier: tier,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Get Started Next Button Tapped
 */
export type TrackBenefitsHubTaxFilingGetStartedNextButtonTappedType = {
  ctaTitle: string
  tier: string
}

export const trackBenefitsHubTaxFilingGetStartedNextButtonTappedPayload = ({
  ctaTitle,
  tier,
}: TrackBenefitsHubTaxFilingGetStartedNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Get Started Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingGetStartedCTA',
    screen: 'taxFilingGetStarted',
    cta_title: ctaTitle,
    tier: tier,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Not Qualify Card Container Viewed
 */
export type TrackBenefitsHubTaxFilingNotQualifyCardContainerViewedType = {
  screen: string
  tier: string
}

export const trackBenefitsHubTaxFilingNotQualifyCardContainerViewedPayload = ({
  screen,
  tier,
}: TrackBenefitsHubTaxFilingNotQualifyCardContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Not Qualify Card Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'taxFilingNotQualifyCard',
    screen: screen,
    tier: tier,
  }

  return ['Container Viewed', payload]
}

/**
 * Benefits Hub
 * Tax Filing Not Qualify Card Button Tapped
 */
export type TrackBenefitsHubTaxFilingNotQualifyCardButtonTappedType = {
  screen: string
  tier: string
}

export const trackBenefitsHubTaxFilingNotQualifyCardButtonTappedPayload = ({
  screen,
  tier,
}: TrackBenefitsHubTaxFilingNotQualifyCardButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Not Qualify Card Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingNotQualifyCard',
    screen: screen,
    tier: tier,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Shortcut Row Tapped
 */
export type TrackBenefitsHubTaxFilingShortcutRowTappedType = {
  ctaTitle: string
}

export const trackBenefitsHubTaxFilingShortcutRowTappedPayload = ({
  ctaTitle,
}: TrackBenefitsHubTaxFilingShortcutRowTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Shortcut Row Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingShortcutRow',
    screen: 'taxFilingLander',
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Contact Support Screen Viewed
 */
export type TrackBenefitsHubTaxFilingContactSupportScreenViewedType = {
  offer: string
}

export const trackBenefitsHubTaxFilingContactSupportScreenViewedPayload = ({
  offer,
}: TrackBenefitsHubTaxFilingContactSupportScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Contact Support Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'taxFilingContactSupport',
    screen: 'taxFilingContactSupport',
    offer: offer,
  }

  return ['Screen Viewed', payload]
}

/**
 * Benefits Hub
 * Tax Filing Contact Support Close Back Arrow
 */
export const trackBenefitsHubTaxFilingContactSupportCloseBackArrowPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Contact Support Close Back Arrow',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingContactSupportClose',
    screen: 'taxFilingContactSupport',
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Contact Support Email Button Tapped
 */
export const trackBenefitsHubTaxFilingContactSupportEmailButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Contact Support Email Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingContactSupportEmail',
    screen: 'taxFilingContactSupport',
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Contact Support Chat Button Tapped
 */
export const trackBenefitsHubTaxFilingContactSupportChatButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Contact Support Chat Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingContactSupportChat',
    screen: 'taxFilingContactSupport',
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Contact Support Acorns Help Button Tapped
 */
export const trackBenefitsHubTaxFilingContactSupportAcornsHelpButtonTappedPayload =
  (): ResultType => {
    const payload = {
      call_type: 'track',
      feature: 'Benefits Hub',
      event_description: 'Tax Filing Contact Support Acorns Help Button Tapped',
      platforms: 'web',
      object: 'Button',
      action: 'Tapped',
      object_name: 'taxFilingContactSupportAcornsHelp',
      screen: 'taxFilingContactSupport',
    }

    return ['Button Tapped', payload]
  }

/**
 * Benefits Hub
 * Life Insurance Contact Support Row Tapped
 */
export const trackBenefitsHubLifeInsuranceContactSupportRowTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Life Insurance Contact Support Row Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'lifeInsuranceContactSupportRow',
    screen: 'lifeInsuranceLander',
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Life Insurance Contact Support Screen Viewed
 */
export type TrackBenefitsHubLifeInsuranceContactSupportScreenViewedType = {
  status: string
  reason?: string
}

export const trackBenefitsHubLifeInsuranceContactSupportScreenViewedPayload = ({
  status,
  reason,
}: TrackBenefitsHubLifeInsuranceContactSupportScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Life Insurance Contact Support Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'lifeInsuranceContactSupport',
    screen: 'lifeInsuranceContactSupport',
    status: status,
    reason: reason,
  }

  if (!reason) {
    delete payload.reason
  }

  return ['Screen Viewed', payload]
}

/**
 * Benefits Hub
 * Life Insurance Contact Support Close Back Arrow
 */
export const trackBenefitsHubLifeInsuranceContactSupportCloseBackArrowPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Life Insurance Contact Support Close Back Arrow',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'lifeInsuranceContactSupportClose',
    screen: 'lifeInsuranceContactSupport',
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Life Insurance Contact Support Email Button Tapped
 */
export const trackBenefitsHubLifeInsuranceContactSupportEmailButtonTappedPayload =
  (): ResultType => {
    const payload = {
      call_type: 'track',
      feature: 'Benefits Hub',
      event_description: 'Life Insurance Contact Support Email Button Tapped',
      platforms: 'web',
      object: 'Button',
      action: 'Tapped',
      object_name: 'lifeInsuranceContactSupportEmail',
      screen: 'lifeInsuranceContactSupport',
    }

    return ['Button Tapped', payload]
  }

/**
 * Benefits Hub
 * Life Insurance Contact Support Phone Number Button Tapped
 */
export const trackBenefitsHubLifeInsuranceContactSupportPhoneNumberButtonTappedPayload =
  (): ResultType => {
    const payload = {
      call_type: 'track',
      feature: 'Benefits Hub',
      event_description: 'Life Insurance Contact Support Phone Number Button Tapped',
      platforms: 'web',
      object: 'Button',
      action: 'Tapped',
      object_name: 'lifeInsuranceContactSupportPhoneNumber',
      screen: 'lifeInsuranceContactSupport',
    }

    return ['Button Tapped', payload]
  }

/**
 * Benefits Hub
 * Life Insurance Contact Support Acorns Help Button Tapped
 */
export const trackBenefitsHubLifeInsuranceContactSupportAcornsHelpButtonTappedPayload =
  (): ResultType => {
    const payload = {
      call_type: 'track',
      feature: 'Benefits Hub',
      event_description: 'Life Insurance Contact Support Acorns Help Button Tapped',
      platforms: 'web',
      object: 'Button',
      action: 'Tapped',
      object_name: 'lifeInsuranceContactSupportAcornsHelp',
      screen: 'lifeInsuranceContactSupport',
    }

    return ['Button Tapped', payload]
  }

/**
 * Direct Bank Integration
 * Interstitial Screen Viewed
 */
export type TrackDirectBankIntegrationInterstitialScreenViewedType = {
  screen: string
  screenName: string
  context: string
}

export const trackDirectBankIntegrationInterstitialScreenViewedPayload = ({
  screen,
  screenName,
  context,
}: TrackDirectBankIntegrationInterstitialScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Direct Bank Integration',
    event_description: 'Interstitial Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'oAuthInterstitial',
    screen: screen,
    screen_name: screenName,
    context: context,
  }

  return ['Screen Viewed', payload]
}

/**
 * Direct Bank Integration
 * Interstitial Screen Next
 */
export type TrackDirectBankIntegrationInterstitialScreenNextType = {
  screen: string
  screenName: string
  ctaTitle?: string
  context: string
}

export const trackDirectBankIntegrationInterstitialScreenNextPayload = ({
  screen,
  screenName,
  ctaTitle,
  context,
}: TrackDirectBankIntegrationInterstitialScreenNextType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Direct Bank Integration',
    event_description: 'Interstitial Screen Next',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'oAuthInterstitialNextCTA',
    screen: screen,
    screen_name: screenName,
    cta_title: ctaTitle,
    context: context,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  return ['Button Tapped', payload]
}

/**
 * Direct Bank Integration
 * DBI Success Screen CTA
 */
export type TrackDirectBankIntegrationDbiSuccessScreenCtaType = {
  screen: string
  screenName: string
  ctaTitle?: string
  context: string
}

export const trackDirectBankIntegrationDbiSuccessScreenCtaPayload = ({
  screen,
  screenName,
  ctaTitle,
  context,
}: TrackDirectBankIntegrationDbiSuccessScreenCtaType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Direct Bank Integration',
    event_description: 'DBI Success Screen CTA',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'oAuthSuccessNextCTA',
    screen: screen,
    screen_name: screenName,
    cta_title: ctaTitle,
    context: context,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  return ['Button Tapped', payload]
}

/**
 * Found Money
 * Recent Activity Screen Viewed
 */
export type TrackFoundMoneyRecentActivityScreenViewedType = {
  currentTier: string
}

export const trackFoundMoneyRecentActivityScreenViewedPayload = ({
  currentTier,
}: TrackFoundMoneyRecentActivityScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Recent Activity Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'foundMoneyRecentActivity',
    screen: 'foundMoneyRecentActivity',
    current_tier: currentTier,
  }

  return ['Screen Viewed', payload]
}

/**
 * Found Money
 * Recent Activity Info Button Tapped
 */
export enum FoundMoneyRecentActivityInfoButtonTappedStatus {
  'Pending' = 'pending',
  'Fulfilled' = 'fulfilled',
}

export type TrackFoundMoneyRecentActivityInfoButtonTappedType = {
  status: FoundMoneyRecentActivityInfoButtonTappedStatus
}

export const trackFoundMoneyRecentActivityInfoButtonTappedPayload = ({
  status,
}: TrackFoundMoneyRecentActivityInfoButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Recent Activity Info Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'foundMoneyRecentActivityInfoCTA',
    screen: 'foundMoneyRecentActivity',
    status: status,
  }

  return ['Button Tapped', payload]
}

/**
 * Found Money
 * Recent Activity Info Drawer Viewed
 */
export enum FoundMoneyRecentActivityInfoDrawerViewedStatus {
  'Pending' = 'pending',
  'Fulfilled' = 'fulfilled',
}

export type TrackFoundMoneyRecentActivityInfoDrawerViewedType = {
  status: FoundMoneyRecentActivityInfoDrawerViewedStatus
}

export const trackFoundMoneyRecentActivityInfoDrawerViewedPayload = ({
  status,
}: TrackFoundMoneyRecentActivityInfoDrawerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Recent Activity Info Drawer Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'foundMoneyRecentActivityInfoDrawer',
    screen: 'foundMoneyRecentActivity',
    status: status,
  }

  return ['Container Viewed', payload]
}

/**
 * Found Money
 * Recent Activity Info Drawer CTA Tapped
 */
export enum FoundMoneyRecentActivityInfoDrawerCtaTappedStatus {
  'Pending' = 'pending',
  'Fulfilled' = 'fulfilled',
}

export type TrackFoundMoneyRecentActivityInfoDrawerCtaTappedType = {
  status: FoundMoneyRecentActivityInfoDrawerCtaTappedStatus
  destination: string
  ctaTitle: string
}

export const trackFoundMoneyRecentActivityInfoDrawerCtaTappedPayload = ({
  status,
  destination,
  ctaTitle,
}: TrackFoundMoneyRecentActivityInfoDrawerCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Recent Activity Info Drawer CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'foundMoneyRecentActivityInfoDrawerCTA',
    screen: 'foundMoneyRecentActivity',
    status: status,
    destination: destination,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Found Money
 * Recent Activity Reward Match Info Button Tapped
 */
export type TrackFoundMoneyRecentActivityRewardMatchInfoButtonTappedType = {
  currentTier: string
}

export const trackFoundMoneyRecentActivityRewardMatchInfoButtonTappedPayload = ({
  currentTier,
}: TrackFoundMoneyRecentActivityRewardMatchInfoButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Recent Activity Reward Match Info Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'foundMoneyRecentActivityRewardMatchCTA',
    screen: 'foundMoneyRecentActivity',
    current_tier: currentTier,
  }

  return ['Button Tapped', payload]
}

/**
 * Found Money
 * Recent Activity Reward Match Drawer Viewed
 */
export type TrackFoundMoneyRecentActivityRewardMatchDrawerViewedType = {
  currentTier: string
}

export const trackFoundMoneyRecentActivityRewardMatchDrawerViewedPayload = ({
  currentTier,
}: TrackFoundMoneyRecentActivityRewardMatchDrawerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Recent Activity Reward Match Drawer Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'foundMoneyRecentActivityRewardMatchDrawer',
    screen: 'foundMoneyRecentActivity',
    current_tier: currentTier,
  }

  return ['Container Viewed', payload]
}

/**
 * Found Money
 * Recent Activity Upgrade Card Viewed
 */
export type TrackFoundMoneyRecentActivityUpgradeCardViewedType = {
  currentTier: string
  newTier: string
}

export const trackFoundMoneyRecentActivityUpgradeCardViewedPayload = ({
  currentTier,
  newTier,
}: TrackFoundMoneyRecentActivityUpgradeCardViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Recent Activity Upgrade Card Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'foundMoneyRecentActivityUpgradeCard',
    screen: 'foundMoneyRecentActivity',
    current_tier: currentTier,
    new_tier: newTier,
  }

  return ['Container Viewed', payload]
}

/**
 * Found Money
 * Recent Activity Upgrade Card Tapped
 */
export type TrackFoundMoneyRecentActivityUpgradeCardTappedType = {
  currentTier: string
  newTier: string
}

export const trackFoundMoneyRecentActivityUpgradeCardTappedPayload = ({
  currentTier,
  newTier,
}: TrackFoundMoneyRecentActivityUpgradeCardTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Recent Activity Upgrade Card Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'foundMoneyRecentActivityUpgradeCard',
    screen: 'foundMoneyRecentActivity',
    current_tier: currentTier,
    new_tier: newTier,
  }

  return ['Button Tapped', payload]
}

/**
 * Found Money
 * Recent Activity Upgrade CTA Tapped
 */
export type TrackFoundMoneyRecentActivityUpgradeCtaTappedType = {
  currentTier: string
  newTier: string
}

export const trackFoundMoneyRecentActivityUpgradeCtaTappedPayload = ({
  currentTier,
  newTier,
}: TrackFoundMoneyRecentActivityUpgradeCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Recent Activity Upgrade CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'foundMoneyRecentActivityUpgradeCTA',
    screen: 'foundMoneyRecentActivity',
    current_tier: currentTier,
    new_tier: newTier,
  }

  return ['Button Tapped', payload]
}

/**
 * Found Money
 * Recent Activity Help Button Tapped
 */
export const trackFoundMoneyRecentActivityHelpButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Recent Activity Help Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'foundMoneyRecentActivityHelpCTA',
    screen: 'foundMoneyRecentActivity',
  }

  return ['Button Tapped', payload]
}

/**
 * Found Money
 * Recent Activity Help Action Tapped
 */
export enum FoundMoneyRecentActivityHelpActionTappedType {
  'Help_center' = 'help_center',
  'Missing_credit_form' = 'missing_credit_form',
}

export type TrackFoundMoneyRecentActivityHelpActionTappedType = {
  ctaTitle: string
  type: FoundMoneyRecentActivityHelpActionTappedType
}

export const trackFoundMoneyRecentActivityHelpActionTappedPayload = ({
  ctaTitle,
  type,
}: TrackFoundMoneyRecentActivityHelpActionTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Recent Activity Help Action Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'foundMoneyRecentActivityHelpAction',
    screen: 'foundMoneyRecentActivity',
    cta_title: ctaTitle,
    type: type,
  }

  return ['Button Tapped', payload]
}

/**
 * Found Money
 * Recent Activity Reward Tapped
 */
export enum FoundMoneyRecentActivityRewardTappedStatus {
  'Pending' = 'pending',
  'Fulfilled' = 'fulfilled',
}

export type TrackFoundMoneyRecentActivityRewardTappedType = {
  status: FoundMoneyRecentActivityRewardTappedStatus
}

export const trackFoundMoneyRecentActivityRewardTappedPayload = ({
  status,
}: TrackFoundMoneyRecentActivityRewardTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Recent Activity Reward Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'foundMoneyRecentActivityReward',
    screen: 'foundMoneyRecentActivity',
    status: status,
  }

  return ['Button Tapped', payload]
}

/**
 * Optimizely
 * Experiment Viewed
 */
export type TrackOptimizelyExperimentViewedType = {
  experimentId: string
  experimentName: string
  variationId: string
  variationName: string
}

export const trackOptimizelyExperimentViewedPayload = ({
  experimentId,
  experimentName,
  variationId,
  variationName,
}: TrackOptimizelyExperimentViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Optimizely',
    event_description: 'Experiment Viewed',
    platforms: 'web',
    object: 'Experiment',
    action: 'Viewed',
    object_name: 'optimizelyExperiment',
    experimentId: experimentId,
    experimentName: experimentName,
    variationId: variationId,
    variationName: variationName,
  }

  return ['Experiment Viewed', payload]
}

/**
 * Amplitude
 * Exposure
 */
export type TrackAmplitudeExposureType = {
  flagKey: string
  variant: string
  experimentKey: string
}

export const trackAmplitudeExposurePayload = ({
  flagKey,
  variant,
  experimentKey,
}: TrackAmplitudeExposureType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Amplitude',
    event_description: 'Exposure',
    platforms: 'web',
    object: '$exposure',
    action: '',
    object_name: 'amplitudeExperiment',
    flag_key: flagKey,
    variant: variant,
    experiment_key: experimentKey,
  }

  return ['$exposure ', payload]
}

/**
 * Found Money
 * Recent Activity Button Tapped
 */
export const trackFoundMoneyRecentActivityButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Recent Activity Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'foundMoneyRecentActivity',
    screen: 'foundMoney',
  }

  return ['Button Tapped', payload]
}

/**
 * Found Money: Home
 * Carousel offer viewed
 */
export enum FoundMoneyHomeCarouselOfferViewedCategory {
  'Most_popular' = 'most_popular',
  'Most_money_back' = 'most_money_back',
}

export enum FoundMoneyHomeCarouselOfferViewedOrigin {
  'Categories' = 'categories',
  'Earn_recent_activity' = 'earn_recent_activity',
  'Found_money_carousel' = 'found_money_carousel',
  'Found_money_on_present' = 'found_money_on_present',
  'Found_money_search' = 'found_money_search',
  'Found_money_upgrade_carousel' = 'found_money_upgrade_carousel',
  'Inline_promotion' = 'inline_promotion',
  'Undefined' = 'undefined',
}

export type TrackFoundMoneyHomeCarouselOfferViewedType = {
  screen: string
  indexPosition: number
  indexCount: number
  ownerId?: string
  campaignId?: string
  offerId: string
  section: string
  modelUuid?: string
  currentTier?: string
  newTier?: string
  category?: FoundMoneyHomeCarouselOfferViewedCategory
  origin: FoundMoneyHomeCarouselOfferViewedOrigin
}

export const trackFoundMoneyHomeCarouselOfferViewedPayload = ({
  screen,
  indexPosition,
  indexCount,
  ownerId,
  campaignId,
  offerId,
  section,
  modelUuid,
  currentTier,
  newTier,
  category,
  origin,
}: TrackFoundMoneyHomeCarouselOfferViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money: Home',
    event_description: 'Carousel offer viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'foundMoneyCampaignCarousel',
    screen: screen,
    index_position: indexPosition,
    index_count: indexCount,
    owner_id: ownerId,
    campaign_id: campaignId,
    offer_id: offerId,
    section: section,
    model_uuid: modelUuid,
    current_tier: currentTier,
    new_tier: newTier,
    category: category,
    origin: origin,
  }

  if (!ownerId) {
    delete payload.owner_id
  }

  if (!campaignId) {
    delete payload.campaign_id
  }

  if (!modelUuid) {
    delete payload.model_uuid
  }

  if (!currentTier) {
    delete payload.current_tier
  }

  if (!newTier) {
    delete payload.new_tier
  }

  if (!category) {
    delete payload.category
  }

  return ['Container Viewed', payload]
}

/**
 * Found Money: Home
 * Carousel offer tapped
 */
export enum FoundMoneyHomeCarouselOfferTappedCategory {
  'Most_popular' = 'most_popular',
  'Most_money_back' = 'most_money_back',
}

export enum FoundMoneyHomeCarouselOfferTappedOrigin {
  'Banking_hub_carousel' = 'banking_hub_carousel',
  'Categories' = 'categories',
  'Earn_recent_activity' = 'earn_recent_activity',
  'Found_money_carousel' = 'found_money_carousel',
  'Found_money_on_present' = 'found_money_on_present',
  'Found_money_search' = 'found_money_search',
  'Found_money_upgrade_carousel' = 'found_money_upgrade_carousel',
  'Inline_promotion' = 'inline_promotion',
  'Undefined' = 'undefined',
}

export type TrackFoundMoneyHomeCarouselOfferTappedType = {
  screen: string
  indexPosition: number
  indexCount: number
  ownerId?: string
  campaignId?: string
  offerId: string
  section: string
  modelUuid?: string
  currentTier?: string
  newTier?: string
  category?: FoundMoneyHomeCarouselOfferTappedCategory
  origin: FoundMoneyHomeCarouselOfferTappedOrigin
}

export const trackFoundMoneyHomeCarouselOfferTappedPayload = ({
  screen,
  indexPosition,
  indexCount,
  ownerId,
  campaignId,
  offerId,
  section,
  modelUuid,
  currentTier,
  newTier,
  category,
  origin,
}: TrackFoundMoneyHomeCarouselOfferTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money: Home',
    event_description: 'Carousel offer tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'foundMoneyCampaignCarousel',
    screen: screen,
    index_position: indexPosition,
    index_count: indexCount,
    owner_id: ownerId,
    campaign_id: campaignId,
    offer_id: offerId,
    section: section,
    model_uuid: modelUuid,
    current_tier: currentTier,
    new_tier: newTier,
    category: category,
    origin: origin,
  }

  if (!ownerId) {
    delete payload.owner_id
  }

  if (!campaignId) {
    delete payload.campaign_id
  }

  if (!modelUuid) {
    delete payload.model_uuid
  }

  if (!currentTier) {
    delete payload.current_tier
  }

  if (!newTier) {
    delete payload.new_tier
  }

  if (!category) {
    delete payload.category
  }

  return ['Button Tapped', payload]
}

/**
 * Earn On Home
 * Amount Error State Viewed
 */
export const trackEarnOnHomeAmountErrorStateViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Earn On Home',
    event_description: 'Amount Error State Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'earnOnHomeAmountErrorState',
    screen: 'present',
    screen_name: 'present',
  }

  return ['Container Viewed', payload]
}

/**
 * Earn On Home
 * Carousel Error State Viewed
 */
export const trackEarnOnHomeCarouselErrorStateViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Earn On Home',
    event_description: 'Carousel Error State Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'earnOnHomeCarouselErrorState',
    screen: 'present',
    screen_name: 'present',
  }

  return ['Container Viewed', payload]
}

/**
 * Input Field
 * Editing Began
 */
export type TrackInputFieldEditingBeganType = {
  screen: string
  title?: string
  placeholder?: string
  fieldName: string
  required: string
}

export const trackInputFieldEditingBeganPayload = ({
  screen,
  title,
  placeholder,
  fieldName,
  required,
}: TrackInputFieldEditingBeganType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Input Field',
    event_description: 'Editing Began',
    platforms: 'web',
    object: 'Input',
    action: 'Changed',
    object_name: 'inputFieldEditingBegan',
    screen: screen,
    title: title,
    placeholder: placeholder,
    field_name: fieldName,
    required: required,
  }

  if (!title) {
    delete payload.title
  }

  if (!placeholder) {
    delete payload.placeholder
  }

  return ['Input Changed', payload]
}

/**
 * Input Field
 * Editing Ended
 */
export type TrackInputFieldEditingEndedType = {
  screen: string
  title?: string
  placeholder?: string
  fieldName: string
  required: string
  isValid: string
  validationHint?: string
}

export const trackInputFieldEditingEndedPayload = ({
  screen,
  title,
  placeholder,
  fieldName,
  required,
  isValid,
  validationHint,
}: TrackInputFieldEditingEndedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Input Field',
    event_description: 'Editing Ended',
    platforms: 'web',
    object: 'Input',
    action: 'Changed',
    object_name: 'inputFieldEditingEnded',
    screen: screen,
    title: title,
    placeholder: placeholder,
    field_name: fieldName,
    required: required,
    is_valid: isValid,
    validation_hint: validationHint,
  }

  if (!title) {
    delete payload.title
  }

  if (!placeholder) {
    delete payload.placeholder
  }

  if (!validationHint) {
    delete payload.validation_hint
  }

  return ['Input Changed', payload]
}

/**
 * Input Field
 * Value Changed
 */
export type TrackInputFieldValueChangedType = {
  screen: string
  title?: string
  placeholder?: string
  fieldName: string
  required: string
  isValid: string
  validationHint?: string
}

export const trackInputFieldValueChangedPayload = ({
  screen,
  title,
  placeholder,
  fieldName,
  required,
  isValid,
  validationHint,
}: TrackInputFieldValueChangedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Input Field',
    event_description: 'Value Changed',
    platforms: 'web',
    object: 'Input',
    action: 'Changed',
    object_name: 'inputFieldValueChanged',
    screen: screen,
    title: title,
    placeholder: placeholder,
    field_name: fieldName,
    required: required,
    is_valid: isValid,
    validation_hint: validationHint,
  }

  if (!title) {
    delete payload.title
  }

  if (!placeholder) {
    delete payload.placeholder
  }

  if (!validationHint) {
    delete payload.validation_hint
  }

  return ['Input Changed', payload]
}

/**
 * Invest Onboarding Round Ups Automatic Vs Manual
 * Screen Viewed
 */
export type TrackInvestOnboardingRoundUpsAutomaticVsManualScreenViewedType = {
  funnel?: string
  funnelVersion?: string
}

export const trackInvestOnboardingRoundUpsAutomaticVsManualScreenViewedPayload = ({
  funnel,
  funnelVersion,
}: TrackInvestOnboardingRoundUpsAutomaticVsManualScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Invest Onboarding Round Ups Automatic Vs Manual',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'investOnboardingRoundUpsAutomaticVsManual',
    screen: 'investOnboardingRoundUpsAutomaticVsManual',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnel) {
    delete payload.funnel
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Screen Viewed', payload]
}

/**
 * Invest Onboarding Round Ups Automatic Vs Manual
 * Skip Button Tapped
 */
export type TrackInvestOnboardingRoundUpsAutomaticVsManualSkipButtonTappedType = {
  funnel?: string
  funnelVersion?: string
  incentive?: string
}

export const trackInvestOnboardingRoundUpsAutomaticVsManualSkipButtonTappedPayload = ({
  funnel,
  funnelVersion,
  incentive,
}: TrackInvestOnboardingRoundUpsAutomaticVsManualSkipButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Invest Onboarding Round Ups Automatic Vs Manual',
    event_description: 'Skip Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'investOnboardingRoundUpsAutomaticVsManualSkip',
    screen: 'investOnboardingRoundUpsAutomaticVsManual',
    funnel: funnel,
    funnel_version: funnelVersion,
    incentive: incentive,
  }

  if (!funnel) {
    delete payload.funnel
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Button Tapped', payload]
}

/**
 * Invest Onboarding Round Ups Automatic Vs Manual
 * Back Button Tapped
 */
export type TrackInvestOnboardingRoundUpsAutomaticVsManualBackButtonTappedType = {
  funnel?: string
  funnelVersion?: string
}

export const trackInvestOnboardingRoundUpsAutomaticVsManualBackButtonTappedPayload = ({
  funnel,
  funnelVersion,
}: TrackInvestOnboardingRoundUpsAutomaticVsManualBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Invest Onboarding Round Ups Automatic Vs Manual',
    event_description: 'Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'investOnboardingRoundUpsAutomaticVsManualBack',
    screen: 'investOnboardingRoundUpsAutomaticVsManual',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnel) {
    delete payload.funnel
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Invest Onboarding Round Ups Automatic Vs Manual
 * Next Button Tapped
 */
export type TrackInvestOnboardingRoundUpsAutomaticVsManualNextButtonTappedType = {
  type: string
  ctaTitle?: string
  funnel?: string
  funnelVersion?: string
}

export const trackInvestOnboardingRoundUpsAutomaticVsManualNextButtonTappedPayload = ({
  type,
  ctaTitle,
  funnel,
  funnelVersion,
}: TrackInvestOnboardingRoundUpsAutomaticVsManualNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Invest Onboarding Round Ups Automatic Vs Manual',
    event_description: 'Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'investOnboardingRoundUpsAutomaticVsManualNext',
    screen: 'investOnboardingRoundUpsAutomaticVsManual',
    type: type,
    cta_title: ctaTitle,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  if (!funnel) {
    delete payload.funnel
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Invest Onboarding Round Up Accounts
 * Account Toggle Tapped
 */
export type TrackInvestOnboardingRoundUpAccountsAccountToggleTappedType = {
  type: string
  state: string
  funnelVersion?: string
  funnel: string
  account?: string
}

export const trackInvestOnboardingRoundUpAccountsAccountToggleTappedPayload = ({
  type,
  state,
  funnelVersion,
  funnel,
  account,
}: TrackInvestOnboardingRoundUpAccountsAccountToggleTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Invest Onboarding Round Up Accounts',
    event_description: 'Account Toggle Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'investOnboardingRoundUpAccountsToggle',
    screen: 'investOnboardingRoundUpAccounts',
    type: type,
    state: state,
    funnel_version: funnelVersion,
    funnel: funnel,
    account: account,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!account) {
    delete payload.account
  }

  return ['Button Tapped', payload]
}

/**
 * Later Onboarding Recommended IRA
 * Screen Viewed
 */
export enum LaterOnboardingRecommendedIraScreenViewedType {
  'Roth' = 'roth',
  'Sep' = 'sep',
  'Traditional' = 'traditional',
}

export type TrackLaterOnboardingRecommendedIraScreenViewedType = {
  type: LaterOnboardingRecommendedIraScreenViewedType
  funnel: string
}

export const trackLaterOnboardingRecommendedIraScreenViewedPayload = ({
  type,
  funnel,
}: TrackLaterOnboardingRecommendedIraScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Onboarding Recommended IRA',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'recommendedIRA',
    screen: 'recommendedIRA',
    type: type,
    funnel: funnel,
  }

  return ['Screen Viewed', payload]
}

/**
 * Later Onboarding Recommended IRA
 * Button Tapped
 */
export enum LaterOnboardingRecommendedIraButtonTappedType {
  'Roth' = 'roth',
  'Sep' = 'sep',
  'Traditional' = 'traditional',
}

export type TrackLaterOnboardingRecommendedIraButtonTappedType = {
  type: LaterOnboardingRecommendedIraButtonTappedType
  destination: string
  funnel: string
}

export const trackLaterOnboardingRecommendedIraButtonTappedPayload = ({
  type,
  destination,
  funnel,
}: TrackLaterOnboardingRecommendedIraButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Onboarding Recommended IRA',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'recommendedIRANext',
    screen: 'recommendedIRA',
    type: type,
    destination: destination,
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Later Onboarding Recommended IRA
 * Back Button Tapped
 */
export enum LaterOnboardingRecommendedIraBackButtonTappedType {
  'Roth' = 'roth',
  'Sep' = 'sep',
  'Traditional' = 'traditional',
}

export type TrackLaterOnboardingRecommendedIraBackButtonTappedType = {
  type: LaterOnboardingRecommendedIraBackButtonTappedType
  destination: string
  funnel: string
}

export const trackLaterOnboardingRecommendedIraBackButtonTappedPayload = ({
  type,
  destination,
  funnel,
}: TrackLaterOnboardingRecommendedIraBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Onboarding Recommended IRA',
    event_description: 'Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'recommendedIRABack',
    screen: 'recommendedIRA',
    type: type,
    destination: destination,
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Later Registration: Interstitial
 * Screen Viewed
 */
export type TrackLaterRegistrationInterstitialScreenViewedType = {
  funnel?: string
  funnelVersion?: string
}

export const trackLaterRegistrationInterstitialScreenViewedPayload = ({
  funnel,
  funnelVersion,
}: TrackLaterRegistrationInterstitialScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: Interstitial',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'laterRegistrationInterstitial',
    style: 'main',
    screen: 'laterRegistrationInterstitial',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnel) {
    delete payload.funnel
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Screen Viewed', payload]
}

/**
 * Later Registration: Welcome Screen
 * Button Tapped
 */
export type TrackLaterRegistrationWelcomeScreenButtonTappedType = {
  funnel?: string
  funnelVersion?: string
}

export const trackLaterRegistrationWelcomeScreenButtonTappedPayload = ({
  funnel,
  funnelVersion,
}: TrackLaterRegistrationWelcomeScreenButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: Welcome Screen',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'laterRegistrationInterstitialCTA',
    screen: 'laterRegistrationInterstitial',
    destination: 'laterRegistrationInvestorQuestions',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnel) {
    delete payload.funnel
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Later Registration: Welcome Screen Exit
 * Button Tapped
 */
export type TrackLaterRegistrationWelcomeScreenExitButtonTappedType = {
  destination: string
  funnel?: string
  funnelVersion?: string
}

export const trackLaterRegistrationWelcomeScreenExitButtonTappedPayload = ({
  destination,
  funnel,
  funnelVersion,
}: TrackLaterRegistrationWelcomeScreenExitButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: Welcome Screen Exit',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'laterRegistrationInterstitialExit',
    screen: 'laterRegistrationInterstitial',
    destination: destination,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnel) {
    delete payload.funnel
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Later Registration: Investor Questions
 * Screen Viewed
 */
export const trackLaterRegistrationInvestorQuestionsScreenViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: Investor Questions',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'laterRegistrationInvestorQuestions',
    style: 'main',
    screen: 'laterRegistrationInvestorQuestions',
  }

  return ['Screen Viewed', payload]
}

/**
 * Later Registration: Investor Questions
 * Question viewed
 */
export type TrackLaterRegistrationInvestorQuestionsQuestionViewedType = {
  containerName: string
  funnel: string
  origin: string
}

export const trackLaterRegistrationInvestorQuestionsQuestionViewedPayload = ({
  containerName,
  funnel,
  origin,
}: TrackLaterRegistrationInvestorQuestionsQuestionViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: Investor Questions',
    event_description: 'Question viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'laterRegistrationInvestorQuestions',
    style: 'main',
    screen: 'laterRegistrationInvestorQuestions',
    container_name: containerName,
    funnel: funnel,
    origin: origin,
  }

  return ['Container Viewed', payload]
}

/**
 * Later Registration: IRA Recommendation
 * Screen Viewed
 */
export const trackLaterRegistrationIraRecommendationScreenViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: IRA Recommendation',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'laterRegistrationIRARecommendation',
    style: 'main',
    screen: 'laterRegistrationIRARecommendation',
  }

  return ['Screen Viewed', payload]
}

/**
 * Later Registration: Recurring Investment
 * Screen Viewed
 */
export type TrackLaterRegistrationRecurringInvestmentScreenViewedType = {
  funnel: string
}

export const trackLaterRegistrationRecurringInvestmentScreenViewedPayload = ({
  funnel,
}: TrackLaterRegistrationRecurringInvestmentScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: Recurring Investment',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'laterRegistrationRecurringInvestment',
    style: 'main',
    screen: 'laterRegistrationRecurringInvestment',
    funnel: funnel,
  }

  return ['Screen Viewed', payload]
}

/**
 * Later Registration: Recurring Investment
 * Next Button Tapped
 */
export type TrackLaterRegistrationRecurringInvestmentNextButtonTappedType = {
  ctaTitle: string
  amount: string
  funnel: string
}

export const trackLaterRegistrationRecurringInvestmentNextButtonTappedPayload = ({
  ctaTitle,
  amount,
  funnel,
}: TrackLaterRegistrationRecurringInvestmentNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: Recurring Investment',
    event_description: 'Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'laterRegistrationRecurringInvestmentNext',
    style: 'main',
    screen: 'laterRegistrationRecurringInvestment',
    destination: 'laterRegistrationComplete',
    frequency: 'weekly',
    cta_title: ctaTitle,
    amount: amount,
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Later Registration: Recurring Investment
 * Skip Later Initial Recurring Investment
 */
export type TrackLaterRegistrationRecurringInvestmentSkipLaterInitialRecurringInvestmentType = {
  ctaTitle: string
  destination: string
  funnel: string
}

export const trackLaterRegistrationRecurringInvestmentSkipLaterInitialRecurringInvestmentPayload =
  ({
    ctaTitle,
    destination,
    funnel,
  }: TrackLaterRegistrationRecurringInvestmentSkipLaterInitialRecurringInvestmentType): ResultType => {
    const payload = {
      call_type: 'track',
      feature: 'Later Registration: Recurring Investment',
      event_description: 'Skip Later Initial Recurring Investment',
      platforms: 'web',
      object: 'Button',
      action: 'Tapped',
      object_name: 'laterRegistrationRecurringInvestmentSkip',
      screen: 'laterRegistrationRecurringInvestment',
      cta_title: ctaTitle,
      destination: destination,
      funnel: funnel,
    }

    return ['Button Tapped', payload]
  }

/**
 * Later Registration: One-Time Investment
 * Screen Viewed
 */
export type TrackLaterRegistrationOneTimeInvestmentScreenViewedType = {
  funnel: string
}

export const trackLaterRegistrationOneTimeInvestmentScreenViewedPayload = ({
  funnel,
}: TrackLaterRegistrationOneTimeInvestmentScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: One-Time Investment',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'laterRegistrationOneTimeInvestment',
    screen: 'laterRegistrationOneTimeInvestment',
    funnel: funnel,
  }

  return ['Screen Viewed', payload]
}

/**
 * Later Registration: One-Time Investment
 * Button Tapped Skip
 */
export type TrackLaterRegistrationOneTimeInvestmentButtonTappedSkipType = {
  ctaTitle: string
  destination: string
}

export const trackLaterRegistrationOneTimeInvestmentButtonTappedSkipPayload = ({
  ctaTitle,
  destination,
}: TrackLaterRegistrationOneTimeInvestmentButtonTappedSkipType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: One-Time Investment',
    event_description: 'Button Tapped Skip',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'laterRegistrationOneTimeInvestmentSkip',
    screen: 'laterRegistrationOneTimeInvestment',
    cta_title: ctaTitle,
    destination: destination,
  }

  return ['Button Tapped', payload]
}

/**
 * Later Registration: One-Time Investment Contribution
 * Button Tapped Next
 */
export type TrackLaterRegistrationOneTimeInvestmentContributionButtonTappedNextType = {
  ctaTitle: string
  amount: string
}

export const trackLaterRegistrationOneTimeInvestmentContributionButtonTappedNextPayload = ({
  ctaTitle,
  amount,
}: TrackLaterRegistrationOneTimeInvestmentContributionButtonTappedNextType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: One-Time Investment Contribution',
    event_description: 'Button Tapped Next',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'laterRegistrationOneTimeInvestmentNext',
    screen: 'laterRegistrationOneTimeInvestment',
    cta_title: ctaTitle,
    amount: amount,
  }

  return ['Button Tapped', payload]
}

/**
 * Later Registration: Complete
 * Screen Viewed
 */
export const trackLaterRegistrationCompleteScreenViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: Complete',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'laterRegistrationCongratulations',
    style: 'main',
    screen: 'laterRegistrationComplete',
    destination: 'later',
  }

  return ['Screen Viewed', payload]
}

/**
 * Later Registration: IRA Recommendation
 * Button Tapped
 */
export type TrackLaterRegistrationIraRecommendationButtonTappedType = {
  screen: string
  destination: string
  type: string
}

export const trackLaterRegistrationIraRecommendationButtonTappedPayload = ({
  screen,
  destination,
  type,
}: TrackLaterRegistrationIraRecommendationButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: IRA Recommendation',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'laterRegistrationInvestorQuestions',
    funnel: 'laterOnboarding',
    screen: screen,
    destination: destination,
    type: type,
  }

  return ['Button Tapped', payload]
}

/**
 * Later Registration: IRA Animation Screen
 * Screen Viewed
 */
export type TrackLaterRegistrationIraAnimationScreenScreenViewedType = {
  funnel: string
}

export const trackLaterRegistrationIraAnimationScreenScreenViewedPayload = ({
  funnel,
}: TrackLaterRegistrationIraAnimationScreenScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: IRA Animation Screen',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'laterRegistrationIRAInfoAnimation',
    style: 'main',
    screen: 'laterRegistrationIRAInfoAnimation',
    origin: 'laterRegistrationInvestorQuestions',
    funnel: funnel,
  }

  return ['Screen Viewed', payload]
}

/**
 * Later Registration: IRA Animation Screen
 * Button Tapped
 */
export const trackLaterRegistrationIraAnimationScreenButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: IRA Animation Screen',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'laterRegistrationIRAInfoAnimation',
    screen: 'laterRegistrationIRAInfoAnimation',
    destination: 'laterRegistrationIRARecommendation',
  }

  return ['Button Tapped', payload]
}

/**
 * Later Registration: Investment
 * Initial state modal viewed
 */
export type TrackLaterRegistrationInvestmentInitialStateModalViewedType = {
  screen: string
  defaultState: string
}

export const trackLaterRegistrationInvestmentInitialStateModalViewedPayload = ({
  screen,
  defaultState,
}: TrackLaterRegistrationInvestmentInitialStateModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: Investment',
    event_description: 'Initial state modal viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'laterRegistrationInvestmentInitialStateModal',
    style: 'modal',
    screen: screen,
    default_state: defaultState,
  }

  return ['Screen Viewed', payload]
}

/**
 * Later Registration: Investment
 * Tapped initial state modal cancel
 */
export type TrackLaterRegistrationInvestmentTappedInitialStateModalCancelType = {
  screen: string
  defaultState: string
}

export const trackLaterRegistrationInvestmentTappedInitialStateModalCancelPayload = ({
  screen,
  defaultState,
}: TrackLaterRegistrationInvestmentTappedInitialStateModalCancelType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: Investment',
    event_description: 'Tapped initial state modal cancel',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'laterRegistrationInvestmentInitialStateCancel',
    style: 'default',
    destination: 'laterRegistrationComplete',
    screen: screen,
    default_state: defaultState,
  }

  return ['Button Tapped', payload]
}

/**
 * Later Registration: Investment
 * Tapped initial state modal confirm
 */
export type TrackLaterRegistrationInvestmentTappedInitialStateModalConfirmType = {
  screen: string
  destination: string
  defaultState: string
}

export const trackLaterRegistrationInvestmentTappedInitialStateModalConfirmPayload = ({
  screen,
  destination,
  defaultState,
}: TrackLaterRegistrationInvestmentTappedInitialStateModalConfirmType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: Investment',
    event_description: 'Tapped initial state modal confirm',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'laterRegistrationInvestmentInitialStateConfirm',
    style: 'default',
    screen: screen,
    destination: destination,
    default_state: defaultState,
  }

  return ['Button Tapped', payload]
}

/**
 * Later Registration: US Territories Modal
 * US Territories Modal Viewed
 */
export const trackLaterRegistrationUsTerritoriesModalUsTerritoriesModalViewedPayload =
  (): ResultType => {
    const payload = {
      call_type: 'track',
      feature: 'Later Registration: US Territories Modal',
      event_description: 'US Territories Modal Viewed',
      platforms: 'web',
      object: 'Container',
      action: 'Viewed',
      object_name: 'laterRegistrationUnqualifiedModal',
      screen: 'laterRegistrationInterstitial',
    }

    return ['Container Viewed', payload]
  }

/**
 * Later Registration: US Territories Modal
 * Cancel Button Tapped
 */
export const trackLaterRegistrationUsTerritoriesModalCancelButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: US Territories Modal',
    event_description: 'Cancel Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'laterRegistrationUnqualifiedModalCancel',
    screen: 'laterRegistrationInterstitial',
  }

  return ['Button Tapped', payload]
}

/**
 * Later Registration: US Territories Modal
 * Confirm Button Tapped
 */
export const trackLaterRegistrationUsTerritoriesModalConfirmButtonTappedPayload =
  (): ResultType => {
    const payload = {
      call_type: 'track',
      feature: 'Later Registration: US Territories Modal',
      event_description: 'Confirm Button Tapped',
      platforms: 'web',
      object: 'Button',
      action: 'Tapped',
      object_name: 'laterRegistrationUnqualifiedModalConfirm',
      screen: 'laterRegistrationInterstitial',
    }

    return ['Button Tapped', payload]
  }

/**
 * Later Lander
 * Upgrade Drawer Viewed
 */
export const trackLaterLanderUpgradeDrawerViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Lander',
    event_description: 'Upgrade Drawer Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'laterLanderUpgradeDrawer',
    screen: 'laterRegistrationInterstitial',
  }

  return ['Container Viewed', payload]
}

/**
 * Later Lander
 * Upgrade Drawer CTA Clicked
 */
export type TrackLaterLanderUpgradeDrawerCtaClickedType = {
  ctaTitle: string
}

export const trackLaterLanderUpgradeDrawerCtaClickedPayload = ({
  ctaTitle,
}: TrackLaterLanderUpgradeDrawerCtaClickedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Lander',
    event_description: 'Upgrade Drawer CTA Clicked',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'laterLanderUpgradeDrawerCta',
    screen: 'laterRegistrationInterstitial',
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Later Lander
 * Upgrade Modal Cancel CTA Tapped
 */
export type TrackLaterLanderUpgradeModalCancelCtaTappedType = {
  ctaTitle: string
}

export const trackLaterLanderUpgradeModalCancelCtaTappedPayload = ({
  ctaTitle,
}: TrackLaterLanderUpgradeModalCancelCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Lander',
    event_description: 'Upgrade Modal Cancel CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'laterLanderUpgradeDrawerCancelCta',
    screen: 'laterRegistrationInterstitial',
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Later Lander
 * IRA Match Upgrade Card Clicked
 */
export const trackLaterLanderIraMatchUpgradeCardClickedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Lander',
    event_description: 'IRA Match Upgrade Card Clicked',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'laterMatchUpgradeCardCta',
    screen: 'laterRegistrationInterstitial',
  }

  return ['Button Tapped', payload]
}

/**
 * Later Registration: Media Player
 * Button Tapped
 */
export type TrackLaterRegistrationMediaPlayerButtonTappedType = {
  funnel?: string
}

export const trackLaterRegistrationMediaPlayerButtonTappedPayload = ({
  funnel,
}: TrackLaterRegistrationMediaPlayerButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: Media Player',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'laterOnboardingMediaPlayer',
    screen: 'laterRegistrationInterstitial',
    destination: 'mediaPlayer',
    funnel: funnel,
  }

  if (!funnel) {
    delete payload.funnel
  }

  return ['Button Tapped', payload]
}

/**
 * Later Registration: Learn More
 * Button Tapped
 */
export type TrackLaterRegistrationLearnMoreButtonTappedType = {
  funnel?: string
}

export const trackLaterRegistrationLearnMoreButtonTappedPayload = ({
  funnel,
}: TrackLaterRegistrationLearnMoreButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: Learn More',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'laterOnboardingLearnMore',
    screen: 'laterRegistrationInterstitial',
    destination: 'articlePage',
    funnel: funnel,
  }

  if (!funnel) {
    delete payload.funnel
  }

  return ['Button Tapped', payload]
}

/**
 * Later Registration: Compare IRAs
 * Button Tapped
 */
export type TrackLaterRegistrationCompareIrAsButtonTappedType = {
  funnel?: string
}

export const trackLaterRegistrationCompareIrAsButtonTappedPayload = ({
  funnel,
}: TrackLaterRegistrationCompareIrAsButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: Compare IRAs',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'laterOnboardingCompareIRAS',
    screen: 'laterRegistrationInterstitial',
    destination: 'articlePage',
    funnel: funnel,
  }

  if (!funnel) {
    delete payload.funnel
  }

  return ['Button Tapped', payload]
}

/**
 * Later Registration: Recurring Investment
 * Container Viewed
 */
export type TrackLaterRegistrationRecurringInvestmentContainerViewedType = {
  funnel: string
}

export const trackLaterRegistrationRecurringInvestmentContainerViewedPayload = ({
  funnel,
}: TrackLaterRegistrationRecurringInvestmentContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: Recurring Investment',
    event_description: 'Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'laterInitialInvestmentRecurringConfirmAmount',
    frequency: 'weekly',
    screen: 'laterRegistrationRecurringInvestment',
    funnel: funnel,
  }

  return ['Container Viewed', payload]
}

/**
 * Later Registration: Recurring Investment
 * Button Tapped Confirm
 */
export type TrackLaterRegistrationRecurringInvestmentButtonTappedConfirmType = {
  amount: string
  ctaTitle?: string
  funnel: string
}

export const trackLaterRegistrationRecurringInvestmentButtonTappedConfirmPayload = ({
  amount,
  ctaTitle,
  funnel,
}: TrackLaterRegistrationRecurringInvestmentButtonTappedConfirmType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: Recurring Investment',
    event_description: 'Button Tapped Confirm',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'laterInitialInvestmentRecurringConfirmAmountConfirm',
    frequency: 'weekly',
    screen: 'laterRegistrationRecurringInvestment',
    amount: amount,
    cta_title: ctaTitle,
    funnel: funnel,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  return ['Button Tapped', payload]
}

/**
 * Later Registration: Recurring Investment
 * Button Tapped Cancel
 */
export type TrackLaterRegistrationRecurringInvestmentButtonTappedCancelType = {
  amount: string
  ctaTitle?: string
  funnel: string
}

export const trackLaterRegistrationRecurringInvestmentButtonTappedCancelPayload = ({
  amount,
  ctaTitle,
  funnel,
}: TrackLaterRegistrationRecurringInvestmentButtonTappedCancelType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: Recurring Investment',
    event_description: 'Button Tapped Cancel',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'laterInitialInvestmentRecurringConfirmAmountCancel',
    frequency: 'weekly',
    screen: 'laterRegistrationRecurringInvestment',
    amount: amount,
    cta_title: ctaTitle,
    funnel: funnel,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  return ['Button Tapped', payload]
}

/**
 * Later Registration: One-Time Investment
 * Container Viewed
 */
export type TrackLaterRegistrationOneTimeInvestmentContainerViewedType = {
  funnel: string
}

export const trackLaterRegistrationOneTimeInvestmentContainerViewedPayload = ({
  funnel,
}: TrackLaterRegistrationOneTimeInvestmentContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: One-Time Investment',
    event_description: 'Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'laterInitialInvestmentOneTimeConfirmAmount',
    screen: 'laterRegistrationOneTimeInvestment',
    funnel: funnel,
  }

  return ['Container Viewed', payload]
}

/**
 * Later Registration: One-Time Investment
 * Button Tapped Confirm
 */
export type TrackLaterRegistrationOneTimeInvestmentButtonTappedConfirmType = {
  amount: string
  ctaTitle?: string
  funnel: string
}

export const trackLaterRegistrationOneTimeInvestmentButtonTappedConfirmPayload = ({
  amount,
  ctaTitle,
  funnel,
}: TrackLaterRegistrationOneTimeInvestmentButtonTappedConfirmType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: One-Time Investment',
    event_description: 'Button Tapped Confirm',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'laterInitialInvestmentOneTimeConfirmAmountConfirm',
    screen: 'laterRegistrationOneTimeInvestment',
    amount: amount,
    cta_title: ctaTitle,
    funnel: funnel,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  return ['Button Tapped', payload]
}

/**
 * Later Registration: One-Time Investment
 * Button Tapped Cancel
 */
export type TrackLaterRegistrationOneTimeInvestmentButtonTappedCancelType = {
  amount: string
  ctaTitle?: string
  funnel: string
}

export const trackLaterRegistrationOneTimeInvestmentButtonTappedCancelPayload = ({
  amount,
  ctaTitle,
  funnel,
}: TrackLaterRegistrationOneTimeInvestmentButtonTappedCancelType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: One-Time Investment',
    event_description: 'Button Tapped Cancel',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'laterInitialInvestmentOneTimeConfirmAmountCancel',
    screen: 'laterRegistrationOneTimeInvestment',
    amount: amount,
    cta_title: ctaTitle,
    funnel: funnel,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  return ['Button Tapped', payload]
}

/**
 * Later Registration: One-Time Investment Custom
 * Screen Viewed
 */
export type TrackLaterRegistrationOneTimeInvestmentCustomScreenViewedType = {
  funnel: string
}

export const trackLaterRegistrationOneTimeInvestmentCustomScreenViewedPayload = ({
  funnel,
}: TrackLaterRegistrationOneTimeInvestmentCustomScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: One-Time Investment Custom',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'laterInitialInvestmentOneTimeCustom',
    screen: 'laterInitialInvestmentOneTimeCustom',
    funnel: funnel,
  }

  return ['Screen Viewed', payload]
}

/**
 * Later Registration: One-Time Investment Custom
 * Button Tapped Next
 */
export type TrackLaterRegistrationOneTimeInvestmentCustomButtonTappedNextType = {
  amount: string
  ctaTitle?: string
  funnel: string
}

export const trackLaterRegistrationOneTimeInvestmentCustomButtonTappedNextPayload = ({
  amount,
  ctaTitle,
  funnel,
}: TrackLaterRegistrationOneTimeInvestmentCustomButtonTappedNextType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: One-Time Investment Custom',
    event_description: 'Button Tapped Next',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'laterInitialInvestmentOneTimeCustomNext',
    screen: 'laterInitialInvestmentOneTimeCustom',
    amount: amount,
    cta_title: ctaTitle,
    funnel: funnel,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  return ['Button Tapped', payload]
}

/**
 * Later Registration: One-Time Investment Custom
 * Button Tapped Back
 */
export type TrackLaterRegistrationOneTimeInvestmentCustomButtonTappedBackType = {
  ctaTitle?: string
  funnel: string
}

export const trackLaterRegistrationOneTimeInvestmentCustomButtonTappedBackPayload = ({
  ctaTitle,
  funnel,
}: TrackLaterRegistrationOneTimeInvestmentCustomButtonTappedBackType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: One-Time Investment Custom',
    event_description: 'Button Tapped Back',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'laterInitialInvestmentOneTimeCustomBack',
    screen: 'laterInitialInvestmentOneTimeCustom',
    cta_title: ctaTitle,
    funnel: funnel,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  return ['Button Tapped', payload]
}

/**
 * Later Registration: One-Time Investment Custom
 * Container Viewed
 */
export type TrackLaterRegistrationOneTimeInvestmentCustomContainerViewedType = {
  funnel: string
}

export const trackLaterRegistrationOneTimeInvestmentCustomContainerViewedPayload = ({
  funnel,
}: TrackLaterRegistrationOneTimeInvestmentCustomContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: One-Time Investment Custom',
    event_description: 'Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'laterInitialInvestmentOneTimeCustomConfirmAmount',
    screen: 'laterInitialInvestmentOneTimeCustom',
    funnel: funnel,
  }

  return ['Container Viewed', payload]
}

/**
 * Later Registration: One-Time Investment Custom
 * Button Tapped Confirm
 */
export type TrackLaterRegistrationOneTimeInvestmentCustomButtonTappedConfirmType = {
  amount: string
  ctaTitle?: string
  funnel: string
}

export const trackLaterRegistrationOneTimeInvestmentCustomButtonTappedConfirmPayload = ({
  amount,
  ctaTitle,
  funnel,
}: TrackLaterRegistrationOneTimeInvestmentCustomButtonTappedConfirmType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: One-Time Investment Custom',
    event_description: 'Button Tapped Confirm',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'laterInitialInvestmentOneTimeCustomConfirmAmountConfirm',
    screen: 'laterInitialInvestmentOneTimeCustom',
    amount: amount,
    cta_title: ctaTitle,
    funnel: funnel,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  return ['Button Tapped', payload]
}

/**
 * Later Registration: One-Time Investment Custom
 * Button Tapped Cancel
 */
export type TrackLaterRegistrationOneTimeInvestmentCustomButtonTappedCancelType = {
  amount: string
  ctaTitle?: string
  funnel: string
}

export const trackLaterRegistrationOneTimeInvestmentCustomButtonTappedCancelPayload = ({
  amount,
  ctaTitle,
  funnel,
}: TrackLaterRegistrationOneTimeInvestmentCustomButtonTappedCancelType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Later Registration: One-Time Investment Custom',
    event_description: 'Button Tapped Cancel',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'laterInitialInvestmentOneTimeCustomConfirmAmountCancel',
    screen: 'laterInitialInvestmentOneTimeCustom',
    amount: amount,
    cta_title: ctaTitle,
    funnel: funnel,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  return ['Button Tapped', payload]
}

/**
 * Loading Time
 * App Ready for User Interaction
 */
export type TrackLoadingTimeAppReadyForUserInteractionType = {
  deltaSeconds: string
  screen?: string
}

export const trackLoadingTimeAppReadyForUserInteractionPayload = ({
  deltaSeconds,
  screen,
}: TrackLoadingTimeAppReadyForUserInteractionType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Loading Time',
    event_description: 'App Ready for User Interaction',
    platforms: 'web',
    object: 'Time',
    action: 'Analysis',
    object_name: 'loadingTimeAppReady',
    delta_seconds: deltaSeconds,
    screen: screen,
  }

  if (!screen) {
    delete payload.screen
  }

  return ['Time Analysis', payload]
}

/**
 * Menu
 * Family Benefits Button Tapped
 */
export type TrackMenuFamilyBenefitsButtonTappedType = {
  ctaTitle: string
}

export const trackMenuFamilyBenefitsButtonTappedPayload = ({
  ctaTitle,
}: TrackMenuFamilyBenefitsButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Menu',
    event_description: 'Family Benefits Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'menuNavFamilyBenefitsCTA',
    screen: 'menu',
    screen_name: 'menu',
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Two Factor Auth
 * Enter Code Screen Viewed
 */
export type TrackTwoFactorAuthEnterCodeScreenViewedType = {
  origin: string
  type?: string
}

export const trackTwoFactorAuthEnterCodeScreenViewedPayload = ({
  origin,
  type,
}: TrackTwoFactorAuthEnterCodeScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Two Factor Auth',
    event_description: 'Enter Code Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'twoFactorAuthEnterCode',
    screen: 'twoFactorAuthEnterCode',
    screen_name: 'twoFactorAuthEnterCode',
    origin: origin,
    type: type,
  }

  if (!type) {
    delete payload.type
  }

  return ['Screen Viewed', payload]
}

/**
 * Two Factor Auth
 * Enter Code Confirm Button Tapped
 */
export type TrackTwoFactorAuthEnterCodeConfirmButtonTappedType = {
  destination: string
  ctaTitle?: string
  origin: string
}

export const trackTwoFactorAuthEnterCodeConfirmButtonTappedPayload = ({
  destination,
  ctaTitle,
  origin,
}: TrackTwoFactorAuthEnterCodeConfirmButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Two Factor Auth',
    event_description: 'Enter Code Confirm Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'twoFactorAuthEnterCode',
    screen: 'twoFactorAuthEnterCode',
    screen_name: 'twoFactorAuthEnterCode',
    destination: destination,
    cta_title: ctaTitle,
    origin: origin,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  return ['Button Tapped', payload]
}

/**
 * Two Factor Auth
 * Enter Code Help Modal Viewed
 */
export type TrackTwoFactorAuthEnterCodeHelpModalViewedType = {
  origin: string
}

export const trackTwoFactorAuthEnterCodeHelpModalViewedPayload = ({
  origin,
}: TrackTwoFactorAuthEnterCodeHelpModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Two Factor Auth',
    event_description: 'Enter Code Help Modal Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'twoFactorAuthHelp',
    screen: 'twoFactorAuthEnterCode',
    screen_name: 'twoFactorAuthEnterCode',
    origin: origin,
  }

  return ['Container Viewed', payload]
}

/**
 * Two Factor Auth
 * Resend Modal Viewed
 */
export type TrackTwoFactorAuthResendModalViewedType = {
  origin: string
}

export const trackTwoFactorAuthResendModalViewedPayload = ({
  origin,
}: TrackTwoFactorAuthResendModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Two Factor Auth',
    event_description: 'Resend Modal Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'twoFactorAuthResend',
    screen: 'twoFactorAuthEnterCode',
    screen_name: 'twoFactorAuthEnterCode',
    origin: origin,
  }

  return ['Container Viewed', payload]
}

/**
 * Two Factor Auth
 * Enter Code Resend Button Tapped
 */
export type TrackTwoFactorAuthEnterCodeResendButtonTappedType = {
  ctaTitle?: string
  origin: string
}

export const trackTwoFactorAuthEnterCodeResendButtonTappedPayload = ({
  ctaTitle,
  origin,
}: TrackTwoFactorAuthEnterCodeResendButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Two Factor Auth',
    event_description: 'Enter Code Resend Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'twoFactorAuthResend',
    screen: 'twoFactorAuthEnterCode',
    screen_name: 'twoFactorAuthEnterCode',
    cta_title: ctaTitle,
    origin: origin,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  return ['Button Tapped', payload]
}

/**
 * Two Factor Auth
 * Enter Code Help Button Tapped
 */
export type TrackTwoFactorAuthEnterCodeHelpButtonTappedType = {
  ctaTitle?: string
  origin: string
}

export const trackTwoFactorAuthEnterCodeHelpButtonTappedPayload = ({
  ctaTitle,
  origin,
}: TrackTwoFactorAuthEnterCodeHelpButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Two Factor Auth',
    event_description: 'Enter Code Help Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'twoFactorAuthHelp',
    screen: 'twoFactorAuthEnterCode',
    screen_name: 'twoFactorAuthEnterCode',
    cta_title: ctaTitle,
    origin: origin,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  return ['Button Tapped', payload]
}

/**
 * Two Factor Auth
 * Email Code Instead Button Tapped
 */
export type TrackTwoFactorAuthEmailCodeInsteadButtonTappedType = {
  origin: string
}

export const trackTwoFactorAuthEmailCodeInsteadButtonTappedPayload = ({
  origin,
}: TrackTwoFactorAuthEmailCodeInsteadButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Two Factor Auth',
    event_description: 'Email Code Instead Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'twoFactorAuthEmailCodeInstead',
    screen: 'twoFactorAuthEnterCode',
    screen_name: 'twoFactorAuthEnterCode',
    origin: origin,
  }

  return ['Button Tapped', payload]
}

/**
 * Two Factor Auth
 * Text Code Instead Button Tapped
 */
export type TrackTwoFactorAuthTextCodeInsteadButtonTappedType = {
  origin: string
}

export const trackTwoFactorAuthTextCodeInsteadButtonTappedPayload = ({
  origin,
}: TrackTwoFactorAuthTextCodeInsteadButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Two Factor Auth',
    event_description: 'Text Code Instead Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'twoFactorAuthTextCodeInstead',
    screen: 'twoFactorAuthEnterCode',
    screen_name: 'twoFactorAuthEnterCode',
    origin: origin,
  }

  return ['Button Tapped', payload]
}

/**
 * Product Upgrade Lander
 * Screen Viewed
 */
export type TrackProductUpgradeLanderScreenViewedType = {
  product: string
  currentTier: string
  newTier: string
}

export const trackProductUpgradeLanderScreenViewedPayload = ({
  product,
  currentTier,
  newTier,
}: TrackProductUpgradeLanderScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Product Upgrade Lander',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'productUpgradeLander',
    screen: 'productUpgradeLander',
    screen_name: 'productUpgradeLander',
    product: product,
    current_tier: currentTier,
    new_tier: newTier,
  }

  return ['Screen Viewed', payload]
}

/**
 * Product Upgrade Lander
 * Button Tapped
 */
export type TrackProductUpgradeLanderButtonTappedType = {
  product: string
  currentTier: string
  newTier: string
  ctaTitle?: string
}

export const trackProductUpgradeLanderButtonTappedPayload = ({
  product,
  currentTier,
  newTier,
  ctaTitle,
}: TrackProductUpgradeLanderButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Product Upgrade Lander',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'productUpgradeLanderCTA',
    screen: 'productUpgradeLander',
    screen_name: 'productUpgradeLander',
    product: product,
    current_tier: currentTier,
    new_tier: newTier,
    cta_title: ctaTitle,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  return ['Button Tapped', payload]
}

/**
 * Product Upgrade Lander
 * Compare Tiers Button Tapped
 */
export type TrackProductUpgradeLanderCompareTiersButtonTappedType = {
  product: string
  ctaTitle?: string
}

export const trackProductUpgradeLanderCompareTiersButtonTappedPayload = ({
  product,
  ctaTitle,
}: TrackProductUpgradeLanderCompareTiersButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Product Upgrade Lander',
    event_description: 'Compare Tiers Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'productUpgradeLanderCompareCTA',
    screen: 'productUpgradeLander',
    screen_name: 'productUpgradeLander',
    product: product,
    cta_title: ctaTitle,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  return ['Button Tapped', payload]
}

/**
 * Product Upgrade Lander
 * Close Button Tapped
 */
export type TrackProductUpgradeLanderCloseButtonTappedType = {
  product: string
}

export const trackProductUpgradeLanderCloseButtonTappedPayload = ({
  product,
}: TrackProductUpgradeLanderCloseButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Product Upgrade Lander',
    event_description: 'Close Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'productUpgradeLanderCloseCTA',
    screen: 'productUpgradeLander',
    screen_name: 'productUpgradeLander',
    product: product,
  }

  return ['Button Tapped', payload]
}

/**
 * Product Upgrade Lander
 * Agreement Drawer Viewed
 */
export type TrackProductUpgradeLanderAgreementDrawerViewedType = {
  screen: string
  product: string
  investmentProduct?: string
  drawerTitle: string
  currentTier: string
  newTier: string
}

export const trackProductUpgradeLanderAgreementDrawerViewedPayload = ({
  screen,
  product,
  investmentProduct,
  drawerTitle,
  currentTier,
  newTier,
}: TrackProductUpgradeLanderAgreementDrawerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Product Upgrade Lander',
    event_description: 'Agreement Drawer Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'productLanderAgreementDrawer',
    screen: screen,
    product: product,
    investment_product: investmentProduct,
    drawer_title: drawerTitle,
    current_tier: currentTier,
    new_tier: newTier,
  }

  if (!investmentProduct) {
    delete payload.investment_product
  }

  return ['Container Viewed', payload]
}

/**
 * Product Upgrade Lander
 * Agreement Drawer CTA Tapped
 */
export type TrackProductUpgradeLanderAgreementDrawerCtaTappedType = {
  screen: string
  product: string
  investmentProduct?: string
  ctaTitle: string
  currentTier: string
  newTier: string
}

export const trackProductUpgradeLanderAgreementDrawerCtaTappedPayload = ({
  screen,
  product,
  investmentProduct,
  ctaTitle,
  currentTier,
  newTier,
}: TrackProductUpgradeLanderAgreementDrawerCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Product Upgrade Lander',
    event_description: 'Agreement Drawer CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'productLanderAgreementDrawerCTA',
    screen: screen,
    product: product,
    investment_product: investmentProduct,
    cta_title: ctaTitle,
    current_tier: currentTier,
    new_tier: newTier,
  }

  if (!investmentProduct) {
    delete payload.investment_product
  }

  return ['Button Tapped', payload]
}

/**
 * Product Upgrade Lander
 * Agreement Drawer Cancel
 */
export type TrackProductUpgradeLanderAgreementDrawerCancelType = {
  screen: string
  product: string
  investmentProduct?: string
  currentTier: string
  newTier: string
}

export const trackProductUpgradeLanderAgreementDrawerCancelPayload = ({
  screen,
  product,
  investmentProduct,
  currentTier,
  newTier,
}: TrackProductUpgradeLanderAgreementDrawerCancelType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Product Upgrade Lander',
    event_description: 'Agreement Drawer Cancel',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'productLanderAgreementDrawerCancelled',
    screen: screen,
    product: product,
    investment_product: investmentProduct,
    current_tier: currentTier,
    new_tier: newTier,
  }

  if (!investmentProduct) {
    delete payload.investment_product
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Address Confirm: Residential
 * Screen Viewed
 */
export type TrackRegistrationAddressConfirmResidentialScreenViewedType = {
  funnel: string
}

export const trackRegistrationAddressConfirmResidentialScreenViewedPayload = ({
  funnel,
}: TrackRegistrationAddressConfirmResidentialScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Address Confirm: Residential',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationAddressConfirmation',
    screen: 'registrationAddressConfirmation',
    funnel: funnel,
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Address Confirm: Residential
 * Next Button Tapped
 */
export const trackRegistrationAddressConfirmResidentialNextButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Address Confirm: Residential',
    event_description: 'Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationAddressConfirmSuggested',
    screen: 'registrationAddressConfirmation',
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Address Confirm: Residential
 * Edit Button Tapped
 */
export const trackRegistrationAddressConfirmResidentialEditButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Address Confirm: Residential',
    event_description: 'Edit Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationAddressConfirmationEdit',
    screen: 'registrationAddressConfirmation',
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Address Confirm: Residential
 * Back Button Tapped
 */
export const trackRegistrationAddressConfirmResidentialBackButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Address Confirm: Residential',
    event_description: 'Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationAddressConfirmationBack',
    screen: 'registrationAddressConfirmation',
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Address Not Found: Residential
 * Screen Viewed
 */
export type TrackRegistrationAddressNotFoundResidentialScreenViewedType = {
  funnel: string
}

export const trackRegistrationAddressNotFoundResidentialScreenViewedPayload = ({
  funnel,
}: TrackRegistrationAddressNotFoundResidentialScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Address Not Found: Residential',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationAddressNotFound',
    screen: 'registrationAddressNotFound',
    funnel: funnel,
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Address Not Found: Residential
 * Edit Button Tapped
 */
export const trackRegistrationAddressNotFoundResidentialEditButtonTappedPayload =
  (): ResultType => {
    const payload = {
      call_type: 'track',
      feature: 'Registration Address Not Found: Residential',
      event_description: 'Edit Button Tapped',
      platforms: 'web',
      object: 'Button',
      action: 'Tapped',
      object_name: 'registrationAddressNotFoundEdit',
      screen: 'registrationAddressNotFound',
    }

    return ['Button Tapped', payload]
  }

/**
 * Registration Address Not Found: Residential
 * Back Button Tapped
 */
export const trackRegistrationAddressNotFoundResidentialBackButtonTappedPayload =
  (): ResultType => {
    const payload = {
      call_type: 'track',
      feature: 'Registration Address Not Found: Residential',
      event_description: 'Back Button Tapped',
      platforms: 'web',
      object: 'Button',
      action: 'Tapped',
      object_name: 'registrationAddressNotFoundBack',
      screen: 'registrationAddressNotFound',
    }

    return ['Button Tapped', payload]
  }

/**
 * Registration Choose Subscription
 * Screen Viewed
 */
export type TrackRegistrationChooseSubscriptionScreenViewedType = {
  type?: string
  tierKey: string
  tierPrice: string
  funnel: string
  funnelVersion?: string
  incentive?: string
}

export const trackRegistrationChooseSubscriptionScreenViewedPayload = ({
  type,
  tierKey,
  tierPrice,
  funnel,
  funnelVersion,
  incentive,
}: TrackRegistrationChooseSubscriptionScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Choose Subscription',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationChooseSubscription',
    style: 'main',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    type: type,
    tierKey: tierKey,
    tier_price: tierPrice,
    funnel: funnel,
    funnel_version: funnelVersion,
    incentive: incentive,
  }

  if (!type) {
    delete payload.type
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Choose Subscription
 * Choose subscription button tapped
 */
export type TrackRegistrationChooseSubscriptionChooseSubscriptionButtonTappedType = {
  type?: string
  tier: string
  funnel: string
  funnelVersion?: string
  ctaTitle: string
}

export const trackRegistrationChooseSubscriptionChooseSubscriptionButtonTappedPayload = ({
  type,
  tier,
  funnel,
  funnelVersion,
  ctaTitle,
}: TrackRegistrationChooseSubscriptionChooseSubscriptionButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Choose Subscription',
    event_description: 'Choose subscription button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationChooseSubscriptionCardCTA',
    style: 'text',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    destination: 'registrationCreateAccount',
    type: type,
    tier: tier,
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
  }

  if (!type) {
    delete payload.type
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Choose Subscription
 * Confirm Button Tapped
 */
export type TrackRegistrationChooseSubscriptionConfirmButtonTappedType = {
  type?: string
  destination: string
  tierKey: string
  tierPrice: string
  ctaTitle: string
  funnel: string
  funnelVersion?: string
  incentive?: string
}

export const trackRegistrationChooseSubscriptionConfirmButtonTappedPayload = ({
  type,
  destination,
  tierKey,
  tierPrice,
  ctaTitle,
  funnel,
  funnelVersion,
  incentive,
}: TrackRegistrationChooseSubscriptionConfirmButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Choose Subscription',
    event_description: 'Confirm Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationChooseSubscriptionConfirm',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    type: type,
    destination: destination,
    tierKey: tierKey,
    tier_price: tierPrice,
    cta_title: ctaTitle,
    funnel: funnel,
    funnel_version: funnelVersion,
    incentive: incentive,
  }

  if (!type) {
    delete payload.type
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Choose Subscription
 * Back Button Tapped
 */
export type TrackRegistrationChooseSubscriptionBackButtonTappedType = {
  type?: string
  tierKey: string
  tierPrice: string
  funnel: string
  funnelVersion?: string
  incentive?: string
}

export const trackRegistrationChooseSubscriptionBackButtonTappedPayload = ({
  type,
  tierKey,
  tierPrice,
  funnel,
  funnelVersion,
  incentive,
}: TrackRegistrationChooseSubscriptionBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Choose Subscription',
    event_description: 'Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationChooseSubscriptionBack',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    type: type,
    tierKey: tierKey,
    tier_price: tierPrice,
    funnel: funnel,
    funnel_version: funnelVersion,
    incentive: incentive,
  }

  if (!type) {
    delete payload.type
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Choose Subscription
 * Button Tapped
 */
export type TrackRegistrationChooseSubscriptionButtonTappedType = {
  type?: string
  tierKey: string
  tierPrice: string
  ctaTitle: string
  funnel: string
  funnelVersion?: string
  incentive?: string
}

export const trackRegistrationChooseSubscriptionButtonTappedPayload = ({
  type,
  tierKey,
  tierPrice,
  ctaTitle,
  funnel,
  funnelVersion,
  incentive,
}: TrackRegistrationChooseSubscriptionButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Choose Subscription',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationChooseSubscription',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    type: type,
    tierKey: tierKey,
    tier_price: tierPrice,
    cta_title: ctaTitle,
    funnel: funnel,
    funnel_version: funnelVersion,
    incentive: incentive,
  }

  if (!type) {
    delete payload.type
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Choose Subscription
 * Container Viewed
 */
export type TrackRegistrationChooseSubscriptionContainerViewedType = {
  type?: string
  tierKey: string
  tierPrice: string
  funnel: string
  funnelVersion?: string
  containerName: string
  indexPosition: number
  indexCount: number
  incentive?: string
}

export const trackRegistrationChooseSubscriptionContainerViewedPayload = ({
  type,
  tierKey,
  tierPrice,
  funnel,
  funnelVersion,
  containerName,
  indexPosition,
  indexCount,
  incentive,
}: TrackRegistrationChooseSubscriptionContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Choose Subscription',
    event_description: 'Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationChooseSubscription',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    type: type,
    tierKey: tierKey,
    tier_price: tierPrice,
    funnel: funnel,
    funnel_version: funnelVersion,
    container_name: containerName,
    index_position: indexPosition,
    index_count: indexCount,
    incentive: incentive,
  }

  if (!type) {
    delete payload.type
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Choose Subscription
 * Screen Swiped
 */
export type TrackRegistrationChooseSubscriptionScreenSwipedType = {
  tierKey: string
  tierPrice: string
  funnel: string
  funnelVersion?: string
  containerName: string
  indexPosition: number
  indexCount: number
}

export const trackRegistrationChooseSubscriptionScreenSwipedPayload = ({
  tierKey,
  tierPrice,
  funnel,
  funnelVersion,
  containerName,
  indexPosition,
  indexCount,
}: TrackRegistrationChooseSubscriptionScreenSwipedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Choose Subscription',
    event_description: 'Screen Swiped',
    platforms: 'web',
    object: 'Screen',
    action: 'Swiped',
    object_name: 'registrationChooseSubscriptionScroll',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    type: 'container_viewed',
    tierKey: tierKey,
    tier_price: tierPrice,
    funnel: funnel,
    funnel_version: funnelVersion,
    container_name: containerName,
    index_position: indexPosition,
    index_count: indexCount,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Screen Swiped', payload]
}

/**
 * Registration Choose Subscription
 * Compare Plans Screen Viewed
 */
export type TrackRegistrationChooseSubscriptionComparePlansScreenViewedType = {
  type?: string
  tierKey: string
  tierPrice: string
  funnel: string
  funnelVersion?: string
  incentive?: string
}

export const trackRegistrationChooseSubscriptionComparePlansScreenViewedPayload = ({
  type,
  tierKey,
  tierPrice,
  funnel,
  funnelVersion,
  incentive,
}: TrackRegistrationChooseSubscriptionComparePlansScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Choose Subscription',
    event_description: 'Compare Plans Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationChooseSubscriptionComparePlans',
    style: 'main',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    type: type,
    tierKey: tierKey,
    tier_price: tierPrice,
    funnel: funnel,
    funnel_version: funnelVersion,
    incentive: incentive,
  }

  if (!type) {
    delete payload.type
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Choose Subscription
 * Compare Plans Button Tapped
 */
export type TrackRegistrationChooseSubscriptionComparePlansButtonTappedType = {
  type?: string
  destination: string
  tierKey: string
  tierPrice: string
  ctaTitle: string
  funnel: string
  funnelVersion?: string
  incentive?: string
}

export const trackRegistrationChooseSubscriptionComparePlansButtonTappedPayload = ({
  type,
  destination,
  tierKey,
  tierPrice,
  ctaTitle,
  funnel,
  funnelVersion,
  incentive,
}: TrackRegistrationChooseSubscriptionComparePlansButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Choose Subscription',
    event_description: 'Compare Plans Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationChooseSubscriptionComparePlans',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    type: type,
    destination: destination,
    tierKey: tierKey,
    tier_price: tierPrice,
    cta_title: ctaTitle,
    funnel: funnel,
    funnel_version: funnelVersion,
    incentive: incentive,
  }

  if (!type) {
    delete payload.type
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Choose Subscription
 * Compare Plans Close Button Tapped
 */
export type TrackRegistrationChooseSubscriptionComparePlansCloseButtonTappedType = {
  type?: string
  destination: string
  tierKey: string
  tierPrice: string
  ctaTitle: string
  funnel: string
  funnelVersion?: string
  incentive?: string
}

export const trackRegistrationChooseSubscriptionComparePlansCloseButtonTappedPayload = ({
  type,
  destination,
  tierKey,
  tierPrice,
  ctaTitle,
  funnel,
  funnelVersion,
  incentive,
}: TrackRegistrationChooseSubscriptionComparePlansCloseButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Choose Subscription',
    event_description: 'Compare Plans Close Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationChooseSubscriptionComparePlansClose',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    type: type,
    destination: destination,
    tierKey: tierKey,
    tier_price: tierPrice,
    cta_title: ctaTitle,
    funnel: funnel,
    funnel_version: funnelVersion,
    incentive: incentive,
  }

  if (!type) {
    delete payload.type
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Choose Subscription
 * Expand Benefits Button Tapped
 */
export type TrackRegistrationChooseSubscriptionExpandBenefitsButtonTappedType = {
  type?: string
  destination: string
  tierKey: string
  tierPrice: string
  ctaTitle: string
  funnel: string
  funnelVersion?: string
  incentive?: string
}

export const trackRegistrationChooseSubscriptionExpandBenefitsButtonTappedPayload = ({
  type,
  destination,
  tierKey,
  tierPrice,
  ctaTitle,
  funnel,
  funnelVersion,
  incentive,
}: TrackRegistrationChooseSubscriptionExpandBenefitsButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Choose Subscription',
    event_description: 'Expand Benefits Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationChooseSubscriptionExpandBenefits',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    type: type,
    destination: destination,
    tierKey: tierKey,
    tier_price: tierPrice,
    cta_title: ctaTitle,
    funnel: funnel,
    funnel_version: funnelVersion,
    incentive: incentive,
  }

  if (!type) {
    delete payload.type
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Choose Subscription
 * Hide Benefits Button Tapped
 */
export type TrackRegistrationChooseSubscriptionHideBenefitsButtonTappedType = {
  type?: string
  destination: string
  tierKey: string
  tierPrice: string
  ctaTitle: string
  funnel: string
  funnelVersion?: string
  incentive?: string
}

export const trackRegistrationChooseSubscriptionHideBenefitsButtonTappedPayload = ({
  type,
  destination,
  tierKey,
  tierPrice,
  ctaTitle,
  funnel,
  funnelVersion,
  incentive,
}: TrackRegistrationChooseSubscriptionHideBenefitsButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Choose Subscription',
    event_description: 'Hide Benefits Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationChooseSubscriptionHideBenefits',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    type: type,
    destination: destination,
    tierKey: tierKey,
    tier_price: tierPrice,
    cta_title: ctaTitle,
    funnel: funnel,
    funnel_version: funnelVersion,
    incentive: incentive,
  }

  if (!type) {
    delete payload.type
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Information: Contact
 * Screen Viewed
 */
export type TrackRegistrationInformationContactScreenViewedType = {
  tier: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInformationContactScreenViewedPayload = ({
  tier,
  funnel,
  funnelVersion,
}: TrackRegistrationInformationContactScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Contact',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationInformationContact',
    style: 'main',
    screen: 'registrationInformationContact',
    screen_name: 'registrationInformationContact',
    tier: tier,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Information: Contact
 * Back button tapped
 */
export type TrackRegistrationInformationContactBackButtonTappedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInformationContactBackButtonTappedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationInformationContactBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Contact',
    event_description: 'Back button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInformationContactBack',
    style: 'icon',
    screen: 'registrationInformationContact',
    screen_name: 'registrationInformationContact',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration: Contextual Funnel Banner
 * Banner Viewed
 */
export type TrackRegistrationContextualFunnelBannerBannerViewedType = {
  screen: string
  campaignId: string
  funnelVersion?: string
}

export const trackRegistrationContextualFunnelBannerBannerViewedPayload = ({
  screen,
  campaignId,
  funnelVersion,
}: TrackRegistrationContextualFunnelBannerBannerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration: Contextual Funnel Banner',
    event_description: 'Banner Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'contextual_funnel_banner',
    screen: screen,
    campaign_id: campaignId,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Container Viewed', payload]
}

/**
 * Registration: Contextual Funnel Banner
 * Terms Tapped
 */
export type TrackRegistrationContextualFunnelBannerTermsTappedType = {
  screen: string
  campaignId: string
  funnelVersion?: string
}

export const trackRegistrationContextualFunnelBannerTermsTappedPayload = ({
  screen,
  campaignId,
  funnelVersion,
}: TrackRegistrationContextualFunnelBannerTermsTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration: Contextual Funnel Banner',
    event_description: 'Terms Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'contextual_funnel_terms',
    screen: screen,
    campaign_id: campaignId,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration: Contextual Funnel Banner
 * Banner Dismissed
 */
export type TrackRegistrationContextualFunnelBannerBannerDismissedType = {
  screen: string
  campaignId: string
  funnelVersion?: string
}

export const trackRegistrationContextualFunnelBannerBannerDismissedPayload = ({
  screen,
  campaignId,
  funnelVersion,
}: TrackRegistrationContextualFunnelBannerBannerDismissedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration: Contextual Funnel Banner',
    event_description: 'Banner Dismissed',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'contextual_funnel_dismiss',
    screen: screen,
    campaign_id: campaignId,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration: Contextual Funnel Banner
 * Drawer Viewed
 */
export type TrackRegistrationContextualFunnelBannerDrawerViewedType = {
  screen: string
  campaignId: string
  funnelVersion?: string
}

export const trackRegistrationContextualFunnelBannerDrawerViewedPayload = ({
  screen,
  campaignId,
  funnelVersion,
}: TrackRegistrationContextualFunnelBannerDrawerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration: Contextual Funnel Banner',
    event_description: 'Drawer Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'contextual_funnel_banner_drawer',
    screen: screen,
    campaign_id: campaignId,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Container Viewed', payload]
}

/**
 * Registration: Contextual Funnel Banner
 * Drawer Terms Tapped
 */
export type TrackRegistrationContextualFunnelBannerDrawerTermsTappedType = {
  screen: string
  campaignId: string
  funnelVersion?: string
}

export const trackRegistrationContextualFunnelBannerDrawerTermsTappedPayload = ({
  screen,
  campaignId,
  funnelVersion,
}: TrackRegistrationContextualFunnelBannerDrawerTermsTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration: Contextual Funnel Banner',
    event_description: 'Drawer Terms Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'contextual_funnel_banner_terms',
    screen: screen,
    campaign_id: campaignId,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration: Contextual Funnel Banner
 * Drawer Dismissed
 */
export type TrackRegistrationContextualFunnelBannerDrawerDismissedType = {
  screen: string
  campaignId: string
  funnelVersion?: string
}

export const trackRegistrationContextualFunnelBannerDrawerDismissedPayload = ({
  screen,
  campaignId,
  funnelVersion,
}: TrackRegistrationContextualFunnelBannerDrawerDismissedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration: Contextual Funnel Banner',
    event_description: 'Drawer Dismissed',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'contextual_funnel_banner_drawer_dismiss',
    screen: screen,
    campaign_id: campaignId,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration: Contextual Funnel Banner
 * Drawer Terms Viewed
 */
export type TrackRegistrationContextualFunnelBannerDrawerTermsViewedType = {
  screen: string
  campaignId: string
  funnelVersion?: string
}

export const trackRegistrationContextualFunnelBannerDrawerTermsViewedPayload = ({
  screen,
  campaignId,
  funnelVersion,
}: TrackRegistrationContextualFunnelBannerDrawerTermsViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration: Contextual Funnel Banner',
    event_description: 'Drawer Terms Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'contextual_funnel_terms',
    screen: screen,
    campaign_id: campaignId,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Create Account
 * Screen Viewed
 */
export type TrackRegistrationCreateAccountScreenViewedType = {
  funnel: string
  defaultState?: string
}

export const trackRegistrationCreateAccountScreenViewedPayload = ({
  funnel,
  defaultState,
}: TrackRegistrationCreateAccountScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Create Account',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationCreateAccount',
    screen: 'registrationCreateAccount',
    screen_name: 'registrationCreateAccount',
    funnel: funnel,
    default_state: defaultState,
  }

  if (!defaultState) {
    delete payload.default_state
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Create Account
 * Next button tapped
 */
export type TrackRegistrationCreateAccountNextButtonTappedType = {
  destination: string
  funnel: string
  ctaTitle: string
}

export const trackRegistrationCreateAccountNextButtonTappedPayload = ({
  destination,
  funnel,
  ctaTitle,
}: TrackRegistrationCreateAccountNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Create Account',
    event_description: 'Next button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationCreateAccountNext',
    screen: 'registrationCreateAccount',
    screen_name: 'registrationCreateAccount',
    destination: destination,
    funnel: funnel,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Create Account
 * Password Screen Viewed
 */
export type TrackRegistrationCreateAccountPasswordScreenViewedType = {
  type: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationCreateAccountPasswordScreenViewedPayload = ({
  type,
  funnel,
  funnelVersion,
}: TrackRegistrationCreateAccountPasswordScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Create Account',
    event_description: 'Password Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationCreateAccountPassword',
    screen: 'registrationCreateAccountPassword',
    screen_name: 'registrationCreateAccountPassword',
    type: type,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Create Account
 * Password Back Button Tapped
 */
export type TrackRegistrationCreateAccountPasswordBackButtonTappedType = {
  type: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationCreateAccountPasswordBackButtonTappedPayload = ({
  type,
  funnel,
  funnelVersion,
}: TrackRegistrationCreateAccountPasswordBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Create Account',
    event_description: 'Password Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationCreateAccountPasswordBack',
    screen: 'registrationCreateAccountPassword',
    screen_name: 'registrationCreateAccountPassword',
    type: type,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Create Account
 * Password Next button tapped
 */
export type TrackRegistrationCreateAccountPasswordNextButtonTappedType = {
  type: string
  funnel: string
  funnelVersion?: string
  ctaTitle: string
}

export const trackRegistrationCreateAccountPasswordNextButtonTappedPayload = ({
  type,
  funnel,
  funnelVersion,
  ctaTitle,
}: TrackRegistrationCreateAccountPasswordNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Create Account',
    event_description: 'Password Next button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationCreateAccountPasswordNext',
    screen: 'registrationCreateAccountPassword',
    screen_name: 'registrationCreateAccountPassword',
    type: type,
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Create Account
 * Program Agreement Modal Viewed
 */
export type TrackRegistrationCreateAccountProgramAgreementModalViewedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationCreateAccountProgramAgreementModalViewedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationCreateAccountProgramAgreementModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Create Account',
    event_description: 'Program Agreement Modal Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationCreateAccountPasswordAgreements',
    screen: 'registrationCreateAccountPassword',
    screen_name: 'registrationCreateAccountPasswordAgreements',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Create Account
 * Program Agreement Modal Cancelled
 */
export type TrackRegistrationCreateAccountProgramAgreementModalCancelledType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationCreateAccountProgramAgreementModalCancelledPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationCreateAccountProgramAgreementModalCancelledType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Create Account',
    event_description: 'Program Agreement Modal Cancelled',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationCreateAccountPasswordAgreementsCancel',
    screen: 'registrationCreateAccountPassword',
    screen_name: 'registrationCreateAccountPasswordAgreements',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Create Account
 * Program Agreement Modal Confirmed
 */
export type TrackRegistrationCreateAccountProgramAgreementModalConfirmedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationCreateAccountProgramAgreementModalConfirmedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationCreateAccountProgramAgreementModalConfirmedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Create Account',
    event_description: 'Program Agreement Modal Confirmed',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationCreateAccountPasswordAgreementsConfirm',
    screen: 'registrationCreateAccountPassword',
    screen_name: 'registrationCreateAccountPasswordAgreements',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Create Account
 * Program Agreement link tapped
 */
export type TrackRegistrationCreateAccountProgramAgreementLinkTappedType = {
  screen: string
  screenName: string
  funnel: string
  funnelVersion?: string
  ctaTitle: string
}

export const trackRegistrationCreateAccountProgramAgreementLinkTappedPayload = ({
  screen,
  screenName,
  funnel,
  funnelVersion,
  ctaTitle,
}: TrackRegistrationCreateAccountProgramAgreementLinkTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Create Account',
    event_description: 'Program Agreement link tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationCreateAccountProgramAgreementLink',
    destination: 'registrationProgramAgreement',
    screen: screen,
    screen_name: screenName,
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Log In
 * Forgot Password button tapped
 */
export type TrackLogInForgotPasswordButtonTappedType = {
  screen: string
  screenName: string
  destination: string
  ctaTitle: string
}

export const trackLogInForgotPasswordButtonTappedPayload = ({
  screen,
  screenName,
  destination,
  ctaTitle,
}: TrackLogInForgotPasswordButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Log In',
    event_description: 'Forgot Password button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'logInForgotPassword',
    screen: screen,
    screen_name: screenName,
    destination: destination,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Forgot Password
 * Modal Viewed
 */
export const trackForgotPasswordModalViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Forgot Password',
    event_description: 'Modal Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationCreateAccountForgotPassword',
    screen: 'registrationCreateAccountPassword',
    screen_name: 'registrationCreateAccountForgotPassword',
  }

  return ['Container Viewed', payload]
}

/**
 * Forgot Password
 * Modal Confirmed
 */
export const trackForgotPasswordModalConfirmedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Forgot Password',
    event_description: 'Modal Confirmed',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationCreateAccountForgotPasswordConfirm',
    screen: 'registrationCreateAccountPassword',
    screen_name: 'registrationCreateAccountForgotPassword',
  }

  return ['Button Tapped', payload]
}

/**
 * Forgot Password
 * Modal Help
 */
export const trackForgotPasswordModalHelpPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Forgot Password',
    event_description: 'Modal Help',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationCreateAccountForgotPasswordHelp',
    screen: 'registrationCreateAccountPassword',
    screen_name: 'registrationCreateAccountForgotPassword',
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Create Account
 * Modal Viewed
 */
export type TrackRegistrationCreateAccountModalViewedType = {
  funnel: string
}

export const trackRegistrationCreateAccountModalViewedPayload = ({
  funnel,
}: TrackRegistrationCreateAccountModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Create Account',
    event_description: 'Modal Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'createAccountEmailExists',
    screen: 'registrationCreateAccount',
    funnel: funnel,
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Create Account Modal
 * Back Button Tapped
 */
export const trackRegistrationCreateAccountModalBackButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Create Account Modal',
    event_description: 'Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'createAccountEmailExistsBack',
    screen: 'registrationCreateAccount',
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Create Account Modal
 * Login Button Tapped
 */
export const trackRegistrationCreateAccountModalLoginButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Create Account Modal',
    event_description: 'Login Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'createAccountEmailExistsLogIn',
    screen: 'registrationCreateAccount',
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Create Account
 * Resident and Program Agreement toggle state changed
 */
export type TrackRegistrationCreateAccountResidentAndProgramAgreementToggleStateChangedType = {
  funnel: string
  state: string
  defaultState: string
}

export const trackRegistrationCreateAccountResidentAndProgramAgreementToggleStateChangedPayload = ({
  funnel,
  state,
  defaultState,
}: TrackRegistrationCreateAccountResidentAndProgramAgreementToggleStateChangedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Create Account',
    event_description: 'Resident and Program Agreement toggle state changed',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationCreateAccountResidentAndProgramAgreement',
    style: 'toggle',
    screen: 'registrationCreateAccount',
    screen_name: 'registrationCreateAccount',
    funnel: funnel,
    state: state,
    default_state: defaultState,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Create Account
 * Close button tapped
 */
export type TrackRegistrationCreateAccountCloseButtonTappedType = {
  funnel: string
}

export const trackRegistrationCreateAccountCloseButtonTappedPayload = ({
  funnel,
}: TrackRegistrationCreateAccountCloseButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Create Account',
    event_description: 'Close button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationCreateAccountClose',
    style: 'icon',
    screen: 'registrationCreateAccount',
    screen_name: 'registrationCreateAccount',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Create Account
 * Verify Email modal viewed
 */
export type TrackRegistrationCreateAccountVerifyEmailModalViewedType = {
  tier?: string
  funnel: string
}

export const trackRegistrationCreateAccountVerifyEmailModalViewedPayload = ({
  tier,
  funnel,
}: TrackRegistrationCreateAccountVerifyEmailModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Create Account',
    event_description: 'Verify Email modal viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationCreateAccountVerifyEmail',
    style: 'modal',
    screen: 'registrationCreateAccount',
    screen_name: 'registrationCreateAccountVerifyEmail',
    tier: tier,
    funnel: funnel,
  }

  if (!tier) {
    delete payload.tier
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Create Account
 * Verify Email modal dismissed
 */
export type TrackRegistrationCreateAccountVerifyEmailModalDismissedType = {
  funnel: string
  ctaTitle: string
}

export const trackRegistrationCreateAccountVerifyEmailModalDismissedPayload = ({
  funnel,
  ctaTitle,
}: TrackRegistrationCreateAccountVerifyEmailModalDismissedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Create Account',
    event_description: 'Verify Email modal dismissed',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationCreateAccountVerifyEmail',
    style: 'default',
    screen: 'registrationCreateAccount',
    screen_name: 'registrationCreateAccountVerifyEmail',
    funnel: funnel,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Create Account
 * Verify Email modal tapped
 */
export type TrackRegistrationCreateAccountVerifyEmailModalTappedType = {
  destination: string
  funnel: string
  ctaTitle: string
}

export const trackRegistrationCreateAccountVerifyEmailModalTappedPayload = ({
  destination,
  funnel,
  ctaTitle,
}: TrackRegistrationCreateAccountVerifyEmailModalTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Create Account',
    event_description: 'Verify Email modal tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationCreateAccountVerifyEmailConfirm',
    style: 'default',
    screen: 'registrationCreateAccount',
    screen_name: 'registrationCreateAccountVerifyEmail',
    destination: destination,
    funnel: funnel,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Create Account
 * Agreement Toggle Invalid Modal Viewed
 */
export type TrackRegistrationCreateAccountAgreementToggleInvalidModalViewedType = {
  funnel: string
}

export const trackRegistrationCreateAccountAgreementToggleInvalidModalViewedPayload = ({
  funnel,
}: TrackRegistrationCreateAccountAgreementToggleInvalidModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Create Account',
    event_description: 'Agreement Toggle Invalid Modal Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationCreateAccountAgreementModal',
    style: 'modal',
    screen: 'registrationCreateAccount',
    screen_name: 'registrationCreateAccountAgreementModal',
    funnel: funnel,
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Create Account
 * Agreement Toggle Invalid Modal Dismissed
 */
export type TrackRegistrationCreateAccountAgreementToggleInvalidModalDismissedType = {
  funnel: string
  ctaTitle: string
}

export const trackRegistrationCreateAccountAgreementToggleInvalidModalDismissedPayload = ({
  funnel,
  ctaTitle,
}: TrackRegistrationCreateAccountAgreementToggleInvalidModalDismissedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Create Account',
    event_description: 'Agreement Toggle Invalid Modal Dismissed',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationCreateAccountAgreementModalDismissed',
    style: 'default',
    screen: 'registrationCreateAccount',
    screen_name: 'registrationCreateAccountAgreementModal',
    funnel: funnel,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Create Account
 * Program Agreement modal dismissed
 */
export type TrackRegistrationCreateAccountProgramAgreementModalDismissedType = {
  funnel: string
  ctaTitle: string
}

export const trackRegistrationCreateAccountProgramAgreementModalDismissedPayload = ({
  funnel,
  ctaTitle,
}: TrackRegistrationCreateAccountProgramAgreementModalDismissedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Create Account',
    event_description: 'Program Agreement modal dismissed',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationCreateAccountProgramAgreementCancel',
    style: 'default',
    screen: 'registrationCreateAccount',
    screen_name: 'registrationCreateAccountProgramAgreement',
    funnel: funnel,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Create Account
 * Existing Account Login Link Tapped
 */
export const trackRegistrationCreateAccountExistingAccountLoginLinkTappedPayload =
  (): ResultType => {
    const payload = {
      call_type: 'track',
      feature: 'Registration Create Account',
      event_description: 'Existing Account Login Link Tapped',
      platforms: 'web',
      object: 'Button',
      action: 'Tapped',
      object_name: 'loginExistsCTA',
      screen: 'registrationCreateAccount',
    }

    return ['Button Tapped', payload]
  }

/**
 * Registration Create Account
 * Gold Prefilled Container Viewed
 */
export type TrackRegistrationCreateAccountGoldPrefilledContainerViewedType = {
  context?: string
}

export const trackRegistrationCreateAccountGoldPrefilledContainerViewedPayload = ({
  context,
}: TrackRegistrationCreateAccountGoldPrefilledContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Create Account',
    event_description: 'Gold Prefilled Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationCreateAccountGoldPrefilled',
    screen: 'registrationCreateAccount',
    context: context,
  }

  if (!context) {
    delete payload.context
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Information: Date Of Birth
 * Screen Viewed
 */
export type TrackRegistrationInformationDateOfBirthScreenViewedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInformationDateOfBirthScreenViewedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationInformationDateOfBirthScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Date Of Birth',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationInformationDob',
    screen: 'registrationInformationDob',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Information: Date Of Birth
 * Next Button Tapped
 */
export type TrackRegistrationInformationDateOfBirthNextButtonTappedType = {
  funnel: string
  funnelVersion?: string
  ctaTitle: string
}

export const trackRegistrationInformationDateOfBirthNextButtonTappedPayload = ({
  funnel,
  funnelVersion,
  ctaTitle,
}: TrackRegistrationInformationDateOfBirthNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Date Of Birth',
    event_description: 'Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInformationDobNext',
    screen: 'registrationInformationDob',
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Information: Date Of Birth
 * Back button tapped
 */
export type TrackRegistrationInformationDateOfBirthBackButtonTappedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInformationDateOfBirthBackButtonTappedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationInformationDateOfBirthBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Date Of Birth',
    event_description: 'Back button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInformationDobBack',
    screen: 'registrationInformationDob',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Ecbsv Consent
 * Container Viewed
 */
export type TrackRegistrationEcbsvConsentContainerViewedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationEcbsvConsentContainerViewedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationEcbsvConsentContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Ecbsv Consent',
    event_description: 'Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationEcbsvConsent',
    screen: 'registrationEcbsvConsent',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Ecbsv Consent Accept
 * Button Tapped
 */
export type TrackRegistrationEcbsvConsentAcceptButtonTappedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationEcbsvConsentAcceptButtonTappedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationEcbsvConsentAcceptButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Ecbsv Consent Accept',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationEcbsvConsentAccept',
    screen: 'registrationEcbsvConsent',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Ecbsv Consent Decline
 * Button Tapped
 */
export type TrackRegistrationEcbsvConsentDeclineButtonTappedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationEcbsvConsentDeclineButtonTappedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationEcbsvConsentDeclineButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Ecbsv Consent Decline',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationEcbsvConsentDecline',
    screen: 'registrationEcbsvConsent',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Hdyhau Page
 * Screen Viewed
 */
export type TrackRegistrationHdyhauPageScreenViewedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationHdyhauPageScreenViewedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationHdyhauPageScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Hdyhau Page',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationHowDidYouHearAboutUs',
    screen: 'registrationHowDidYouHearAboutUs',
    screen_name: 'registrationHowDidYouHearAboutUs',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Hdyhau Page
 * Button Tapped
 */
export type TrackRegistrationHdyhauPageButtonTappedType = {
  funnel: string
  funnelVersion?: string
  hdyhau?: string
}

export const trackRegistrationHdyhauPageButtonTappedPayload = ({
  funnel,
  funnelVersion,
  hdyhau,
}: TrackRegistrationHdyhauPageButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Hdyhau Page',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationHowDidYouHearAboutUsNext',
    screen: 'registrationHowDidYouHearAboutUs',
    screen_name: 'registrationHowDidYouHearAboutUs',
    funnel: funnel,
    funnel_version: funnelVersion,
    hdyhau: hdyhau,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!hdyhau) {
    delete payload.hdyhau
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Hdyhau Page
 * Skip Button Tapped
 */
export type TrackRegistrationHdyhauPageSkipButtonTappedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationHdyhauPageSkipButtonTappedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationHdyhauPageSkipButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Hdyhau Page',
    event_description: 'Skip Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationHowDidYouHearAboutUsSkip',
    screen: 'registrationHowDidYouHearAboutUs',
    screen_name: 'registrationHowDidYouHearAboutUs',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Initial Investment: One-Time
 * Screen Viewed
 */
export type TrackRegistrationInitialInvestmentOneTimeScreenViewedType = {
  tier: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInitialInvestmentOneTimeScreenViewedPayload = ({
  tier,
  funnel,
  funnelVersion,
}: TrackRegistrationInitialInvestmentOneTimeScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Initial Investment: One-Time',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationInitialInvestmentOneTime',
    style: 'main',
    screen: 'registrationInitialInvestmentOneTime',
    tier: tier,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Initial Investment: One-Time
 * Amount selected
 */
export type TrackRegistrationInitialInvestmentOneTimeAmountSelectedType = {
  indexPosition: number
  indexPositionTapped: number
  indexCount: number
  funnel: string
  funnelVersion?: string
  ctaTitle: string
}

export const trackRegistrationInitialInvestmentOneTimeAmountSelectedPayload = ({
  indexPosition,
  indexPositionTapped,
  indexCount,
  funnel,
  funnelVersion,
  ctaTitle,
}: TrackRegistrationInitialInvestmentOneTimeAmountSelectedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Initial Investment: One-Time',
    event_description: 'Amount selected',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInitialInvestmentOneTimeAmount',
    style: 'cell',
    screen: 'registrationInitialInvestmentOneTime',
    destination: 'registrationInitialInvestmentRecurring',
    index_position: indexPosition,
    index_position_tapped: indexPositionTapped,
    index_count: indexCount,
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Initial Investment: One-Time
 * Next button tapped
 */
export type TrackRegistrationInitialInvestmentOneTimeNextButtonTappedType = {
  destination: string
  funnel: string
  funnelVersion?: string
  ctaTitle: string
  amount?: string
}

export const trackRegistrationInitialInvestmentOneTimeNextButtonTappedPayload = ({
  destination,
  funnel,
  funnelVersion,
  ctaTitle,
  amount,
}: TrackRegistrationInitialInvestmentOneTimeNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Initial Investment: One-Time',
    event_description: 'Next button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInitialInvestmentOneTimeNext',
    style: 'default',
    screen: 'registrationInitialInvestmentOneTime',
    destination: destination,
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
    amount: amount,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!amount) {
    delete payload.amount
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Initial Investment: One-Time
 * Back button tapped
 */
export type TrackRegistrationInitialInvestmentOneTimeBackButtonTappedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInitialInvestmentOneTimeBackButtonTappedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationInitialInvestmentOneTimeBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Initial Investment: One-Time',
    event_description: 'Back button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInitialInvestmentOneTimeBack',
    style: 'icon',
    screen: 'registrationInitialInvestmentOneTime',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Initial Investment: One-Time
 * Confirm modal viewed
 */
export type TrackRegistrationInitialInvestmentOneTimeConfirmModalViewedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInitialInvestmentOneTimeConfirmModalViewedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationInitialInvestmentOneTimeConfirmModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Initial Investment: One-Time',
    event_description: 'Confirm modal viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationInitialInvestmentOneTimeConfirmAmount',
    style: 'modal',
    screen: 'registrationInitialInvestmentOneTime',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Initial Investment: One-Time
 * Confirm modal dismissed
 */
export type TrackRegistrationInitialInvestmentOneTimeConfirmModalDismissedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInitialInvestmentOneTimeConfirmModalDismissedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationInitialInvestmentOneTimeConfirmModalDismissedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Initial Investment: One-Time',
    event_description: 'Confirm modal dismissed',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInitialInvestmentOneTimeConfirmAmountCancel',
    style: 'default',
    screen: 'registrationInitialInvestmentOneTime',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Initial Investment: One-Time
 * Confirm modal confirmed
 */
export type TrackRegistrationInitialInvestmentOneTimeConfirmModalConfirmedType = {
  destination: string
  funnel: string
  funnelVersion?: string
  ctaTitle: string
  amount: string
}

export const trackRegistrationInitialInvestmentOneTimeConfirmModalConfirmedPayload = ({
  destination,
  funnel,
  funnelVersion,
  ctaTitle,
  amount,
}: TrackRegistrationInitialInvestmentOneTimeConfirmModalConfirmedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Initial Investment: One-Time',
    event_description: 'Confirm modal confirmed',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInitialInvestmentOneTimeConfirmAmountConfirm',
    style: 'default',
    screen: 'registrationInitialInvestmentOneTime',
    destination: destination,
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
    amount: amount,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Initial Investment: One-Time
 * make an investment later button tapped
 */
export type TrackRegistrationInitialInvestmentOneTimeMakeAnInvestmentLaterButtonTappedType = {
  funnel: string
  funnelVersion?: string
  ctaTitle: string
}

export const trackRegistrationInitialInvestmentOneTimeMakeAnInvestmentLaterButtonTappedPayload = ({
  funnel,
  funnelVersion,
  ctaTitle,
}: TrackRegistrationInitialInvestmentOneTimeMakeAnInvestmentLaterButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Initial Investment: One-Time',
    event_description: 'make an investment later button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInitialInvestmentOneTimeSkip',
    screen: 'registrationInitialInvestmentOneTime',
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Initial Investment: One-Time
 * other amount selected
 */
export type TrackRegistrationInitialInvestmentOneTimeOtherAmountSelectedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInitialInvestmentOneTimeOtherAmountSelectedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationInitialInvestmentOneTimeOtherAmountSelectedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Initial Investment: One-Time',
    event_description: 'other amount selected',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInitialInvestmentOneTimeOther',
    screen: 'registrationInitialInvestmentOneTime',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Initial Investment: One-Time Other
 * Screen Viewed
 */
export type TrackRegistrationInitialInvestmentOneTimeOtherScreenViewedType = {
  tier: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInitialInvestmentOneTimeOtherScreenViewedPayload = ({
  tier,
  funnel,
  funnelVersion,
}: TrackRegistrationInitialInvestmentOneTimeOtherScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Initial Investment: One-Time Other',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationInitialInvestmentOneTimeCustom',
    style: 'main',
    screen: 'registrationInitialInvestmentOneTimeCustom',
    tier: tier,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Initial Investment: One-Time Other
 * Next button tapped
 */
export type TrackRegistrationInitialInvestmentOneTimeOtherNextButtonTappedType = {
  funnel: string
  funnelVersion?: string
  ctaTitle: string
  amount: string
}

export const trackRegistrationInitialInvestmentOneTimeOtherNextButtonTappedPayload = ({
  funnel,
  funnelVersion,
  ctaTitle,
  amount,
}: TrackRegistrationInitialInvestmentOneTimeOtherNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Initial Investment: One-Time Other',
    event_description: 'Next button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInitialInvestmentOneTimeCustomNext',
    style: 'default',
    screen: 'registrationInitialInvestmentOneTimeCustom',
    destination: 'registrationInitialInvestmentOneTimeCustomConfirmAmount',
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
    amount: amount,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Initial Investment: One-Time Other
 * Back button tapped
 */
export type TrackRegistrationInitialInvestmentOneTimeOtherBackButtonTappedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInitialInvestmentOneTimeOtherBackButtonTappedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationInitialInvestmentOneTimeOtherBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Initial Investment: One-Time Other',
    event_description: 'Back button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInitialInvestmentOneTimeCustomBack',
    style: 'icon',
    screen: 'registrationInitialInvestmentOneTimeCustom',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Initial Investment: Recurring
 * Screen Viewed
 */
export type TrackRegistrationInitialInvestmentRecurringScreenViewedType = {
  tier: string
  funnel: string
  funnelVersion?: string
  incentive?: string
}

export const trackRegistrationInitialInvestmentRecurringScreenViewedPayload = ({
  tier,
  funnel,
  funnelVersion,
  incentive,
}: TrackRegistrationInitialInvestmentRecurringScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Initial Investment: Recurring',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationInitialInvestmentRecurring',
    style: 'main',
    screen: 'registrationInitialInvestmentRecurring',
    screen_name: 'registrationInitialInvestmentRecurring',
    tier: tier,
    funnel: funnel,
    funnel_version: funnelVersion,
    incentive: incentive,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Initial Investment: Recurring
 * Amount selected
 */
export type TrackRegistrationInitialInvestmentRecurringAmountSelectedType = {
  indexPosition: number
  indexCount: number
  funnel: string
  funnelVersion?: string
  ctaTitle: string
  amount: string
  frequency: string
}

export const trackRegistrationInitialInvestmentRecurringAmountSelectedPayload = ({
  indexPosition,
  indexCount,
  funnel,
  funnelVersion,
  ctaTitle,
  amount,
  frequency,
}: TrackRegistrationInitialInvestmentRecurringAmountSelectedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Initial Investment: Recurring',
    event_description: 'Amount selected',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInitialInvestmentRecurringAmount',
    style: 'cell',
    screen: 'registrationInitialInvestmentRecurring',
    screen_name: 'registrationInitialInvestmentRecurring',
    index_position: indexPosition,
    index_count: indexCount,
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
    amount: amount,
    frequency: frequency,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Initial Investment: Recurring
 * One Time Investment button tapped
 */
export type TrackRegistrationInitialInvestmentRecurringOneTimeInvestmentButtonTappedType = {
  destination: string
  funnel: string
  funnelVersion?: string
  ctaTitle: string
}

export const trackRegistrationInitialInvestmentRecurringOneTimeInvestmentButtonTappedPayload = ({
  destination,
  funnel,
  funnelVersion,
  ctaTitle,
}: TrackRegistrationInitialInvestmentRecurringOneTimeInvestmentButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Initial Investment: Recurring',
    event_description: 'One Time Investment button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInitialInvestmentRecurringOneTime',
    style: 'text',
    screen: 'registrationInitialInvestmentRecurring',
    screen_name: 'registrationInitialInvestmentRecurring',
    destination: destination,
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Initial Investment: Recurring
 * Next button tapped
 */
export type TrackRegistrationInitialInvestmentRecurringNextButtonTappedType = {
  destination: string
  funnel: string
  funnelVersion?: string
  ctaTitle: string
  amount: string
  frequency: string
}

export const trackRegistrationInitialInvestmentRecurringNextButtonTappedPayload = ({
  destination,
  funnel,
  funnelVersion,
  ctaTitle,
  amount,
  frequency,
}: TrackRegistrationInitialInvestmentRecurringNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Initial Investment: Recurring',
    event_description: 'Next button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInitialInvestmentRecurringNext',
    style: 'default',
    screen: 'registrationInitialInvestmentRecurring',
    screen_name: 'registrationInitialInvestmentRecurring',
    destination: destination,
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
    amount: amount,
    frequency: frequency,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Initial Investment: Recurring
 * Do Later button tapped
 */
export type TrackRegistrationInitialInvestmentRecurringDoLaterButtonTappedType = {
  destination: string
  funnel: string
  funnelVersion?: string
  ctaTitle: string
}

export const trackRegistrationInitialInvestmentRecurringDoLaterButtonTappedPayload = ({
  destination,
  funnel,
  funnelVersion,
  ctaTitle,
}: TrackRegistrationInitialInvestmentRecurringDoLaterButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Initial Investment: Recurring',
    event_description: 'Do Later button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInitialInvestmentRecurringAmountDoLater',
    style: 'text',
    screen: 'registrationInitialInvestmentRecurring',
    screen_name: 'registrationInitialInvestmentRecurring',
    destination: destination,
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Initial Investment: Recurring
 * Back Button Tapped
 */
export type TrackRegistrationInitialInvestmentRecurringBackButtonTappedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInitialInvestmentRecurringBackButtonTappedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationInitialInvestmentRecurringBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Initial Investment: Recurring',
    event_description: 'Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInitialInvestmentRecurringBack',
    screen: 'registrationInitialInvestmentRecurring',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Initial Investment: Recurring
 * Confirm Amount modal viewed
 */
export type TrackRegistrationInitialInvestmentRecurringConfirmAmountModalViewedType = {
  funnel: string
  funnelVersion?: string
  amount: string
  frequency: string
}

export const trackRegistrationInitialInvestmentRecurringConfirmAmountModalViewedPayload = ({
  funnel,
  funnelVersion,
  amount,
  frequency,
}: TrackRegistrationInitialInvestmentRecurringConfirmAmountModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Initial Investment: Recurring',
    event_description: 'Confirm Amount modal viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationInitialInvestmentRecurringConfirmAmount',
    style: 'modal',
    screen: 'registrationInitialInvestmentRecurring',
    screen_name: 'registrationInitialInvestmentRecurringConfirmAmount',
    funnel: funnel,
    funnel_version: funnelVersion,
    amount: amount,
    frequency: frequency,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Initial Investment: Recurring
 * Confirm Amount modal dismissed
 */
export type TrackRegistrationInitialInvestmentRecurringConfirmAmountModalDismissedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInitialInvestmentRecurringConfirmAmountModalDismissedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationInitialInvestmentRecurringConfirmAmountModalDismissedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Initial Investment: Recurring',
    event_description: 'Confirm Amount modal dismissed',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInitialInvestmentRecurringConfirmAmountCancel',
    style: 'default',
    screen: 'registrationInitialInvestmentRecurring',
    screen_name: 'registrationInitialInvestmentRecurringConfirmAmount',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Initial Investment: Recurring
 * Confirm Amount modal tapped
 */
export type TrackRegistrationInitialInvestmentRecurringConfirmAmountModalTappedType = {
  funnel: string
  funnelVersion?: string
  ctaTitle: string
  amount: string
  frequency: string
}

export const trackRegistrationInitialInvestmentRecurringConfirmAmountModalTappedPayload = ({
  funnel,
  funnelVersion,
  ctaTitle,
  amount,
  frequency,
}: TrackRegistrationInitialInvestmentRecurringConfirmAmountModalTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Initial Investment: Recurring',
    event_description: 'Confirm Amount modal tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInitialInvestmentRecurringConfirmAmountConfirm',
    style: 'default',
    screen: 'registrationInitialInvestmentRecurring',
    screen_name: 'registrationInitialInvestmentRecurringConfirmAmount',
    destination: 'registrationInvestorCertificate',
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
    amount: amount,
    frequency: frequency,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Initial Investment: Recurring
 * Skip Button Tapped
 */
export type TrackRegistrationInitialInvestmentRecurringSkipButtonTappedType = {
  funnel: string
  funnelVersion?: string
  ctaTitle: string
  destination: string
}

export const trackRegistrationInitialInvestmentRecurringSkipButtonTappedPayload = ({
  funnel,
  funnelVersion,
  ctaTitle,
  destination,
}: TrackRegistrationInitialInvestmentRecurringSkipButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Initial Investment: Recurring',
    event_description: 'Skip Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInitialInvestmentRecurringSkip',
    screen: 'registrationInitialInvestmentRecurring',
    screen_name: 'registrationInitialInvestmentRecurring',
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
    destination: destination,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Initial Investment: Recurring
 * Update Amount Button Tapped
 */
export type TrackRegistrationInitialInvestmentRecurringUpdateAmountButtonTappedType = {
  funnel: string
  amount: string
  frequency: string
}

export const trackRegistrationInitialInvestmentRecurringUpdateAmountButtonTappedPayload = ({
  funnel,
  amount,
  frequency,
}: TrackRegistrationInitialInvestmentRecurringUpdateAmountButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Initial Investment: Recurring',
    event_description: 'Update Amount Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInitialInvestmentRecurringUpdateAmount',
    screen: 'registrationInitialInvestmentRecurring',
    screen_name: 'registrationInitialInvestmentRecurring',
    funnel: funnel,
    amount: amount,
    frequency: frequency,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Initial Invetment: Recurring
 * Potential Button Tapped
 */
export type TrackRegistrationInitialInvetmentRecurringPotentialButtonTappedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInitialInvetmentRecurringPotentialButtonTappedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationInitialInvetmentRecurringPotentialButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Initial Invetment: Recurring',
    event_description: 'Potential Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInitialInvestmentRecurringPotentialPill',
    screen: 'registrationInitialInvestmentRecurring',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Potential Drawer
 * Container Viewed
 */
export type TrackRegistrationPotentialDrawerContainerViewedType = {
  amount: string
  frequency: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationPotentialDrawerContainerViewedPayload = ({
  amount,
  frequency,
  funnel,
  funnelVersion,
}: TrackRegistrationPotentialDrawerContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Potential Drawer',
    event_description: 'Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationPotentialDrawer',
    screen: 'registrationInitialInvestmentRecurring',
    amount: amount,
    frequency: frequency,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Potential Drawer
 * Disclosure Button Tapped
 */
export type TrackRegistrationPotentialDrawerDisclosureButtonTappedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationPotentialDrawerDisclosureButtonTappedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationPotentialDrawerDisclosureButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Potential Drawer',
    event_description: 'Disclosure Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationPotentialDisclosure',
    screen: 'registrationInitialInvestmentRecurring',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Potential Drawer
 * Close Button Tapped
 */
export type TrackRegistrationPotentialDrawerCloseButtonTappedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationPotentialDrawerCloseButtonTappedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationPotentialDrawerCloseButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Potential Drawer',
    event_description: 'Close Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInitialInvestmentRecurringPotentialDismiss',
    screen: 'registrationInitialInvestmentRecurring',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Recurring Incentive Reminder
 * Container Viewed
 */
export type TrackRegistrationRecurringIncentiveReminderContainerViewedType = {
  funnel: string
  funnelVersion?: string
  incentive?: string
  destination: string
}

export const trackRegistrationRecurringIncentiveReminderContainerViewedPayload = ({
  funnel,
  funnelVersion,
  incentive,
  destination,
}: TrackRegistrationRecurringIncentiveReminderContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Recurring Incentive Reminder',
    event_description: 'Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationRecurringIncentiveReminder',
    funnel: funnel,
    funnel_version: funnelVersion,
    incentive: incentive,
    destination: destination,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Recurring Incentive Reminder Back
 * Button Tapped
 */
export type TrackRegistrationRecurringIncentiveReminderBackButtonTappedType = {
  funnel: string
  funnelVersion?: string
  incentive?: string
  destination: string
  ctaTitle: string
}

export const trackRegistrationRecurringIncentiveReminderBackButtonTappedPayload = ({
  funnel,
  funnelVersion,
  incentive,
  destination,
  ctaTitle,
}: TrackRegistrationRecurringIncentiveReminderBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Recurring Incentive Reminder Back',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationRecurringIncentiveReminderBack',
    funnel: funnel,
    funnel_version: funnelVersion,
    incentive: incentive,
    destination: destination,
    cta_title: ctaTitle,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Recurring Incentive Reminder Next
 * Button Tapped
 */
export type TrackRegistrationRecurringIncentiveReminderNextButtonTappedType = {
  funnel: string
  funnelVersion?: string
  incentive?: string
  destination: string
  ctaTitle: string
}

export const trackRegistrationRecurringIncentiveReminderNextButtonTappedPayload = ({
  funnel,
  funnelVersion,
  incentive,
  destination,
  ctaTitle,
}: TrackRegistrationRecurringIncentiveReminderNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Recurring Incentive Reminder Next',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationRecurringIncentiveReminderNext',
    funnel: funnel,
    funnel_version: funnelVersion,
    incentive: incentive,
    destination: destination,
    cta_title: ctaTitle,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Invest: Interstitial
 * Screen Viewed
 */
export type TrackRegistrationInvestInterstitialScreenViewedType = {
  tier: string
  tierKey: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInvestInterstitialScreenViewedPayload = ({
  tier,
  tierKey,
  funnel,
  funnelVersion,
}: TrackRegistrationInvestInterstitialScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Invest: Interstitial',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationInvestInterstitial',
    style: 'main',
    screen: 'registrationInvestInterstitial',
    screen_name: 'registrationInvestInterstitial',
    tier: tier,
    tierKey: tierKey,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Invest: Interstitial
 * Next button tapped
 */
export type TrackRegistrationInvestInterstitialNextButtonTappedType = {
  destination: string
  funnel: string
  funnelVersion?: string
  ctaTitle: string
}

export const trackRegistrationInvestInterstitialNextButtonTappedPayload = ({
  destination,
  funnel,
  funnelVersion,
  ctaTitle,
}: TrackRegistrationInvestInterstitialNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Invest: Interstitial',
    event_description: 'Next button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInvestInterstitialNext',
    style: 'default',
    screen: 'registrationInvestInterstitial',
    screen_name: 'registrationInvestInterstitial',
    destination: destination,
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Information: Investor Questions
 * Screen Viewed
 */
export type TrackRegistrationInformationInvestorQuestionsScreenViewedType = {
  tier: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInformationInvestorQuestionsScreenViewedPayload = ({
  tier,
  funnel,
  funnelVersion,
}: TrackRegistrationInformationInvestorQuestionsScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Investor Questions',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationInformationInvestorQuestions',
    style: 'main',
    screen: 'registrationInformationInvestorQuestions',
    screen_name: 'registrationInformationInvestorQuestions',
    tier: tier,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Information: Investor Questions
 * Next button tapped
 */
export type TrackRegistrationInformationInvestorQuestionsNextButtonTappedType = {
  destination: string
  funnel: string
  funnelVersion?: string
  ctaTitle: string
}

export const trackRegistrationInformationInvestorQuestionsNextButtonTappedPayload = ({
  destination,
  funnel,
  funnelVersion,
  ctaTitle,
}: TrackRegistrationInformationInvestorQuestionsNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Investor Questions',
    event_description: 'Next button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInformationInvestorQuestionsNext',
    style: 'default',
    screen: 'registrationInformationInvestorQuestions',
    screen_name: 'registrationInformationInvestorQuestions',
    destination: destination,
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Information: Investor Questions
 * Back button tapped
 */
export type TrackRegistrationInformationInvestorQuestionsBackButtonTappedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInformationInvestorQuestionsBackButtonTappedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationInformationInvestorQuestionsBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Investor Questions',
    event_description: 'Back button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInformationInvestorQuestionsBack',
    style: 'icon',
    screen: 'registrationInformationInvestorQuestions',
    screen_name: 'registrationInformationInvestorQuestions',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Link Bank
 * Manual Link Button Tapped
 */
export type TrackRegistrationLinkBankManualLinkButtonTappedType = {
  ctaTitle?: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationLinkBankManualLinkButtonTappedPayload = ({
  ctaTitle,
  funnel,
  funnelVersion,
}: TrackRegistrationLinkBankManualLinkButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Link Bank',
    event_description: 'Manual Link Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationLinkBankAccountManualCTA',
    style: 'text',
    screen: 'registrationLinkBankSearch',
    screen_name: 'registrationLinkBankSearch',
    destination: 'registrationLinkBankManual',
    cta_title: ctaTitle,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Link Bank
 * Confirm Skip Modal Viewed
 */
export type TrackRegistrationLinkBankConfirmSkipModalViewedType = {
  copy: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationLinkBankConfirmSkipModalViewedPayload = ({
  copy,
  funnel,
  funnelVersion,
}: TrackRegistrationLinkBankConfirmSkipModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Link Bank',
    event_description: 'Confirm Skip Modal Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationLinkBankSearchSkipModal',
    screen: 'registrationLinkBankSearchSkipModal',
    copy: copy,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Link Bank
 * Confirm Skip Modal Back
 */
export const trackRegistrationLinkBankConfirmSkipModalBackPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Link Bank',
    event_description: 'Confirm Skip Modal Back',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationLinkBankSearchSkipModalBack',
    screen: 'registrationLinkBankSearchSkipModal',
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Link Bank
 * Confirm Skip Modal Skip
 */
export const trackRegistrationLinkBankConfirmSkipModalSkipPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Link Bank',
    event_description: 'Confirm Skip Modal Skip',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationLinkBankSearchSkipModalSkip',
    screen: 'registrationLinkBankSearchSkipModal',
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Link Bank: Account Linked
 * Screen Viewed
 */
export type TrackRegistrationLinkBankAccountLinkedScreenViewedType = {
  tier: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationLinkBankAccountLinkedScreenViewedPayload = ({
  tier,
  funnel,
  funnelVersion,
}: TrackRegistrationLinkBankAccountLinkedScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Link Bank: Account Linked',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationLinkBankAccountLinked',
    style: 'main',
    screen: 'registrationLinkBankAccountLinked',
    screen_name: 'registrationLinkBankAccountLinked',
    tier: tier,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Link Bank: Account Linked
 * Next button tapped
 */
export type TrackRegistrationLinkBankAccountLinkedNextButtonTappedType = {
  destination: string
  funnel: string
  funnelVersion?: string
  ctaTitle: string
}

export const trackRegistrationLinkBankAccountLinkedNextButtonTappedPayload = ({
  destination,
  funnel,
  funnelVersion,
  ctaTitle,
}: TrackRegistrationLinkBankAccountLinkedNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Link Bank: Account Linked',
    event_description: 'Next button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationLinkBankAccountLinkedNext',
    style: 'default',
    screen: 'registrationLinkBankAccountLinked',
    screen_name: 'registrationLinkBankAccountLinked',
    destination: destination,
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Link Bank: Account Linked
 * Billing Alert Container Viewed
 */
export const trackRegistrationLinkBankAccountLinkedBillingAlertContainerViewedPayload =
  (): ResultType => {
    const payload = {
      call_type: 'track',
      feature: 'Registration Link Bank: Account Linked',
      event_description: 'Billing Alert Container Viewed',
      platforms: 'web',
      object: 'Container',
      action: 'Viewed',
      object_name: 'registrationLinkBankAccountLinkedBillingAlert',
      screen: 'registrationLinkBankAccountLinked',
    }

    return ['Container Viewed', payload]
  }

/**
 * Registration Manual Link Bank In Progress
 * Screen Viewed
 */
export type TrackRegistrationManualLinkBankInProgressScreenViewedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationManualLinkBankInProgressScreenViewedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationManualLinkBankInProgressScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Manual Link Bank In Progress',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationLinkBankManualInProgress',
    screen: 'registrationLinkBankManualInProgress',
    screen_name: 'registrationLinkBankManualInProgress',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Manual Link Bank In Progress
 * Next button tapped
 */
export type TrackRegistrationManualLinkBankInProgressNextButtonTappedType = {
  destination: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationManualLinkBankInProgressNextButtonTappedPayload = ({
  destination,
  funnel,
  funnelVersion,
}: TrackRegistrationManualLinkBankInProgressNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Manual Link Bank In Progress',
    event_description: 'Next button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationLinkBankManualInProgressNext',
    screen: 'registrationLinkBankManualInProgress',
    screen_name: 'registrationLinkBankManualInProgress',
    destination: destination,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Link Bank: Interstitial
 * Screen Viewed
 */
export enum RegistrationLinkBankInterstitialScreenViewedType {
  'Automatic' = 'automatic',
  'Instant' = 'instant',
}

export type TrackRegistrationLinkBankInterstitialScreenViewedType = {
  tier: string
  funnel: string
  funnelVersion?: string
  type?: RegistrationLinkBankInterstitialScreenViewedType
}

export const trackRegistrationLinkBankInterstitialScreenViewedPayload = ({
  tier,
  funnel,
  funnelVersion,
  type,
}: TrackRegistrationLinkBankInterstitialScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Link Bank: Interstitial',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationLinkBankInterstitial',
    screen: 'registrationLinkBankInterstitial',
    screen_name: 'registrationLinkBankInterstitial',
    tier: tier,
    funnel: funnel,
    funnel_version: funnelVersion,
    type: type,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!type) {
    delete payload.type
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Link Bank: Interstitial
 * Back button tapped
 */
export type TrackRegistrationLinkBankInterstitialBackButtonTappedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationLinkBankInterstitialBackButtonTappedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationLinkBankInterstitialBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Link Bank: Interstitial',
    event_description: 'Back button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationLinkBankInterstitialBack',
    screen: 'registrationLinkBankInterstitial',
    screen_name: 'registrationLinkBankInterstitial',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Link Bank: Interstitial
 * Link automatically button tapped
 */
export enum RegistrationLinkBankInterstitialLinkAutomaticallyButtonTappedType {
  'Automatic' = 'automatic',
  'Instant' = 'instant',
}

export type TrackRegistrationLinkBankInterstitialLinkAutomaticallyButtonTappedType = {
  destination: string
  funnel: string
  funnelVersion?: string
  type?: RegistrationLinkBankInterstitialLinkAutomaticallyButtonTappedType
}

export const trackRegistrationLinkBankInterstitialLinkAutomaticallyButtonTappedPayload = ({
  destination,
  funnel,
  funnelVersion,
  type,
}: TrackRegistrationLinkBankInterstitialLinkAutomaticallyButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Link Bank: Interstitial',
    event_description: 'Link automatically button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationLinkBankInterstitialLinkAutomatically',
    screen: 'registrationLinkBankInterstitial',
    screen_name: 'registrationLinkBankInterstitial',
    destination: destination,
    funnel: funnel,
    funnel_version: funnelVersion,
    type: type,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!type) {
    delete payload.type
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Link Bank: Interstitial
 * Link manually button tapped
 */
export type TrackRegistrationLinkBankInterstitialLinkManuallyButtonTappedType = {
  destination: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationLinkBankInterstitialLinkManuallyButtonTappedPayload = ({
  destination,
  funnel,
  funnelVersion,
}: TrackRegistrationLinkBankInterstitialLinkManuallyButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Link Bank: Interstitial',
    event_description: 'Link manually button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationLinkBankInterstitialLinkManually',
    screen: 'registrationLinkBankInterstitial',
    screen_name: 'registrationLinkBankInterstitial',
    destination: destination,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Link Bank: Manual
 * Screen Viewed
 */
export type TrackRegistrationLinkBankManualScreenViewedType = {
  tier: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationLinkBankManualScreenViewedPayload = ({
  tier,
  funnel,
  funnelVersion,
}: TrackRegistrationLinkBankManualScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Link Bank: Manual',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationLinkBankManual',
    style: 'main',
    screen: 'registrationLinkBankManual',
    screen_name: 'registrationLinkBankManual',
    tier: tier,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Link Bank: Manual
 * Instant Link Button Tapped
 */
export type TrackRegistrationLinkBankManualInstantLinkButtonTappedType = {
  ctaTitle?: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationLinkBankManualInstantLinkButtonTappedPayload = ({
  ctaTitle,
  funnel,
  funnelVersion,
}: TrackRegistrationLinkBankManualInstantLinkButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Link Bank: Manual',
    event_description: 'Instant Link Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationLinkBankManualInstantCTA',
    style: 'text',
    screen: 'registrationLinkBankManual',
    screen_name: 'registrationLinkBankManual',
    destination: 'registrationLinkBankSearch',
    cta_title: ctaTitle,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Link Bank: Manual
 * Link Instantly Reminder Tapped
 */
export type TrackRegistrationLinkBankManualLinkInstantlyReminderTappedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationLinkBankManualLinkInstantlyReminderTappedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationLinkBankManualLinkInstantlyReminderTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Link Bank: Manual',
    event_description: 'Link Instantly Reminder Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationManualRoundUpsReminderLinkAutomatically',
    screen: 'registrationLinkBankManual',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Link Bank: Manual
 * Do Later button tapped
 */
export type TrackRegistrationLinkBankManualDoLaterButtonTappedType = {
  destination: string
  funnel: string
  funnelVersion?: string
  ctaTitle: string
}

export const trackRegistrationLinkBankManualDoLaterButtonTappedPayload = ({
  destination,
  funnel,
  funnelVersion,
  ctaTitle,
}: TrackRegistrationLinkBankManualDoLaterButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Link Bank: Manual',
    event_description: 'Do Later button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationLinkBankManualDoLater',
    style: 'text',
    screen: 'registrationLinkBankManual',
    screen_name: 'registrationLinkBankManual',
    destination: destination,
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Link Bank: Manual
 * Do Later button tapped from Institution List
 */
export type TrackRegistrationLinkBankManualDoLaterButtonTappedFromInstitutionListType = {
  destination: string
  funnel: string
  funnelVersion?: string
  ctaTitle: string
}

export const trackRegistrationLinkBankManualDoLaterButtonTappedFromInstitutionListPayload = ({
  destination,
  funnel,
  funnelVersion,
  ctaTitle,
}: TrackRegistrationLinkBankManualDoLaterButtonTappedFromInstitutionListType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Link Bank: Manual',
    event_description: 'Do Later button tapped from Institution List',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationLinkBankManualDoLaterInstitutionList',
    style: 'text',
    screen: 'registrationLinkBankManual',
    screen_name: 'registrationLinkBankManual',
    destination: destination,
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Link Bank: Manual
 * Next button tapped
 */
export type TrackRegistrationLinkBankManualNextButtonTappedType = {
  destination: string
  funnel: string
  funnelVersion?: string
  ctaTitle: string
}

export const trackRegistrationLinkBankManualNextButtonTappedPayload = ({
  destination,
  funnel,
  funnelVersion,
  ctaTitle,
}: TrackRegistrationLinkBankManualNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Link Bank: Manual',
    event_description: 'Next button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationLinkBankManualNext',
    style: 'default',
    screen: 'registrationLinkBankManual',
    screen_name: 'registrationLinkBankManual',
    destination: destination,
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Link Bank: Manual
 * Back button tapped
 */
export type TrackRegistrationLinkBankManualBackButtonTappedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationLinkBankManualBackButtonTappedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationLinkBankManualBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Link Bank: Manual',
    event_description: 'Back button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationLinkBankManualBack',
    screen: 'registrationLinkBankManual',
    screen_name: 'registrationLinkBankManual',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Link Bank: Search
 * Screen Viewed
 */
export enum RegistrationLinkBankSearchScreenViewedType {
  'Automatic' = 'automatic',
  'Instant' = 'instant',
}

export type TrackRegistrationLinkBankSearchScreenViewedType = {
  tier: string
  funnel: string
  funnelVersion?: string
  type?: RegistrationLinkBankSearchScreenViewedType
}

export const trackRegistrationLinkBankSearchScreenViewedPayload = ({
  tier,
  funnel,
  funnelVersion,
  type,
}: TrackRegistrationLinkBankSearchScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Link Bank: Search',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationLinkBankSearch',
    style: 'main',
    screen: 'registrationLinkBankSearch',
    screen_name: 'registrationLinkBankSearch',
    tier: tier,
    funnel: funnel,
    funnel_version: funnelVersion,
    type: type,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!type) {
    delete payload.type
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Link Bank: Search
 * Bank selected
 */
export type TrackRegistrationLinkBankSearchBankSelectedType = {
  indexPosition: number
  indexPositionTapped: number
  indexCount: number
  ctaTitle: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationLinkBankSearchBankSelectedPayload = ({
  indexPosition,
  indexPositionTapped,
  indexCount,
  ctaTitle,
  funnel,
  funnelVersion,
}: TrackRegistrationLinkBankSearchBankSelectedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Link Bank: Search',
    event_description: 'Bank selected',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationLinkBankSearchBank',
    style: 'cell',
    screen: 'registrationLinkBankSearch',
    screen_name: 'registrationLinkBankSearch',
    destination: 'registrationLinkBankAccountLogin',
    index_position: indexPosition,
    index_position_tapped: indexPositionTapped,
    index_count: indexCount,
    cta_title: ctaTitle,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Link Bank: Search
 * Back button tapped
 */
export type TrackRegistrationLinkBankSearchBackButtonTappedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationLinkBankSearchBackButtonTappedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationLinkBankSearchBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Link Bank: Search',
    event_description: 'Back button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationLinkBankSearchBack',
    style: 'icon',
    screen: 'registrationLinkBankSearch',
    screen_name: 'registrationLinkBankSearch',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Link Bank: Select Checking
 * Checking Acct selected
 */
export type TrackRegistrationLinkBankSelectCheckingCheckingAcctSelectedType = {
  indexPosition: number
  indexPositionTapped: number
  indexCount: number
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationLinkBankSelectCheckingCheckingAcctSelectedPayload = ({
  indexPosition,
  indexPositionTapped,
  indexCount,
  funnel,
  funnelVersion,
}: TrackRegistrationLinkBankSelectCheckingCheckingAcctSelectedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Link Bank: Select Checking',
    event_description: 'Checking Acct selected',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationLinkBankSelectCheckingAccount',
    style: 'cell',
    screen: 'registrationLinkBankSelectChecking',
    screen_name: 'registrationLinkBankSelectChecking',
    destination: 'registrationLinkBankAccountLinked',
    index_position: indexPosition,
    index_position_tapped: indexPositionTapped,
    index_count: indexCount,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Manual Link Survey
 * Screen Viewed
 */
export type TrackRegistrationManualLinkSurveyScreenViewedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationManualLinkSurveyScreenViewedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationManualLinkSurveyScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Manual Link Survey',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationManualLinkSurvey',
    screen: 'registrationManualLinkSurvey',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Manual Link Survey
 * Send Feedback Button Tapped
 */
export type TrackRegistrationManualLinkSurveySendFeedbackButtonTappedType = {
  incentive: string
  ctaTitle?: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationManualLinkSurveySendFeedbackButtonTappedPayload = ({
  incentive,
  ctaTitle,
  funnel,
  funnelVersion,
}: TrackRegistrationManualLinkSurveySendFeedbackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Manual Link Survey',
    event_description: 'Send Feedback Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationManualLinkSurveyNext',
    screen: 'registrationManualLinkSurvey',
    incentive: incentive,
    cta_title: ctaTitle,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Manual Link Survey
 * Close Button Tapped
 */
export type TrackRegistrationManualLinkSurveyCloseButtonTappedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationManualLinkSurveyCloseButtonTappedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationManualLinkSurveyCloseButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Manual Link Survey',
    event_description: 'Close Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationManualLinkSurveyExit',
    screen: 'registrationManualLinkSurvey',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Two Factor Auth
 * Enter Code Screen Viewed
 */
export type TrackRegistrationTwoFactorAuthEnterCodeScreenViewedType = {
  tier: string
  origin: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationTwoFactorAuthEnterCodeScreenViewedPayload = ({
  tier,
  origin,
  funnel,
  funnelVersion,
}: TrackRegistrationTwoFactorAuthEnterCodeScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Two Factor Auth',
    event_description: 'Enter Code Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationTwoFactorAuthEnterCode',
    screen: 'registrationTwoFactorAuthEnterCode',
    tier: tier,
    origin: origin,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Two Factor Auth
 * Enter Code Confirm Button Tapped
 */
export type TrackRegistrationTwoFactorAuthEnterCodeConfirmButtonTappedType = {
  destination: string
  ctaTitle?: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationTwoFactorAuthEnterCodeConfirmButtonTappedPayload = ({
  destination,
  ctaTitle,
  funnel,
  funnelVersion,
}: TrackRegistrationTwoFactorAuthEnterCodeConfirmButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Two Factor Auth',
    event_description: 'Enter Code Confirm Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationTwoFactorAuthEnterCode',
    screen: 'registrationTwoFactorAuthEnterCode',
    destination: destination,
    cta_title: ctaTitle,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Two Factor Auth
 * Enter Code Help Modal Viewed
 */
export type TrackRegistrationTwoFactorAuthEnterCodeHelpModalViewedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationTwoFactorAuthEnterCodeHelpModalViewedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationTwoFactorAuthEnterCodeHelpModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Two Factor Auth',
    event_description: 'Enter Code Help Modal Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationTwoFactorAuthHelp',
    screen: 'registrationTwoFactorAuthEnterCode',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Two Factor Auth
 * Resend Modal Viewed
 */
export type TrackRegistrationTwoFactorAuthResendModalViewedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationTwoFactorAuthResendModalViewedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationTwoFactorAuthResendModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Two Factor Auth',
    event_description: 'Resend Modal Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationTwoFactorAuthResend',
    screen: 'registrationTwoFactorAuthEnterCode',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Two Factor Auth
 * Enter Code Resend Button Tapped
 */
export type TrackRegistrationTwoFactorAuthEnterCodeResendButtonTappedType = {
  ctaTitle?: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationTwoFactorAuthEnterCodeResendButtonTappedPayload = ({
  ctaTitle,
  funnel,
  funnelVersion,
}: TrackRegistrationTwoFactorAuthEnterCodeResendButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Two Factor Auth',
    event_description: 'Enter Code Resend Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationTwoFactorAuthResend',
    screen: 'registrationTwoFactorAuthEnterCode',
    cta_title: ctaTitle,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Two Factor Auth
 * Enter Code Help Button Tapped
 */
export type TrackRegistrationTwoFactorAuthEnterCodeHelpButtonTappedType = {
  ctaTitle?: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationTwoFactorAuthEnterCodeHelpButtonTappedPayload = ({
  ctaTitle,
  funnel,
  funnelVersion,
}: TrackRegistrationTwoFactorAuthEnterCodeHelpButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Two Factor Auth',
    event_description: 'Enter Code Help Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationTwoFactorAuthHelp',
    screen: 'registrationTwoFactorAuthEnterCode',
    cta_title: ctaTitle,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Two Factor Auth
 * Back button tapped
 */
export type TrackRegistrationTwoFactorAuthBackButtonTappedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationTwoFactorAuthBackButtonTappedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationTwoFactorAuthBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Two Factor Auth',
    event_description: 'Back button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationTwoFactorAuthEnterCodeBack',
    style: 'icon',
    screen: 'registrationTwoFactorAuthEnterCode',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Two Factor Auth
 * Help Button Tapped
 */
export type TrackRegistrationTwoFactorAuthHelpButtonTappedType = {
  funnel: string
  origin: string
}

export const trackRegistrationTwoFactorAuthHelpButtonTappedPayload = ({
  funnel,
  origin,
}: TrackRegistrationTwoFactorAuthHelpButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Two Factor Auth',
    event_description: 'Help Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationTwoFactorAuthEnterCodeHelp',
    screen: 'registrationTwoFactorAuthEnterCode',
    funnel: funnel,
    origin: origin,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Two Factor Auth
 * Help Modal Viewed
 */
export type TrackRegistrationTwoFactorAuthHelpModalViewedType = {
  funnel: string
  origin: string
}

export const trackRegistrationTwoFactorAuthHelpModalViewedPayload = ({
  funnel,
  origin,
}: TrackRegistrationTwoFactorAuthHelpModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Two Factor Auth',
    event_description: 'Help Modal Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationTwoFactorAuthEnterCodeHelpModal',
    screen: 'registrationTwoFactorAuthEnterCode',
    funnel: funnel,
    origin: origin,
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Two Factor Auth
 * Help Modal Support
 */
export type TrackRegistrationTwoFactorAuthHelpModalSupportType = {
  funnel: string
  origin: string
}

export const trackRegistrationTwoFactorAuthHelpModalSupportPayload = ({
  funnel,
  origin,
}: TrackRegistrationTwoFactorAuthHelpModalSupportType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Two Factor Auth',
    event_description: 'Help Modal Support',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationTwoFactorAuthEnterCodeModalSupport',
    screen: 'registrationTwoFactorAuthEnterCode',
    funnel: funnel,
    origin: origin,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Two Factor Auth
 * Help Modal Try Again
 */
export type TrackRegistrationTwoFactorAuthHelpModalTryAgainType = {
  funnel: string
  origin: string
}

export const trackRegistrationTwoFactorAuthHelpModalTryAgainPayload = ({
  funnel,
  origin,
}: TrackRegistrationTwoFactorAuthHelpModalTryAgainType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Two Factor Auth',
    event_description: 'Help Modal Try Again',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationTwoFactorAuthEnterCodeModalTryAgain',
    screen: 'registrationTwoFactorAuthEnterCode',
    funnel: funnel,
    origin: origin,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Information: Name
 * Screen Viewed
 */
export type TrackRegistrationInformationNameScreenViewedType = {
  funnel: string
  funnelVersion?: string
  defaultState?: string
}

export const trackRegistrationInformationNameScreenViewedPayload = ({
  funnel,
  funnelVersion,
  defaultState,
}: TrackRegistrationInformationNameScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Name',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationInformationName',
    screen: 'registrationInformationName',
    funnel: funnel,
    funnel_version: funnelVersion,
    default_state: defaultState,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!defaultState) {
    delete payload.default_state
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Information: Name
 * Next Button Tapped
 */
export type TrackRegistrationInformationNameNextButtonTappedType = {
  funnel: string
  funnelVersion?: string
  ctaTitle: string
}

export const trackRegistrationInformationNameNextButtonTappedPayload = ({
  funnel,
  funnelVersion,
  ctaTitle,
}: TrackRegistrationInformationNameNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Name',
    event_description: 'Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInformationNameNext',
    screen: 'registrationInformationName',
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Information: Personal
 * Screen Viewed
 */
export type TrackRegistrationInformationPersonalScreenViewedType = {
  tier: string
  funnel: string
  funnelVersion?: string
  defaultState?: string
}

export const trackRegistrationInformationPersonalScreenViewedPayload = ({
  tier,
  funnel,
  funnelVersion,
  defaultState,
}: TrackRegistrationInformationPersonalScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Personal',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationInformationPersonal',
    style: 'main',
    screen: 'registrationInformationPersonal',
    screen_name: 'registrationInformationPersonal',
    tier: tier,
    funnel: funnel,
    funnel_version: funnelVersion,
    default_state: defaultState,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!defaultState) {
    delete payload.default_state
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Information: Personal
 * Next button tapped
 */
export type TrackRegistrationInformationPersonalNextButtonTappedType = {
  destination: string
  hdyhau?: string
  funnel: string
  funnelVersion?: string
  ctaTitle: string
}

export const trackRegistrationInformationPersonalNextButtonTappedPayload = ({
  destination,
  hdyhau,
  funnel,
  funnelVersion,
  ctaTitle,
}: TrackRegistrationInformationPersonalNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Personal',
    event_description: 'Next button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInformationPersonalNext',
    style: 'default',
    screen: 'registrationInformationPersonal',
    screen_name: 'registrationInformationPersonal',
    destination: destination,
    hdyhau: hdyhau,
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
  }

  if (!hdyhau) {
    delete payload.hdyhau
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Information: Personal
 * Program Agreement Modal Cancelled
 */
export const trackRegistrationInformationPersonalProgramAgreementModalCancelledPayload =
  (): ResultType => {
    const payload = {
      call_type: 'track',
      feature: 'Registration Information: Personal',
      event_description: 'Program Agreement Modal Cancelled',
      platforms: 'web',
      object: 'Button',
      action: 'Tapped',
      object_name: 'registrationInformationPersonalProgramAgreementsCancel',
      screen: 'registrationInformationPersonal',
    }

    return ['Button Tapped', payload]
  }

/**
 * Registration Information: Phone Number
 * Phone Number Screen Viewed
 */
export type TrackRegistrationInformationPhoneNumberPhoneNumberScreenViewedType = {
  funnel: string
  funnelVersion?: string
  defaultState?: string
}

export const trackRegistrationInformationPhoneNumberPhoneNumberScreenViewedPayload = ({
  funnel,
  funnelVersion,
  defaultState,
}: TrackRegistrationInformationPhoneNumberPhoneNumberScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Phone Number',
    event_description: 'Phone Number Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationInformationPhoneNumber',
    screen: 'registrationInformationPhoneNumber',
    funnel: funnel,
    funnel_version: funnelVersion,
    default_state: defaultState,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!defaultState) {
    delete payload.default_state
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Information: Phone Number
 * Phone Number Next Button Tapped
 */
export type TrackRegistrationInformationPhoneNumberPhoneNumberNextButtonTappedType = {
  funnel: string
  funnelVersion?: string
  ctaTitle: string
}

export const trackRegistrationInformationPhoneNumberPhoneNumberNextButtonTappedPayload = ({
  funnel,
  funnelVersion,
  ctaTitle,
}: TrackRegistrationInformationPhoneNumberPhoneNumberNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Phone Number',
    event_description: 'Phone Number Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInformationPhoneNumberNext',
    screen: 'registrationInformationPhoneNumber',
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Information: Phone Number
 * Phone Number Back button tapped
 */
export type TrackRegistrationInformationPhoneNumberPhoneNumberBackButtonTappedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInformationPhoneNumberPhoneNumberBackButtonTappedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationInformationPhoneNumberPhoneNumberBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Phone Number',
    event_description: 'Phone Number Back button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInformationPhoneNumberBack',
    screen: 'registrationInformationPhoneNumber',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Information: Phone Number
 * Phone Number Invalid
 */
export type TrackRegistrationInformationPhoneNumberPhoneNumberInvalidType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInformationPhoneNumberPhoneNumberInvalidPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationInformationPhoneNumberPhoneNumberInvalidType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Phone Number',
    event_description: 'Phone Number Invalid',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationPlaidLayerPhoneNumberInvalid',
    screen: 'registrationInformationPhoneNumber',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Information: Phone Number
 * Phone Number Verification
 */
export type TrackRegistrationInformationPhoneNumberPhoneNumberVerificationType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInformationPhoneNumberPhoneNumberVerificationPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationInformationPhoneNumberPhoneNumberVerificationType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Phone Number',
    event_description: 'Phone Number Verification',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationPlaidLayerPhoneNumberVerification',
    screen: 'registrationInformationPhoneNumber',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Information: Phone Number
 * Plaid Layer Eligible
 */
export type TrackRegistrationInformationPhoneNumberPlaidLayerEligibleType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInformationPhoneNumberPlaidLayerEligiblePayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationInformationPhoneNumberPlaidLayerEligibleType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Phone Number',
    event_description: 'Plaid Layer Eligible',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationPlaidLayerEligible',
    screen: 'registrationInformationPhoneNumber',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Information: Phone Number
 * Plaid Layer Eligible Cancel
 */
export type TrackRegistrationInformationPhoneNumberPlaidLayerEligibleCancelType = {
  funnel: string
  funnelVersion?: string
  requestId?: string
  institutionId?: string
  institutionName?: string
  exitStatus?: string
  status?: string
  linkSessionId?: string
}

export const trackRegistrationInformationPhoneNumberPlaidLayerEligibleCancelPayload = ({
  funnel,
  funnelVersion,
  requestId,
  institutionId,
  institutionName,
  exitStatus,
  status,
  linkSessionId,
}: TrackRegistrationInformationPhoneNumberPlaidLayerEligibleCancelType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Phone Number',
    event_description: 'Plaid Layer Eligible Cancel',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationPlaidLayerEligibleCancel',
    screen: 'registrationInformationPhoneNumber',
    funnel: funnel,
    funnel_version: funnelVersion,
    request_id: requestId,
    institution_id: institutionId,
    institution_name: institutionName,
    exit_status: exitStatus,
    status: status,
    link_session_id: linkSessionId,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!requestId) {
    delete payload.request_id
  }

  if (!institutionId) {
    delete payload.institution_id
  }

  if (!institutionName) {
    delete payload.institution_name
  }

  if (!exitStatus) {
    delete payload.exit_status
  }

  if (!status) {
    delete payload.status
  }

  if (!linkSessionId) {
    delete payload.link_session_id
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Information: Phone Number
 * Plaid Layer Eligible Authentication Failed
 */
export type TrackRegistrationInformationPhoneNumberPlaidLayerEligibleAuthenticationFailedType = {
  funnel: string
  funnelVersion?: string
  linkSessionId?: string
}

export const trackRegistrationInformationPhoneNumberPlaidLayerEligibleAuthenticationFailedPayload =
  ({
    funnel,
    funnelVersion,
    linkSessionId,
  }: TrackRegistrationInformationPhoneNumberPlaidLayerEligibleAuthenticationFailedType): ResultType => {
    const payload = {
      call_type: 'track',
      feature: 'Registration Information: Phone Number',
      event_description: 'Plaid Layer Eligible Authentication Failed',
      platforms: 'web',
      object: 'Container',
      action: 'Viewed',
      object_name: 'registrationPlaidLayerEligibleAuthenticationFailed',
      screen: 'registrationInformationPhoneNumber',
      funnel: funnel,
      funnel_version: funnelVersion,
      link_session_id: linkSessionId,
    }

    if (!funnelVersion) {
      delete payload.funnel_version
    }

    if (!linkSessionId) {
      delete payload.link_session_id
    }

    return ['Container Viewed', payload]
  }

/**
 * Registration Information: Phone Number
 * Plaid Layer Link Success
 */
export type TrackRegistrationInformationPhoneNumberPlaidLayerLinkSuccessType = {
  funnel: string
  funnelVersion?: string
  institutionId?: string
  institutionName?: string
  linkSessionId?: string
}

export const trackRegistrationInformationPhoneNumberPlaidLayerLinkSuccessPayload = ({
  funnel,
  funnelVersion,
  institutionId,
  institutionName,
  linkSessionId,
}: TrackRegistrationInformationPhoneNumberPlaidLayerLinkSuccessType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Phone Number',
    event_description: 'Plaid Layer Link Success',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationPlaidLayerLinkSuccess',
    screen: 'registrationInformationPhoneNumber',
    funnel: funnel,
    funnel_version: funnelVersion,
    institution_id: institutionId,
    institution_name: institutionName,
    link_session_id: linkSessionId,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!institutionId) {
    delete payload.institution_id
  }

  if (!institutionName) {
    delete payload.institution_name
  }

  if (!linkSessionId) {
    delete payload.link_session_id
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Information: Phone Number
 * Plaid Layer Link Exit
 */
export type TrackRegistrationInformationPhoneNumberPlaidLayerLinkExitType = {
  errorCode?: string
  errorDetails?: string
  errorMessage?: string
  funnel: string
  funnelVersion?: string
  requestId?: string
  institutionId?: string
  institutionName?: string
  linkSessionId?: string
  exitStatus?: string
}

export const trackRegistrationInformationPhoneNumberPlaidLayerLinkExitPayload = ({
  errorCode,
  errorDetails,
  errorMessage,
  funnel,
  funnelVersion,
  requestId,
  institutionId,
  institutionName,
  linkSessionId,
  exitStatus,
}: TrackRegistrationInformationPhoneNumberPlaidLayerLinkExitType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Phone Number',
    event_description: 'Plaid Layer Link Exit',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationPlaidLayerLinkExit',
    screen: 'registrationInformationPhoneNumber',
    error_code: errorCode,
    error_details: errorDetails,
    error_message: errorMessage,
    funnel: funnel,
    funnel_version: funnelVersion,
    request_id: requestId,
    institution_id: institutionId,
    institution_name: institutionName,
    link_session_id: linkSessionId,
    exit_status: exitStatus,
  }

  if (!errorCode) {
    delete payload.error_code
  }

  if (!errorDetails) {
    delete payload.error_details
  }

  if (!errorMessage) {
    delete payload.error_message
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!requestId) {
    delete payload.request_id
  }

  if (!institutionId) {
    delete payload.institution_id
  }

  if (!institutionName) {
    delete payload.institution_name
  }

  if (!linkSessionId) {
    delete payload.link_session_id
  }

  if (!exitStatus) {
    delete payload.exit_status
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Information: Phone Number
 * Plaid Layer Eligible Splash Viewed
 */
export type TrackRegistrationInformationPhoneNumberPlaidLayerEligibleSplashViewedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInformationPhoneNumberPlaidLayerEligibleSplashViewedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationInformationPhoneNumberPlaidLayerEligibleSplashViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Phone Number',
    event_description: 'Plaid Layer Eligible Splash Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationPlaidLayerEligibleSplash',
    screen: 'registrationInformationPhoneNumber',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Information: Phone Number
 * Plaid Layer Eligible Splash Continue
 */
export type TrackRegistrationInformationPhoneNumberPlaidLayerEligibleSplashContinueType = {
  ctaTitle: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInformationPhoneNumberPlaidLayerEligibleSplashContinuePayload = ({
  ctaTitle,
  funnel,
  funnelVersion,
}: TrackRegistrationInformationPhoneNumberPlaidLayerEligibleSplashContinueType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Phone Number',
    event_description: 'Plaid Layer Eligible Splash Continue',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationPlaidLayerEligibleSplashContinue',
    screen: 'registrationInformationPhoneNumber',
    cta_title: ctaTitle,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Information: Phone Number
 * Plaid Layer Eligible Splash Close
 */
export type TrackRegistrationInformationPhoneNumberPlaidLayerEligibleSplashCloseType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInformationPhoneNumberPlaidLayerEligibleSplashClosePayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationInformationPhoneNumberPlaidLayerEligibleSplashCloseType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Phone Number',
    event_description: 'Plaid Layer Eligible Splash Close',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationPlaidLayerEligibleSplashClose',
    screen: 'registrationInformationPhoneNumber',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Information: Phone Number
 * Plaid Layer Phone Verified Viewed
 */
export type TrackRegistrationInformationPhoneNumberPlaidLayerPhoneVerifiedViewedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInformationPhoneNumberPlaidLayerPhoneVerifiedViewedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationInformationPhoneNumberPlaidLayerPhoneVerifiedViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Phone Number',
    event_description: 'Plaid Layer Phone Verified Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationPlaidLayerPhoneVerified',
    screen: 'registrationInformationPhoneNumber',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Portfolio: Breakdown
 * Screen Viewed
 */
export type TrackRegistrationPortfolioBreakdownScreenViewedType = {
  tier: string
  funnel: string
  funnelVersion?: string
  portfolioRisk: string
}

export const trackRegistrationPortfolioBreakdownScreenViewedPayload = ({
  tier,
  funnel,
  funnelVersion,
  portfolioRisk,
}: TrackRegistrationPortfolioBreakdownScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Portfolio: Breakdown',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationPortfolioBreakdown',
    style: 'main',
    screen: 'registrationPortfolioBreakdown',
    screen_name: 'registrationPortfolioBreakdown',
    tier: tier,
    funnel: funnel,
    funnel_version: funnelVersion,
    portfolio_risk: portfolioRisk,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Portfolio: Breakdown
 * Next button tapped
 */
export type TrackRegistrationPortfolioBreakdownNextButtonTappedType = {
  destination: string
  funnel: string
  funnelVersion?: string
  portfolioRisk: string
  ctaTitle: string
}

export const trackRegistrationPortfolioBreakdownNextButtonTappedPayload = ({
  destination,
  funnel,
  funnelVersion,
  portfolioRisk,
  ctaTitle,
}: TrackRegistrationPortfolioBreakdownNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Portfolio: Breakdown',
    event_description: 'Next button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationPortfolioBreakdownNext',
    style: 'default',
    screen: 'registrationPortfolioBreakdown',
    screen_name: 'registrationPortfolioBreakdown',
    destination: destination,
    funnel: funnel,
    funnel_version: funnelVersion,
    portfolio_risk: portfolioRisk,
    cta_title: ctaTitle,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Portfolio: Breakdown
 * Error Modal Viewed
 */
export type TrackRegistrationPortfolioBreakdownErrorModalViewedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationPortfolioBreakdownErrorModalViewedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationPortfolioBreakdownErrorModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Portfolio: Breakdown',
    event_description: 'Error Modal Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationPortfolioBreakdownErrorModal',
    screen: 'registrationPortfolioBreakdown',
    screen_name: 'registrationPortfolioBreakdown',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Portfolio: Breakdown
 * Error Modal Confirmed
 */
export type TrackRegistrationPortfolioBreakdownErrorModalConfirmedType = {
  funnel: string
  funnelVersion?: string
  ctaTitle?: string
}

export const trackRegistrationPortfolioBreakdownErrorModalConfirmedPayload = ({
  funnel,
  funnelVersion,
  ctaTitle,
}: TrackRegistrationPortfolioBreakdownErrorModalConfirmedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Portfolio: Breakdown',
    event_description: 'Error Modal Confirmed',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationPortfolioBreakdownErrorModalConfirm',
    screen: 'registrationPortfolioBreakdown',
    screen_name: 'registrationPortfolioBreakdownErrorModal',
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Portfolio: Breakdown
 * Error Modal Exited
 */
export type TrackRegistrationPortfolioBreakdownErrorModalExitedType = {
  funnel: string
  funnelVersion?: string
  ctaTitle?: string
}

export const trackRegistrationPortfolioBreakdownErrorModalExitedPayload = ({
  funnel,
  funnelVersion,
  ctaTitle,
}: TrackRegistrationPortfolioBreakdownErrorModalExitedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Portfolio: Breakdown',
    event_description: 'Error Modal Exited',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationPortfolioBreakdownErrorModalExit',
    screen: 'registrationPortfolioBreakdown',
    screen_name: 'registrationPortfolioBreakdownErrorModal',
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Product Onboarding
 * Screen Viewed
 */
export type TrackRegistrationProductOnboardingScreenViewedType = {
  tier?: string
  context: string
  earlySetup: string
  investSetup: string
  spendSetup: string
  laterSetup: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationProductOnboardingScreenViewedPayload = ({
  tier,
  context,
  earlySetup,
  investSetup,
  spendSetup,
  laterSetup,
  funnel,
  funnelVersion,
}: TrackRegistrationProductOnboardingScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Product Onboarding',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationProductOnboarding',
    screen: 'registrationProductOnboarding',
    screen_name: 'registrationProductOnboarding',
    tier: tier,
    context: context,
    earlySetup: earlySetup,
    investSetup: investSetup,
    spendSetup: spendSetup,
    laterSetup: laterSetup,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!tier) {
    delete payload.tier
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Product Onboarding
 * Skip Button Tapped
 */
export type TrackRegistrationProductOnboardingSkipButtonTappedType = {
  earlySetup: string
  investSetup: string
  spendSetup: string
  laterSetup: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationProductOnboardingSkipButtonTappedPayload = ({
  earlySetup,
  investSetup,
  spendSetup,
  laterSetup,
  funnel,
  funnelVersion,
}: TrackRegistrationProductOnboardingSkipButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Product Onboarding',
    event_description: 'Skip Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationProductOnboardingSkip',
    screen: 'registrationProductOnboarding',
    screen_name: 'registrationProductOnboarding',
    earlySetup: earlySetup,
    investSetup: investSetup,
    spendSetup: spendSetup,
    laterSetup: laterSetup,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Product Onboarding
 * Shortcut Tapped
 */
export type TrackRegistrationProductOnboardingShortcutTappedType = {
  product: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationProductOnboardingShortcutTappedPayload = ({
  product,
  funnel,
  funnelVersion,
}: TrackRegistrationProductOnboardingShortcutTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Product Onboarding',
    event_description: 'Shortcut Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationProductOnboardingShortcut',
    screen: 'registrationProductOnboarding',
    screen_name: 'registrationProductOnboarding',
    product: product,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Product Onboarding
 * Done Button Tapped
 */
export type TrackRegistrationProductOnboardingDoneButtonTappedType = {
  context: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationProductOnboardingDoneButtonTappedPayload = ({
  context,
  funnel,
  funnelVersion,
}: TrackRegistrationProductOnboardingDoneButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Product Onboarding',
    event_description: 'Done Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationProductOnboardingDone',
    screen: 'registrationProductOnboarding',
    screen_name: 'registrationProductOnboarding',
    context: context,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration: Promo Code
 * Enter Code CTA Tapped
 */
export enum RegistrationPromoCodeEnterCodeCtaTappedState {
  'Enter_new_code' = 'enter_new_code',
  'Edit_code' = 'edit_code',
}

export type TrackRegistrationPromoCodeEnterCodeCtaTappedType = {
  promotion: string
  ctaTitle: string
  state: RegistrationPromoCodeEnterCodeCtaTappedState
}

export const trackRegistrationPromoCodeEnterCodeCtaTappedPayload = ({
  promotion,
  ctaTitle,
  state,
}: TrackRegistrationPromoCodeEnterCodeCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration: Promo Code',
    event_description: 'Enter Code CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationCreateAccountChangePromoCodes',
    screen: 'registrationCreateAccount',
    promotion: promotion,
    cta_title: ctaTitle,
    state: state,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration: Promo Code
 * Container Viewed
 */
export enum RegistrationPromoCodeContainerViewedState {
  'Enter_new_code' = 'enter_new_code',
  'Edit_code' = 'edit_code',
}

export type TrackRegistrationPromoCodeContainerViewedType = {
  promotion: string
  type: string
  state: RegistrationPromoCodeContainerViewedState
}

export const trackRegistrationPromoCodeContainerViewedPayload = ({
  promotion,
  type,
  state,
}: TrackRegistrationPromoCodeContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration: Promo Code',
    event_description: 'Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationCreateAccountPromoCodes',
    screen: 'registrationCreateAccount',
    promotion: promotion,
    type: type,
    state: state,
  }

  return ['Container Viewed', payload]
}

/**
 * Registration: Promo Code
 * Drawer Viewed
 */
export enum RegistrationPromoCodeDrawerViewedType {
  'Enter_new_code' = 'enter_new_code',
  'Edit_code' = 'edit_code',
}

export type TrackRegistrationPromoCodeDrawerViewedType = {
  promotion: string
  type: RegistrationPromoCodeDrawerViewedType
}

export const trackRegistrationPromoCodeDrawerViewedPayload = ({
  promotion,
  type,
}: TrackRegistrationPromoCodeDrawerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration: Promo Code',
    event_description: 'Drawer Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationCreateAccountPromoCodesDrawer',
    screen: 'registrationCreateAccount',
    promotion: promotion,
    type: type,
  }

  return ['Container Viewed', payload]
}

/**
 * Registration: Promo Code
 * Eligibility Drawer Viewed
 */
export type TrackRegistrationPromoCodeEligibilityDrawerViewedType = {
  promotion: string
  url?: string
}

export const trackRegistrationPromoCodeEligibilityDrawerViewedPayload = ({
  promotion,
  url,
}: TrackRegistrationPromoCodeEligibilityDrawerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration: Promo Code',
    event_description: 'Eligibility Drawer Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationCreateAccountPromoCodesEligibilityDrawer',
    screen: 'registrationCreateAccount',
    promotion: promotion,
    url: url,
  }

  if (!url) {
    delete payload.url
  }

  return ['Container Viewed', payload]
}

/**
 * Registration: Promo Code
 * Terms and Conditions Link Tapped
 */
export type TrackRegistrationPromoCodeTermsAndConditionsLinkTappedType = {
  promotion: string
  url?: string
}

export const trackRegistrationPromoCodeTermsAndConditionsLinkTappedPayload = ({
  promotion,
  url,
}: TrackRegistrationPromoCodeTermsAndConditionsLinkTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration: Promo Code',
    event_description: 'Terms and Conditions Link Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationCreateAccountPromoCodesTermsAndConditions',
    screen: 'registrationCreateAccount',
    promotion: promotion,
    url: url,
  }

  if (!url) {
    delete payload.url
  }

  return ['Button Tapped', payload]
}

/**
 * Registration: Promo Code
 * Skip CTA Tapped
 */
export const trackRegistrationPromoCodeSkipCtaTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration: Promo Code',
    event_description: 'Skip CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationCreateAccountPromoCodesDrawerSkip',
    screen: 'registrationCreateAccount',
  }

  return ['Button Tapped', payload]
}

/**
 * Registration: Promo Code
 * Next CTA Tapped
 */
export type TrackRegistrationPromoCodeNextCtaTappedType = {
  promotion: string
}

export const trackRegistrationPromoCodeNextCtaTappedPayload = ({
  promotion,
}: TrackRegistrationPromoCodeNextCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration: Promo Code',
    event_description: 'Next CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationCreateAccountPromoCodesNext',
    screen: 'registrationCreateAccount',
    promotion: promotion,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration: Promo Code
 * Error Received
 */
export type TrackRegistrationPromoCodeErrorReceivedType = {
  promotion: string
  errorMessage?: string
  errorCode?: string
}

export const trackRegistrationPromoCodeErrorReceivedPayload = ({
  promotion,
  errorMessage,
  errorCode,
}: TrackRegistrationPromoCodeErrorReceivedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration: Promo Code',
    event_description: 'Error Received',
    platforms: 'web',
    object: 'Error',
    action: 'Received',
    object_name: 'registrationCreateAccountPromoCodesError',
    screen: 'registrationCreateAccount',
    promotion: promotion,
    error_message: errorMessage,
    error_code: errorCode,
  }

  if (!errorMessage) {
    delete payload.error_message
  }

  if (!errorCode) {
    delete payload.error_code
  }

  return ['Error Received', payload]
}

/**
 * Registration Information: Residential Address
 * Screen Viewed
 */
export type TrackRegistrationInformationResidentialAddressScreenViewedType = {
  funnel: string
  funnelVersion?: string
  defaultState?: string
}

export const trackRegistrationInformationResidentialAddressScreenViewedPayload = ({
  funnel,
  funnelVersion,
  defaultState,
}: TrackRegistrationInformationResidentialAddressScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Residential Address',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationInformationResidentialAddress',
    screen: 'registrationInformationResidentialAddress',
    funnel: funnel,
    funnel_version: funnelVersion,
    default_state: defaultState,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!defaultState) {
    delete payload.default_state
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Information: Residential Address
 * Next Button Tapped
 */
export type TrackRegistrationInformationResidentialAddressNextButtonTappedType = {
  funnel: string
  funnelVersion?: string
  ctaTitle: string
}

export const trackRegistrationInformationResidentialAddressNextButtonTappedPayload = ({
  funnel,
  funnelVersion,
  ctaTitle,
}: TrackRegistrationInformationResidentialAddressNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Residential Address',
    event_description: 'Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInformationResidentialAddressNext',
    screen: 'registrationInformationResidentialAddress',
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Information: Residential Address
 * Back button tapped
 */
export type TrackRegistrationInformationResidentialAddressBackButtonTappedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInformationResidentialAddressBackButtonTappedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationInformationResidentialAddressBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: Residential Address',
    event_description: 'Back button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInformationResidentialAddressBack',
    screen: 'registrationInformationResidentialAddress',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Past Round-Ups
 * Screen Viewed
 */
export type TrackRegistrationPastRoundUpsScreenViewedType = {
  tier: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationPastRoundUpsScreenViewedPayload = ({
  tier,
  funnel,
  funnelVersion,
}: TrackRegistrationPastRoundUpsScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Past Round-Ups',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationRoundUps',
    style: 'main',
    screen: 'registrationRoundUps',
    screen_name: 'registrationRoundUps',
    tier: tier,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Past Round-Ups
 * Skip button tapped
 */
export type TrackRegistrationPastRoundUpsSkipButtonTappedType = {
  destination: string
  funnel: string
  funnelVersion?: string
  ctaTitle: string
}

export const trackRegistrationPastRoundUpsSkipButtonTappedPayload = ({
  destination,
  funnel,
  funnelVersion,
  ctaTitle,
}: TrackRegistrationPastRoundUpsSkipButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Past Round-Ups',
    event_description: 'Skip button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationRoundUpsSkip',
    style: 'text',
    screen: 'registrationRoundUps',
    screen_name: 'registrationRoundUps',
    destination: destination,
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Past Round-Ups
 * Next button tapped
 */
export type TrackRegistrationPastRoundUpsNextButtonTappedType = {
  destination: string
  funnel: string
  funnelVersion?: string
  ctaTitle: string
}

export const trackRegistrationPastRoundUpsNextButtonTappedPayload = ({
  destination,
  funnel,
  funnelVersion,
  ctaTitle,
}: TrackRegistrationPastRoundUpsNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Past Round-Ups',
    event_description: 'Next button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationRoundUpsNext',
    style: 'default',
    screen: 'registrationRoundUps',
    screen_name: 'registrationRoundUps',
    destination: destination,
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Past Round-Ups
 * Round-Ups Modal Viewed
 */
export type TrackRegistrationPastRoundUpsRoundUpsModalViewedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationPastRoundUpsRoundUpsModalViewedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationPastRoundUpsRoundUpsModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Past Round-Ups',
    event_description: 'Round-Ups Modal Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationRoundUpsModal',
    screen: 'registrationRoundUps',
    screen_name: 'registrationRoundUps',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Past Round-Ups
 * Round-Ups Modal Confirmed
 */
export type TrackRegistrationPastRoundUpsRoundUpsModalConfirmedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationPastRoundUpsRoundUpsModalConfirmedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationPastRoundUpsRoundUpsModalConfirmedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Past Round-Ups',
    event_description: 'Round-Ups Modal Confirmed',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationRoundUpsModalConfirm',
    screen: 'registrationRoundUps',
    screen_name: 'registrationRoundUps',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration: Round-Ups Interstitial
 * Screen Viewed
 */
export type TrackRegistrationRoundUpsInterstitialScreenViewedType = {
  tier: string
  funnel: string
  funnelVersion?: string
  incentive?: string
}

export const trackRegistrationRoundUpsInterstitialScreenViewedPayload = ({
  tier,
  funnel,
  funnelVersion,
  incentive,
}: TrackRegistrationRoundUpsInterstitialScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration: Round-Ups Interstitial',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationRoundUpsInterstitial',
    style: 'main',
    screen: 'registrationRoundUpsInterstitial',
    tier: tier,
    funnel: funnel,
    funnel_version: funnelVersion,
    incentive: incentive,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration: Round-Ups Interstitial
 * Next button tapped
 */
export type TrackRegistrationRoundUpsInterstitialNextButtonTappedType = {
  destination: string
  funnel: string
  funnelVersion?: string
  ctaTitle: string
  incentive?: string
}

export const trackRegistrationRoundUpsInterstitialNextButtonTappedPayload = ({
  destination,
  funnel,
  funnelVersion,
  ctaTitle,
  incentive,
}: TrackRegistrationRoundUpsInterstitialNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration: Round-Ups Interstitial',
    event_description: 'Next button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationRoundUpsInterstitialNext',
    style: 'default',
    screen: 'registrationRoundUpsInterstitial',
    destination: destination,
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
    incentive: incentive,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Button Tapped', payload]
}

/**
 * Registration: Round-Ups Interstitial
 * Skip Button Tapped
 */
export type TrackRegistrationRoundUpsInterstitialSkipButtonTappedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationRoundUpsInterstitialSkipButtonTappedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationRoundUpsInterstitialSkipButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration: Round-Ups Interstitial',
    event_description: 'Skip Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationRoundUpsInterstitialSkip',
    screen: 'registrationRoundUpsInterstitial',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Information: SSN
 * Screen Viewed
 */
export type TrackRegistrationInformationSsnScreenViewedType = {
  tier: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInformationSsnScreenViewedPayload = ({
  tier,
  funnel,
  funnelVersion,
}: TrackRegistrationInformationSsnScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: SSN',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationInformationSSN',
    style: 'main',
    screen: 'registrationInformationSSN',
    screen_name: 'registrationInformationSSN',
    tier: tier,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Information: SSN
 * Next button tapped
 */
export type TrackRegistrationInformationSsnNextButtonTappedType = {
  destination: string
  funnel: string
  funnelVersion?: string
  ctaTitle: string
}

export const trackRegistrationInformationSsnNextButtonTappedPayload = ({
  destination,
  funnel,
  funnelVersion,
  ctaTitle,
}: TrackRegistrationInformationSsnNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: SSN',
    event_description: 'Next button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInformationSSNNext',
    style: 'default',
    screen: 'registrationInformationSSN',
    screen_name: 'registrationInformationSSN',
    destination: destination,
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Information: SSN
 * Back Button Tapped
 */
export type TrackRegistrationInformationSsnBackButtonTappedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationInformationSsnBackButtonTappedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationInformationSsnBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Information: SSN',
    event_description: 'Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationInformationSSNBack',
    screen: 'registrationInformationSSN',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Subscription Active
 * Screen Viewed
 */
export type TrackRegistrationSubscriptionActiveScreenViewedType = {
  tier: string
  funnel: string
  funnelVersion?: string
  context?: string
}

export const trackRegistrationSubscriptionActiveScreenViewedPayload = ({
  tier,
  funnel,
  funnelVersion,
  context,
}: TrackRegistrationSubscriptionActiveScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Subscription Active',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationSubscriptionActive',
    screen: 'registrationSubscriptionActive',
    tier: tier,
    funnel: funnel,
    funnel_version: funnelVersion,
    context: context,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!context) {
    delete payload.context
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Subscription Active
 * Next Button Tapped
 */
export type TrackRegistrationSubscriptionActiveNextButtonTappedType = {
  funnel: string
  funnelVersion?: string
  ctaTitle: string
}

export const trackRegistrationSubscriptionActiveNextButtonTappedPayload = ({
  funnel,
  funnelVersion,
  ctaTitle,
}: TrackRegistrationSubscriptionActiveNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Subscription Active',
    event_description: 'Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationSubscriptionActiveNext',
    screen: 'registrationSubscriptionActive',
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Success
 * Screen Viewed
 */
export type TrackRegistrationSuccessScreenViewedType = {
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationSuccessScreenViewedPayload = ({
  funnel,
  funnelVersion,
}: TrackRegistrationSuccessScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Success',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationSuccess',
    screen: 'registrationSuccess',
    screen_name: 'registrationSuccess',
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Portfolio: Questions
 * Screen Viewed
 */
export type TrackRegistrationPortfolioQuestionsScreenViewedType = {
  tier: string
  funnel: string
  funnelVersion?: string
  type: string
}

export const trackRegistrationPortfolioQuestionsScreenViewedPayload = ({
  tier,
  funnel,
  funnelVersion,
  type,
}: TrackRegistrationPortfolioQuestionsScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Portfolio: Questions',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationPortfolioQuestions',
    style: 'main',
    screen: 'registrationPortfolioQuestions',
    tier: tier,
    funnel: funnel,
    funnel_version: funnelVersion,
    type: type,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Portfolio: Questions
 * Next button tapped
 */
export enum RegistrationPortfolioQuestionsNextButtonTappedIncentive {
  'Early_opt_in' = 'early_opt_in',
  'Early_opt_out' = 'early_opt_out',
  'Yes' = 'yes',
  'No' = 'no',
}

export type TrackRegistrationPortfolioQuestionsNextButtonTappedType = {
  destination: string
  funnel: string
  funnelVersion?: string
  ctaTitle: string
  incentive?: RegistrationPortfolioQuestionsNextButtonTappedIncentive
  type: string
  state: string
}

export const trackRegistrationPortfolioQuestionsNextButtonTappedPayload = ({
  destination,
  funnel,
  funnelVersion,
  ctaTitle,
  incentive,
  type,
  state,
}: TrackRegistrationPortfolioQuestionsNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Portfolio: Questions',
    event_description: 'Next button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationPortfolioQuestionsNext',
    style: 'default',
    screen: 'registrationPortfolioQuestions',
    destination: destination,
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
    incentive: incentive,
    type: type,
    state: state,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Portfolio: Questions
 * Back Button Tapped
 */
export type TrackRegistrationPortfolioQuestionsBackButtonTappedType = {
  funnel: string
  funnelVersion?: string
  type: string
  destination: string
}

export const trackRegistrationPortfolioQuestionsBackButtonTappedPayload = ({
  funnel,
  funnelVersion,
  type,
  destination,
}: TrackRegistrationPortfolioQuestionsBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Portfolio: Questions',
    event_description: 'Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationPortfolioQuestionsBack',
    screen: 'registrationPortfolioQuestions',
    funnel: funnel,
    funnel_version: funnelVersion,
    type: type,
    destination: destination,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Portfolio: Questions
 * Skip Button Tapped
 */
export type TrackRegistrationPortfolioQuestionsSkipButtonTappedType = {
  funnel: string
  funnelVersion?: string
  type: string
  destination: string
}

export const trackRegistrationPortfolioQuestionsSkipButtonTappedPayload = ({
  funnel,
  funnelVersion,
  type,
  destination,
}: TrackRegistrationPortfolioQuestionsSkipButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Portfolio: Questions',
    event_description: 'Skip Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationPortfolioQuestionSkip',
    screen: 'registrationPortfolioQuestions',
    funnel: funnel,
    funnel_version: funnelVersion,
    type: type,
    destination: destination,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Screen Enum Values
 * To be used in screen parameters
 */
export enum ScreenEnums {
  BankCardOrderAddressNotFound = 'bankCardOrderAddressNotFound',
  BankCardOrderEditAddressInput = 'bankCardOrderEditAddressInput',
  BankCardOrderSuggestedAddress = 'bankCardOrderSuggestedAddress',
  BenefitsLander = 'benefitsLander',
  BenefitsWillLander = 'benefitsWillLander',
  FoundMoneyRecentActivity = 'foundMoneyRecentActivity',
  GoHenryLander = 'goHenryLander',
  InvestOnboardingRoundUpsAutomaticVsManual = 'investOnboardingRoundUpsAutomaticVsManual',
  LaterInitialInvestmentOneTimeCustom = 'laterInitialInvestmentOneTimeCustom',
  LaterRegistrationCongratulations = 'laterRegistrationCongratulations',
  LaterRegistrationIRAInfoAnimation = 'laterRegistrationIRAInfoAnimation',
  LaterRegistrationIRARecommendation = 'laterRegistrationIRARecommendation',
  LaterRegistrationInterstitial = 'laterRegistrationInterstitial',
  LaterRegistrationInvestmentInitialStateModal = 'laterRegistrationInvestmentInitialStateModal',
  LaterRegistrationInvestorQuestions = 'laterRegistrationInvestorQuestions',
  LaterRegistrationOneTimeInvestment = 'laterRegistrationOneTimeInvestment',
  LaterRegistrationRecurringInvestment = 'laterRegistrationRecurringInvestment',
  LifeInsuranceContactSupport = 'lifeInsuranceContactSupport',
  LifeInsuranceLander = 'lifeInsuranceLander',
  OAuthInterstitial = 'oAuthInterstitial',
  PlaidLinkError = 'plaidLinkError',
  ProductUpgradeLander = 'productUpgradeLander',
  RecommendedIRA = 'recommendedIRA',
  RegistrationAddressConfirmation = 'registrationAddressConfirmation',
  RegistrationAddressNotFound = 'registrationAddressNotFound',
  RegistrationChooseSubscription = 'registrationChooseSubscription',
  RegistrationChooseSubscriptionComparePlans = 'registrationChooseSubscriptionComparePlans',
  RegistrationCreateAccount = 'registrationCreateAccount',
  RegistrationCreateAccountAgreementModal = 'registrationCreateAccountAgreementModal',
  RegistrationCreateAccountPassword = 'registrationCreateAccountPassword',
  RegistrationCreateAccountVerifyEmail = 'registrationCreateAccountVerifyEmail',
  RegistrationHowDidYouHearAboutUs = 'registrationHowDidYouHearAboutUs',
  RegistrationInformationContact = 'registrationInformationContact',
  RegistrationInformationDob = 'registrationInformationDob',
  RegistrationInformationInvestorQuestions = 'registrationInformationInvestorQuestions',
  RegistrationInformationName = 'registrationInformationName',
  RegistrationInformationPersonal = 'registrationInformationPersonal',
  RegistrationInformationPhoneNumber = 'registrationInformationPhoneNumber',
  RegistrationInformationResidentialAddress = 'registrationInformationResidentialAddress',
  RegistrationInformationSSN = 'registrationInformationSSN',
  RegistrationInitialInvestmentOneTime = 'registrationInitialInvestmentOneTime',
  RegistrationInitialInvestmentOneTimeCustom = 'registrationInitialInvestmentOneTimeCustom',
  RegistrationInitialInvestmentRecurring = 'registrationInitialInvestmentRecurring',
  RegistrationInitialInvestmentRecurringConfirmAmount = 'registrationInitialInvestmentRecurringConfirmAmount',
  RegistrationInvestInterstitial = 'registrationInvestInterstitial',
  RegistrationLinkBankAccountLinked = 'registrationLinkBankAccountLinked',
  RegistrationLinkBankInterstitial = 'registrationLinkBankInterstitial',
  RegistrationLinkBankManual = 'registrationLinkBankManual',
  RegistrationLinkBankManualInProgress = 'registrationLinkBankManualInProgress',
  RegistrationLinkBankSearch = 'registrationLinkBankSearch',
  RegistrationManualLinkSurvey = 'registrationManualLinkSurvey',
  RegistrationPortfolioBreakdown = 'registrationPortfolioBreakdown',
  RegistrationPortfolioQuestions = 'registrationPortfolioQuestions',
  RegistrationProductOnboarding = 'registrationProductOnboarding',
  RegistrationRoundUps = 'registrationRoundUps',
  RegistrationRoundUpsInterstitial = 'registrationRoundUpsInterstitial',
  RegistrationSpendAddress = 'registrationSpendAddress',
  RegistrationSubscriptionActive = 'registrationSubscriptionActive',
  RegistrationSuccess = 'registrationSuccess',
  RegistrationTwoFactorAuthEnterCode = 'registrationTwoFactorAuthEnterCode',
  TaxFilingContactSupport = 'taxFilingContactSupport',
  TaxFilingGetStarted = 'taxFilingGetStarted',
  TaxFilingLander = 'taxFilingLander',
  TwoFactorAuthEnterCode = 'twoFactorAuthEnterCode',
}
